
export const widgetsToShow = [
    {
        "id": 9,
        "order": 2,
        "name": "Shop by categories",
        "widgetName": "Shop by categories - Dynamic",
        "widgetIdentifier": "",
        "type": "CATEGORIES",
        "subText": "Freshest meats and much more!",
        "iosEnabled": true,
        "androidEnabled": true,
        "webEnabled": true,
        "msiteEnabled": true,
        "layoutName": "short1",
        "status": "ACTIVE",
        "widgetMediaType": "IMAGE",
        "widgetMappings": [
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 1,
                    "cat_name": "Chicken",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                You've never had chicken like this. Raised in a humane environment, farm-fed and free from growth-promoting hormones or harmful antibiotics. One bite and you’ll know what we're talking about.\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/650e6234-c4ca-c9bf-a2b4-b049e99fcc2a/original/1705579455295.png",
                    "slug": "chicken",
                    "meta_desc": "Want to buy chicken without stepping out? Order chicken online and get safe, contactless delivery right to your doorstep. Order Now!",
                    "meta_keyword": "order chicken online, fresh chicken online, buy chicken, chicken",
                    "meta_title": "Chicken Online - Order Fresh Chicken Online At Best Price - Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/efd78703-fe0e-e9f3-c4b7-95833ba8dd35/original/1705579467212.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/f9dea1f6-ab10-0581-a421-1a94ce498926/original/1705579460821.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                You've never had chicken like this. Raised in a humane environment, farm-fed and free from growth-promoting hormones or harmful antibiotics. One bite and you’ll know what we're talking about.",
                    "subtitle": "Chicken",
                    "popular": 1,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/58e5a4d2-4b33-1f2b-cd61-3af345fa14f1/original/1705579471100.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/056a195a-7d71-0d51-a4c4-bea0926dd8da/original/1705579476124.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/6154e150-cb4c-39c3-cc49-263673b22998/original/1705579479722.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/ba4b97f2-5b9d-a88a-0784-7f5e45533648/original/1705579484565.png",
                    "created_at": "2016-04-29T10:59:58.000Z",
                    "updated_at": "2024-04-22T03:39:45.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/0e3d6b1a-fb36-f434-43e1-1e8f5afb7074/original/1705579441855.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/0810be96-88ad-91b7-e4bf-184d9dbcb9a1/original/1705579448441.png",
                    "l0_subtext": "Raised on biosecure farms",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 1,
                    "sub_categories": [
                        {
                            "id": 115,
                            "cat_name": "Curry Cuts_Chicken",
                            "cat_desc": "                                                                                                                                                            <span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Curry Cuts</span>                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/10c5578d-59a0-d719-10ea-1a1e3e854855/original/Chicken_curry_cut_small_264x204.png",
                            "slug": "curry-cuts_chicken",
                            "meta_desc": "Curry Cuts",
                            "meta_keyword": "Curry Cuts",
                            "meta_title": "Curry Cuts",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ac8a8eed-cfa1-9b9f-f10f-c1c7b467e7bb/original/Chicken_curry_cut_small_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/14fe3c6c-7ef7-c9ef-96fc-395b84b8a1ea/original/Chicken_curry_cut_small_264x204.png",
                            "msite_desc": "                                                                                                                                                            <p><span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Curry Cuts</span><br></p>",
                            "subtitle": "Curry Cuts",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/293ad675-73ec-1f4e-1c07-7befc462c15d/original/Chicken_curry_cut_small_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c353c94a-c202-2633-aeba-f1fa5714448f/original/Chicken_curry_cut_small_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/470549a7-e077-280a-90f6-785c3e5b6378/original/Chicken_curry_cut_small_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/250cafa9-1e66-147e-ae7a-43fc8adc6448/original/Chicken_curry_cut_small_264x204.png",
                            "created_at": "2022-05-19T19:23:51.000Z",
                            "updated_at": "2023-06-27T04:48:59.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f6d43eb8-691a-bb7c-5860-d51c46a2de22/original/Chicken_curry_cut_small_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/daad0b7f-a207-f13f-ddff-c34513be0049/original/Chicken_curry_cut_small_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 117,
                            "cat_name": "Boneless & Mince_Chicken",
                            "cat_desc": "                                                                                                                                                                                                                <span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Boneless \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/db65019f-c897-7ee9-4bbf-cf7f7562ea00/original/Chicken_Breast_boneless_264x204_(1).png",
                            "slug": "boneless-and-mince_chicken",
                            "meta_desc": "Boneless & Mince",
                            "meta_keyword": "Boneless & Mince",
                            "meta_title": "Boneless & Mince",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/dce202e2-cb3e-cd7a-addf-19a9c9f2b77d/original/Chicken_Breast_boneless_264x204_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/172ab683-99ce-00e5-9269-7d53fdbedba0/original/Chicken_Breast_boneless_264x204_(1).png",
                            "msite_desc": "                                                                                                                                                                                                                <p><span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Boneless ",
                            "subtitle": "Boneless & Mince",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4a5ed006-10ed-a16e-a4ce-45e78815caeb/original/Chicken_Breast_boneless_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/041c8a84-0b3c-8ff7-b774-a16c87879b41/original/Chicken_Breast_boneless_264x204_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7c20738c-a82f-ae26-2c18-71e81cfe8660/original/Chicken_Breast_boneless_264x204_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c96baafd-3bf2-c390-a0d0-fc14f26236df/original/Chicken_Breast_boneless_264x204_(1).png",
                            "created_at": "2022-05-19T19:25:01.000Z",
                            "updated_at": "2023-06-27T04:53:28.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4df40249-f238-4fd5-2670-f0d2f3c453cf/original/Chicken_Breast_boneless_264x204_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d4ad325c-8d61-6cdd-e73e-148929da62ed/original/Chicken_Breast_boneless_264x204_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 119,
                            "cat_name": "Speciality Cuts_Chicken",
                            "cat_desc": "                                                                                                        <span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Speciality Cuts</span>                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3a83e915-76df-a6d5-022e-b6d1ef1470de/original/Chicken_Whole_Legs_264x204.png",
                            "slug": "speciality-cuts_chicken",
                            "meta_desc": "Speciality Cuts",
                            "meta_keyword": "Speciality Cuts",
                            "meta_title": "Speciality Cuts",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8f744755-f1a3-8573-7f8d-d0b7beb36a88/original/Chicken_Whole_Legs_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0e8fa6f8-2190-87e3-552a-6fc5afc503d7/original/Chicken_Whole_Legs_264x204.png",
                            "msite_desc": "                                                                                                        <p><span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Speciality Cuts</span><br></p>",
                            "subtitle": "Speciality Cuts",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e6175e68-4254-1870-bc02-0341a1434e34/original/Chicken_Whole_Legs_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/df80244a-32c7-9b9c-dd78-7ea39ba98c47/original/Chicken_Whole_Legs_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0e6d2ccc-5344-567f-0934-27146cf54690/original/Chicken_Whole_Legs_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a4b93e74-6f6e-d90d-497c-816eebbb73df/original/Chicken_Whole_Legs_264x204.png",
                            "created_at": "2022-05-19T19:26:18.000Z",
                            "updated_at": "2023-06-27T04:54:31.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/690290fc-d36a-5c10-5f2c-68133eedd32d/original/Chicken_Whole_Legs_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2a04f2c8-75f2-14ee-2993-4cd95ac775e7/original/Chicken_Whole_Legs_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 120,
                            "cat_name": "Offals_Chicken",
                            "cat_desc": "                                                                                                                                                                                                                                                                    <span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Offals</span>\n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/62df3466-2bc5-8d6f-9eaf-4731a8b36182/original/Liver_264x204_(1).png",
                            "slug": "others_chicken",
                            "meta_desc": "Offals",
                            "meta_keyword": "Offals",
                            "meta_title": "Offals",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/32e05a20-721d-215f-afe7-b96c4edab2de/original/Liver_264x204_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/48aa7ee5-e1db-a762-fa09-da211466269e/original/Liver_264x204_(1).png",
                            "msite_desc": "                                                                                                                                                                                                                                                                                                                        <p><span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Offals</span><br></p>",
                            "subtitle": "Offals",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4489adb9-b3e2-6b70-2183-a63d9239d656/original/Liver_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d5019aaf-31e7-6f05-b756-234eb882e13c/original/Liver_264x204_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d9cd15a6-7901-ef56-cda7-597e4923f34e/original/Liver_264x204_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/541ba75a-cd7e-58d0-d229-0647dfed944b/original/Liver_264x204_(1).png",
                            "created_at": "2022-05-19T19:27:20.000Z",
                            "updated_at": "2023-06-27T04:55:45.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/867cd5c4-4bd6-d129-36c6-2aaf2c4c9dd3/original/Liver_264x204_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0e8ac9f5-3ae7-a7fb-ce8d-6680ca78693c/original/Liver_264x204_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 121,
                            "cat_name": "Combos_Chicken",
                            "cat_desc": "                                                                                                        <span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Combos</span>                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d149b703-faed-2895-142c-6c266373df7b/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "slug": "combos_chicken",
                            "meta_desc": "Combos",
                            "meta_keyword": "Combos",
                            "meta_title": "Combos",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4f49380c-8306-a33b-1b99-d9fab0b25af5/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/5e3fd319-efe9-83a5-c382-e985777b3c6c/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "msite_desc": "                                                                                                        <p><span style=\"font-family: docs-Calibri; font-size: 16px; white-space: pre-wrap;\">Combos</span><br></p>",
                            "subtitle": "Combos",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2c8a7008-494b-f2a0-623b-20f3059cea57/original/sample-imgchicken-combo-shot-(264-x-204).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/380c5105-95bc-4a90-b4ab-505b775e41a6/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/89d0879b-e7c4-4708-657c-0f59a7f177b1/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8d9e1fa8-ef51-d543-0984-d4f949d15f4f/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "created_at": "2022-05-19T19:28:22.000Z",
                            "updated_at": "2023-06-27T04:56:51.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8141a27d-4386-1724-dd78-7e227ce08219/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1a1dc683-a21e-9516-1f47-2fca46c6cff6/original/sample-imgchicken-combo-shot-(264-x-204)_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 612,
                            "cat_name": "Premium Cuts_Chicken",
                            "cat_desc": "                                                    Premium Cuts                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/f5af97e9-4f05-f65c-812a-467a8572d1e8/original/1693840343393.png",
                            "slug": "premium-cuts_chicken",
                            "meta_desc": "Premium Cuts",
                            "meta_keyword": "Premium Cuts",
                            "meta_title": "Premium Cuts",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/f7abc03f-9f02-7e46-7922-364ff5c13785/original/1693840336193.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/f789ea3c-008c-8020-586b-64c0e9bf4dca/original/1693840340010.png",
                            "msite_desc": "                                                    <p>Premium Cuts<br></p>",
                            "subtitle": "Premium Cuts",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/d5125c32-76bc-c00e-0b11-5006e66b486f/original/1693840330152.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/6cede561-9d8e-e165-cfa9-b4dc85203ba7/original/1693840326630.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/c06c042c-ec31-c930-4d64-7b6a6a89e847/original/1693840321308.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/7661116c-434a-96f1-eaf8-8d363c311108/original/1693840317227.png",
                            "created_at": "2023-09-04T14:07:13.000Z",
                            "updated_at": "2023-09-04T09:42:37.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/408ef541-fd35-c268-2cdf-2aab26b8c80c/original/1693840351781.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/1b222d6f-0adf-84dd-651d-e67afaaeca98/original/1693840348021.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 836,
                            "cat_name": "Ready-to-cook",
                            "cat_desc": "                                                                                                                                                                                                                                                                                                                        Ready-to-cook                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/bc063e04-12f1-bf52-c36c-aebe8909d620/original/1705413836339.png",
                            "slug": "rtc_new",
                            "meta_desc": "Ready-to-cook",
                            "meta_keyword": "Ready-to-cook",
                            "meta_title": "Ready-to-cook",
                            "status": 1,
                            "parent_id": 1,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/3a22d5ef-0dda-749e-7cd6-342e8146a033/original/1705413851032.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/244796fc-9015-cfe8-7697-e9f60716644a/original/1705413846511.png",
                            "msite_desc": "                                                                                                                                                                                                                                                                                                                        <p>Ready-to-cook<br></p>",
                            "subtitle": "Ready-to-cook",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/591c32f2-f3e4-3fc7-0e13-defdf767e1a8/original/1705413856999.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/54937eab-5ea3-2e0f-3a29-636310ef0fa7/original/1705413862277.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/cf73f817-535d-b754-fc2a-03f3e192a683/original/1705413869129.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/3daa7f10-32b3-9af4-f4d0-b20548239b0f/original/1705413873550.png",
                            "created_at": "2024-01-16T14:04:52.000Z",
                            "updated_at": "2024-02-26T05:38:07.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/4b8837a4-12cd-44a8-9bca-4cd2584eeefc/original/1705413824498.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/7016aadd-86b2-b777-9a02-ec3597711580/original/1705413830822.png",
                            "l0_subtext": "Great deals on fresh meats & more",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 987,
                    "cat_name": "  Ready to cook ",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    Fine cuts of world-class meats, cured in juicy marinades that are handcrafted by master chefs. All natural. Zero preservatives. Delicious tasting. This is truly as good as it gets.                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/94bf383d-18ac-3608-f6e7-81d9f07c51d0/original/1714038096585.png",
                    "slug": "ready-to-cook_-mumbai",
                    "meta_desc": "Looking for good quality and fresh marinated meat online? Licious serves the best quality ready to cook chicken/fish/prawns/mutton marinated using high grade ingredients. Order now!",
                    "meta_keyword": "ready to cook food ready to cook, readytocook, ready to cook chicken, chicken marinade, marinades, ready to cook food online marinated meat",
                    "meta_title": "Buy Marinated Meat | Ready To Cook Meat Online - Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/d66ae4d6-a29a-3d76-3bfe-4950c01d2767/original/1714038104830.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/84376bce-993e-17bb-ccca-66695da51ddd/original/1714038100822.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <p>Fine cuts of world-class meats, cured in juicy marinades that are handcrafted by master chefs. All natural. Zero preservatives. Delicious tasting. This is truly as good as it gets.<br></p>",
                    "subtitle": " Ready to cook",
                    "popular": 1,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/16e6308b-cbe5-3780-b3e1-9d3ecf03408d/original/1714038113227.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/3c4157bb-7acc-445c-8b1f-9d26e17955e2/original/1714038117658.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/35b3cf0b-19d4-117a-328c-d5ca3426fcd5/original/1714038137525.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/a0980039-dbd0-be23-fb83-e4cecd85fb84/original/1714038140172.png",
                    "created_at": "2024-04-25T09:43:07.000Z",
                    "updated_at": "2024-06-13T03:45:28.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/6900b1b4-c40d-9d68-fd8a-88a553dcdaf2/original/1714038083760.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/64ad4ace-847e-6a2c-6eb4-71b126135836/original/1714038089348.png",
                    "l0_subtext": "Freshly marinated meats",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 1,
                    "sub_categories": [
                        {
                            "id": 990,
                            "cat_name": "Crispy_RTC",
                            "cat_desc": "                                                                                                                                                                                                                <span data-sheets-root=\"1\" data-sheets-value=\"{\n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/9bf0fbaf-6087-8b5b-97bd-1ac8bdbd2409/original/1714038994931.png",
                            "slug": "crispy_rtc",
                            "meta_desc": "Crispy",
                            "meta_keyword": "Crispy",
                            "meta_title": "Crispy",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/084ee972-9545-6e57-9f9d-542973d7e7b8/original/1714039000428.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/4f198f42-2994-a65e-a1ce-27f0d437a2fb/original/1714038997647.png",
                            "msite_desc": "                                                                                                                                                                                                                <p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Crispy Snacks",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/5d46e400-80a5-af5b-9ba8-4c67ad58e0c3/original/1714039003116.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/39df70cf-239e-f7ab-b4a0-1ca95fce966f/original/1714039005789.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/449e21b5-2768-d151-70e1-e2269e93aa94/original/1714039008824.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/63411d65-daff-9ea2-a0ce-662765a3a46b/original/1714039011243.png",
                            "created_at": "2024-04-25T09:57:14.000Z",
                            "updated_at": "2024-05-03T00:18:30.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/0381df7a-f879-97bc-5f7d-56e6378d29c9/original/1714038989288.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/a541a418-b391-7e19-e7a7-59890ed96166/original/1714038992504.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 991,
                            "cat_name": "Wings_RTC",
                            "cat_desc": "<span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "cat_img": "https://assets.licious.in/OMS-Category/1ade7281-882c-9fb4-c566-d52b15b4fb13/original/1714039211097.png",
                            "slug": "wings_rtc",
                            "meta_desc": "Wings",
                            "meta_keyword": "Wings",
                            "meta_title": "Wings",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/9067453e-a315-ef8e-7bcb-cd26adcda1e1/original/1714039216686.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/3e493e3b-200f-5d77-20d9-e66a306cc0e6/original/1714039214190.png",
                            "msite_desc": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Wings",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/19c5f378-5d41-be13-6c7b-47e6bca7489c/original/1714039219139.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/91ab663d-d604-f485-e993-e5cb6c07f49b/original/1714039222185.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/239e12b3-db0d-46a9-6fa1-235fcf546a25/original/1714039228292.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/a4b4b085-553f-8776-d8a7-3c1e5d3cc03a/original/1714039234168.png",
                            "created_at": "2024-04-25T10:01:50.000Z",
                            "updated_at": "2024-04-25T10:01:50.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/38d61837-0ec1-c440-ebbd-c3bf1099a727/original/1714039205038.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/9af304aa-7dba-5ae3-69a3-41dc9b42b2d2/original/1714039208497.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 992,
                            "cat_name": "Global Flavours",
                            "cat_desc": "<span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "cat_img": "https://assets.licious.in/OMS-Category/83736c65-864e-f344-9b73-2a4f09a8ecb7/original/1714039596429.png",
                            "slug": "global-flavours",
                            "meta_desc": "Global Flavours",
                            "meta_keyword": "Global Flavours",
                            "meta_title": "Global Flavours",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/2a8c2726-6f41-74d9-6d0c-0f844fa45a60/original/1714039601517.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/dbdda24b-0f66-4cb8-7a84-d51c2b2538a5/original/1714039598799.png",
                            "msite_desc": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Global Flavours",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/cd20d5b6-edbc-0ed3-ff82-1e1dc0da30f2/original/1714039604043.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/4a3cf352-7244-06ac-d2ea-87257114548f/original/1714039606559.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/7c02da93-73b4-4314-784c-b031619c8e07/original/1714039609313.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/d4aff27d-8433-6809-8e4f-4802d63d2b24/original/1714039612304.png",
                            "created_at": "2024-04-25T10:07:09.000Z",
                            "updated_at": "2024-04-25T10:07:09.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/dbc85f7a-33c1-2261-47b3-efd17c67f593/original/1714039591372.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/1c14a8e7-3f36-c75d-264a-22186f711a34/original/1714039593983.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 994,
                            "cat_name": "Kebabs & Tikkas_RTC",
                            "cat_desc": "<span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "cat_img": "https://assets.licious.in/OMS-Category/bf5846c8-39a1-df96-f0c3-23a5fe8b412f/original/1714039930844.png",
                            "slug": "kebabs-and-tikkas_rtc",
                            "meta_desc": "Kebabs & Tikkas",
                            "meta_keyword": "Kebabs & Tikkas",
                            "meta_title": "Kebabs & Tikkas",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/a0d4c098-7055-0a3c-3e09-9a750fe39560/original/1714039935789.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/eb0dde33-b59c-1d7e-1acc-c2974adf8978/original/1714039933232.png",
                            "msite_desc": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Kebabs & Tikkas",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/e881bf30-af89-caba-844c-79309a02bb39/original/1714039939378.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/e0f5de4d-986f-3001-8e50-ce5c3c256d55/original/1714039942594.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/bf1362a4-598f-7922-f6e2-91f10242641c/original/1714039945722.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/f8c905ce-0e4b-cb20-c4e5-0cfc6cc02e3e/original/1714039948347.png",
                            "created_at": "2024-04-25T10:12:50.000Z",
                            "updated_at": "2024-04-25T10:12:50.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/f598ca20-f412-e45c-e3b7-42f25e8ed16f/original/1714039924423.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/22ec9c53-74e7-b56c-a22e-0c133911d778/original/1714039927676.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 996,
                            "cat_name": "Regional Favourites_RTC ",
                            "cat_desc": "                                                    <span data-sheets-root=\"1\" data-sheets-value=\"{\n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/b9c2ff86-52e5-2a24-bd05-df5c90506b37/original/1714040169410.png",
                            "slug": "regional-favourites_rtc",
                            "meta_desc": "Regional Favourites",
                            "meta_keyword": "Regional Favourites",
                            "meta_title": "Regional Favourites",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/7ce86b23-2dae-1541-0a3c-9be71b79a437/original/1714040188306.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/33e7cbde-61fd-5d06-c047-97a296e08930/original/1714040182122.png",
                            "msite_desc": "                                                    <p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Local Favourites",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/0aecfa5b-3352-c3c9-5c5b-c39290edf72c/original/1714040198828.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/551b6d1b-900d-b0a3-1268-6cfbb180036a/original/1714040201535.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/acb59026-b88d-f5c0-df69-6177a301adab/original/1714040240515.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/6cd61bbb-076f-7554-fd67-6e1f5dd9b07d/original/1714040244200.png",
                            "created_at": "2024-04-25T10:18:57.000Z",
                            "updated_at": "2024-04-30T00:36:03.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/d69200a9-a3a0-0539-e72a-790f37826904/original/1714040163210.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/2f020f68-0412-25ff-df74-27f07fdd0a5a/original/1714040166566.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 998,
                            "cat_name": "Biryani_RTC",
                            "cat_desc": "<span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "cat_img": "https://assets.licious.in/OMS-Category/8761168d-e745-9edf-9f70-d0b16e78a79e/original/1714040763927.png",
                            "slug": "biryani_rtc",
                            "meta_desc": "Biryani",
                            "meta_keyword": "Biryani",
                            "meta_title": "Biryani",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/6efa464c-4f55-5181-fc4d-8beda3fc3c74/original/1714040766551.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/3fdb6998-fde0-2e61-b330-aa55573d2182/original/1714040769243.png",
                            "msite_desc": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Biryani",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/3fc190dc-d486-80bb-b9a4-8bd2bad8700d/original/1714040771810.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/839eaa15-46da-e78f-f2fb-f337a0b6a76f/original/1714040777628.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/bf6ebcdb-4896-142f-933c-c5c4ff719861/original/1714040774865.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/ea15487a-051e-3636-b23b-82e66f9ac5ab/original/1714040780296.png",
                            "created_at": "2024-04-25T10:26:34.000Z",
                            "updated_at": "2024-04-25T10:26:34.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/f7fb43c0-d992-1912-3402-28bd96a07787/original/1714040758381.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/a78d2bed-858e-38f3-1971-830a15ac40de/original/1714040761435.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 999,
                            "cat_name": "Mains_RTC",
                            "cat_desc": "                                                    <span data-sheets-root=\"1\" data-sheets-value=\"{\n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/04fcd764-aad2-53df-c27b-2b5e210a1d88/original/1714040952448.png",
                            "slug": "mains_rtc",
                            "meta_desc": "CURRY",
                            "meta_keyword": "CURRY",
                            "meta_title": "CURRY",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/6a90e977-5124-f3ce-e245-0e5d64a8c0d1/original/1714040957822.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/00ddeddd-0d2b-7ac1-a953-14eed0a3cd14/original/1714040955606.png",
                            "msite_desc": "                                                    <p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Curries",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/3b8e1425-0767-1827-8cfa-00a49e3cd074/original/1714040960188.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/3de52b7a-16c5-e010-a8d7-008c28d36a78/original/1714040962565.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/80ed66ba-59f5-4220-78af-054d6d5b04cb/original/1714040965144.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/f4e3bd4d-047f-586a-5d3e-26cbbb944929/original/1714040968016.png",
                            "created_at": "2024-04-25T10:29:49.000Z",
                            "updated_at": "2024-04-30T00:36:39.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/2bfe6cdb-9c2e-00c7-7edf-09301e3428e6/original/1714040947621.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/62e96a0d-d1de-69c6-c256-e153d15740de/original/1714040950089.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 1006,
                            "cat_name": "Burger Patties_RTC",
                            "cat_desc": "                                                    Burger Patties                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/c2a38823-8dd0-0c32-7dbd-0b280db2bb1b/original/1714646403537.png",
                            "slug": "burger-patties_rtc",
                            "meta_desc": "Burger Patties",
                            "meta_keyword": "Burger Patties",
                            "meta_title": "Burger Patties",
                            "status": 1,
                            "parent_id": 987,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/43edd5a2-2d2e-50e6-7265-25509aabf169/original/1714646408972.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/64a58b90-c240-c4bd-8f03-5aae9d1019ca/original/1714646406653.png",
                            "msite_desc": "                                                    <p>Burger Patties<br></p>",
                            "subtitle": "Burger Cutlets",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/352133ff-2ef9-31bf-a319-3fbbdb54cf4f/original/1714646411500.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/623763b3-c3ba-5f56-82dd-f56abd0b3d2a/original/1714646413370.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/9d9877f6-667d-b1a2-da8d-d13ed78a48a3/original/1714646415402.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/24674aa8-704a-56e1-9765-453113b9c722/original/1714646421363.png",
                            "created_at": "2024-05-02T10:40:40.000Z",
                            "updated_at": "2024-06-13T03:44:41.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/74973cff-16d2-8710-25ed-60c5815e55ba/original/1714646398650.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/714a15a6-ed2f-13cd-67ba-09ea59395a44/original/1714646400656.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 1052,
                    "cat_name": " Fish & Seafood",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                Fish \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/0bd586d4-a841-9a78-8232-00b5cff1da90/original/1715753763290.png",
                    "slug": "fish-and-seafood-4ae7e86c-3406-4690-a7a3-0e5368ab6e74",
                    "meta_desc": "Fish & SeaFood",
                    "meta_keyword": "Fish & SeaFood",
                    "meta_title": "Fish & SeaFood",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/37b0d9df-4474-1c4e-ace3-d36dfb26a772/original/1715753771878.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/2ce8fd5a-9a6f-89b9-ffde-ed405e929499/original/1715753767038.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                <p>Fish ",
                    "subtitle": "Fish & Seafood",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/b2e90b80-b786-a763-a2d6-2fb20ac48dac/original/1715753777065.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/fc475d24-0abd-f3fb-e755-3bc26ff60d71/original/1715753779886.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/e03be57c-a41f-04a1-eb2a-87c3a7342c29/original/1715753782743.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/1ce6b36f-299a-9bf2-8a77-03d279a1fa8d/original/1715753785832.png",
                    "created_at": "2024-05-15T06:17:00.000Z",
                    "updated_at": "2024-06-10T06:19:00.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/e19b032c-78c1-1a25-1cdc-134543e8e6bc/original/1715753753100.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/e3c0d247-8d9b-ce37-fa2c-dd879e789b10/original/1715753758053.png",
                    "l0_subtext": "Fish & SeaFood",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 1,
                    "sub_categories": [
                        {
                            "id": 1054,
                            "cat_name": " Store_Fish & seafood Exp-BLR",
                            "cat_desc": "                                                                                                                                                                                                                                                                    Store                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/09539cd5-1fed-5947-f85c-2de794e6b335/original/1716396522232.png",
                            "slug": "store_fish-and-seafood-exp-blr",
                            "meta_desc": "Store",
                            "meta_keyword": "Store",
                            "meta_title": "Store",
                            "status": 1,
                            "parent_id": 1052,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/6a28980a-4434-baa1-c9ed-f4daa6d4c95d/original/1716396548585.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/a19ffbe6-c9cc-888b-01d8-306c21cc7aa1/original/1716396523355.png",
                            "msite_desc": "                                                                                                                                                                                                                                                                    <p>Store<br></p>",
                            "subtitle": "Daily Staples",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/ef43a568-d606-0e50-0d52-fc516d2ce567/original/1716396551174.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/6786e40d-d0f3-7480-a60a-c065c0bbd3e5/original/1716396543998.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/eef6cb64-6a41-1188-9479-b5ce7036c847/original/1716396546116.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/0299557b-b712-31d8-3cdc-fabd174ccd09/original/1716396554977.png",
                            "created_at": "2024-05-15T06:20:41.000Z",
                            "updated_at": "2024-06-13T10:54:36.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/3e79fd6c-a027-b1c1-bb21-c100a984eb22/original/1716396532832.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/55654f24-0c3c-470c-7a1c-6aa1b46e7a4a/original/1716396536248.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 1055,
                            "cat_name": " Freshwater  ",
                            "cat_desc": "                                                    Freshwater                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/affd10d1-776b-5630-db98-ff9a2e815ed0/original/1715754227015.png",
                            "slug": "freshwater_fish-and-seafood-exp-blr",
                            "meta_desc": "Freshwater",
                            "meta_keyword": "Freshwater",
                            "meta_title": "Freshwater",
                            "status": 1,
                            "parent_id": 1052,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/d1ffe559-7325-8c66-21df-d0a162cb41ea/original/1715754233629.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/c24d09da-6b05-00f2-9b1d-c29f1cd58350/original/1715754229321.png",
                            "msite_desc": "                                                    <p>Freshwater<br></p>",
                            "subtitle": "Freshwater",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/109e156f-6401-dbea-5628-2cacb861c6b6/original/1715754235959.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/5a5bd874-8f23-68ec-aad2-939ca4a2dc2c/original/1715754238398.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/c6ea211d-80a0-a43b-a819-76d2957d4d13/original/1715754240661.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/e9878047-b07d-c7f2-979c-45f8cc799688/original/1715754243343.png",
                            "created_at": "2024-05-15T06:24:18.000Z",
                            "updated_at": "2024-06-13T10:54:36.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/bbd41baa-1452-87f8-3bc7-bd0bb3a79892/original/1715754222484.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/518c13bd-4370-766f-83ac-60a0f2faf958/original/1715754224827.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [
                                {
                                    "cat_desc": "<div class=\"form-group\" style=\"color: rgb(52, 73, 94); font-family: ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/03ff9368-76c8-a1d7-11ea-27411215efb3/original/1715754774754.png",
                                    "cat_name": "Rohu & Catla_BLR Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/1ecd94d0-2085-bbdb-95b8-69874a8f5b5b/original/1715754777661.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/bcc9b4ce-bc77-cdb9-f896-0fe6d0bc46b7/original/1715754780398.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/8da11338-b395-4439-9070-559864f45d20/original/1715754772423.png",
                                    "created_at": "2024-05-15T06:33:54.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1057,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Rohu & Catla_BLR Exp",
                                    "meta_keyword": "Rohu & Catla_BLR Exp",
                                    "meta_title": "Rohu & Catla_BLR Exp",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/7ad28e17-a828-d35b-d1ef-121367e41467/original/1715754782628.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/21a3790b-a9a1-9109-eb5b-f9ff1a1cc2b9/original/1715754784804.png",
                                    "msite_desc": "<p><div class=\"form-group\" style=\"box-sizing: border-box; margin-bottom: 15px; margin-left: -15px; margin-right: -15px; color: rgb(52, 73, 94); font-family: ",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "rohu-and-catla_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Rohu & Catla",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:33:54.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/744ae2ce-de5e-7e11-c6e5-c855ad982e1f/original/1715754787163.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/e91ec935-97d8-fd6a-b051-6861164a7724/original/1715754789671.png"
                                },
                                {
                                    "cat_desc": "Basa                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/19b6afb9-8720-7247-821d-5a06253a86f1/original/1715755046787.png",
                                    "cat_name": "Basa_Exp BLR",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/36d9206c-822c-a347-a6e5-85a2a6dc3802/original/1715755048861.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/158481ce-5e34-b7b2-537d-8b6c6c7171e4/original/1715755051110.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/59e33082-f3e2-5357-d97f-3797132bd8e1/original/1715755044559.png",
                                    "created_at": "2024-05-15T06:38:01.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1058,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Basa",
                                    "meta_keyword": "Basa",
                                    "meta_title": "Basa",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/558b3fa3-14f4-7e56-6807-f4b1cdeda86a/original/1715755053527.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/1f485943-ee98-13eb-327d-1ed3d57548ae/original/1715755056241.png",
                                    "msite_desc": "<p>Basa<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "basa_exp-blr",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Basa",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:38:01.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/3c0b3292-ddb2-ed87-3c43-f2358d4dd8b9/original/1715755059190.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/38977e64-a14b-03aa-33ee-27bfc98efc48/original/1715755061547.png"
                                },
                                {
                                    "cat_desc": "River Sol/Murrel                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/42aa19e0-7747-3026-8b01-d7158829c7c0/original/1715755157071.png",
                                    "cat_name": "River Sol/Murrel_BLR -EXP",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/51c07098-769d-7c4a-c0f1-a86b9616303e/original/1715755159207.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/e129f7ed-31fa-7e38-2354-7901a465cd22/original/1715755161288.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/eda8ede5-f1c7-589e-b7c7-7b25765412bd/original/1715755154765.png",
                                    "created_at": "2024-05-15T06:39:53.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1059,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "River Sol/Murrel",
                                    "meta_keyword": "River Sol/Murrel",
                                    "meta_title": "River Sol/Murrel",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/577ff752-02ff-0aec-9353-53d1e62a6de2/original/1715755163960.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/2d62670d-1ff2-11a3-2c6d-75596310ff5e/original/1715755166674.png",
                                    "msite_desc": "<p>River Sol/Murrel<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "river-solmurrel_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "River Sol/Murrel",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:39:53.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/39f0e697-4d94-8fcb-f870-ede7450ecfc1/original/1715755168875.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/497511ed-78c2-aa63-54db-2f2cbde957d3/original/1715755170981.png"
                                },
                                {
                                    "cat_desc": "Pabda ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/f2a990db-7cf7-79f9-b557-75e34d6a2a80/original/1715755254905.png",
                                    "cat_name": "Pabda & Parshe_Blr-EXP",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/fe26c80f-22fa-436b-2b59-0624b10e9b80/original/1715755258211.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/8964c971-f2ba-fef2-5247-c1086c879bbb/original/1715755260928.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/b3be5e3c-f4f2-55c8-67a6-201b0ca4dd41/original/1715755252527.png",
                                    "created_at": "2024-05-15T06:41:28.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1060,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Pabda & Parshe",
                                    "meta_keyword": "Pabda & Parshe",
                                    "meta_title": "Pabda & Parshe",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/391d8f05-1995-487d-d01a-0237d484a5d5/original/1715755263304.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/ae99c47d-cd69-087c-c774-5446f0d1ce52/original/1715755265887.png",
                                    "msite_desc": "<p>Pabda ",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "pabda-and-parshe_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Pabda & Parshe",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:41:28.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/648a51ac-17ae-d2a1-6f98-bd3674bfe53e/original/1715755268786.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/425c6310-5adb-6189-baad-611d05927e41/original/1715755272206.png"
                                },
                                {
                                    "cat_desc": "Tilapia                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/8adde139-adb9-c1ef-e571-44f8f932320c/original/1715755360018.png",
                                    "cat_name": "Tilapia_Blr-Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/dfb0b862-f3b0-ddb2-dc50-93f8540083b4/original/1715755362402.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/9e939cac-5d0e-1a22-3bc2-5c71b2d5f027/original/1715755364769.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/5dcf3b16-ba13-8fbe-30fc-80a22520f134/original/1715755357723.png",
                                    "created_at": "2024-05-15T06:43:12.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1061,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Tilapia",
                                    "meta_keyword": "Tilapia",
                                    "meta_title": "Tilapia",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/00f4f3a7-9939-3394-ade4-8ce0628ebd01/original/1715755367338.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/03383cf6-5383-b213-698b-732da1692130/original/1715755369889.png",
                                    "msite_desc": "<p>Tilapia<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "tilapia_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Tilapia",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:43:12.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/7f422fdf-ca27-99f3-a7ae-71da955d605b/original/1715755372474.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/bb4714bb-9c28-30aa-0909-62a8dc7349ec/original/1715755374917.png"
                                },
                                {
                                    "cat_desc": "Roopchand                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/acd00c87-d81f-e0ff-96ba-c3050509d94a/original/1715755510565.png",
                                    "cat_name": "Roopchand-Blr-exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/82674267-20ff-81c7-2456-684c638fec3c/original/1715755512960.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/8e5c6933-fadf-f3b8-3111-4fd6339e20a0/original/1715755515765.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/cbd6026f-4cf0-a583-88c5-5760323aea46/original/1715755507811.png",
                                    "created_at": "2024-05-15T06:45:42.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1062,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Roopchand",
                                    "meta_keyword": "Roopchand",
                                    "meta_title": "Roopchand",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/917d4cf2-0a1b-e9a2-f4c8-0d8e51c0887b/original/1715755518440.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/2029233b-1fd1-c636-4925-0fdd3228e036/original/1715755521039.png",
                                    "msite_desc": "<p>Roopchand<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "roopchand-blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Roopchand",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:45:42.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/84002ac5-2a3d-3e64-a55a-5266bf5dd2d0/original/1715755523461.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/4527250c-ee5a-fc53-5fcf-1e81da8a253f/original/1715755526297.png"
                                },
                                {
                                    "cat_desc": "Sea Bass_Blr-exp                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/b6c0dfc2-a089-ee1f-6274-3891ed684a21/original/1715755595590.png",
                                    "cat_name": "Sea Bass_Blr-exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/279c0fd2-9a61-1e60-6c2f-7ec00f0133f7/original/1715755598166.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/0e6e6ab3-5bbf-51bf-e600-56d9e04533b1/original/1715755600991.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/e16a6685-1ea3-13bb-0bc9-492bb554ddb5/original/1715755593177.png",
                                    "created_at": "2024-05-15T06:47:07.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1063,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Sea Bass_Blr-exp",
                                    "meta_keyword": "Sea Bass_Blr-exp",
                                    "meta_title": "Sea Bass_Blr-exp",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/d5cb3997-fe4a-d330-53c3-f176b3ce3b14/original/1715755603557.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/8fa94ed7-c75a-0c57-e056-f5054277957a/original/1715755606295.png",
                                    "msite_desc": "<p>Sea Bass_Blr-exp<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "sea-bass_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Sea Bass",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:47:07.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/004f631b-84ae-93c9-e897-4ed52e1e6291/original/1715755608709.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/5e4c9603-ebc7-60dc-f61d-9328d8723c5a/original/1715755611296.png"
                                },
                                {
                                    "cat_desc": "Aar/Singhara                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/c5ea6238-6719-d535-3de3-bc9698c2e31e/original/1715755685761.png",
                                    "cat_name": "Aar/Singhara_ Blr-Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/2db3aa73-1df8-220e-4abe-6b4fe87c8b3f/original/1715755688080.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/5cbfd039-e730-ddc7-fc13-7f006cdb7a17/original/1715755690728.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/4bd736fc-7659-9076-dd8e-a137be46c0c4/original/1715755683367.png",
                                    "created_at": "2024-05-15T06:48:38.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1064,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Aar/Singhara",
                                    "meta_keyword": "Aar/Singhara",
                                    "meta_title": "Aar/Singhara",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/e0b84493-7739-481e-834c-6e7073d43b1e/original/1715755693281.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/e6c50860-3106-115d-5f48-ede435e65c25/original/1715755695644.png",
                                    "msite_desc": "<p>Aar/Singhara<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "aarsinghara_-blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Aar/Singhara",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:48:38.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/464b50c2-c658-74e7-425b-fcb46e791017/original/1715755698047.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/63ccfede-bbea-8377-dedc-555d7dc4fab7/original/1715755700295.png"
                                },
                                {
                                    "cat_desc": "Exotic Catch                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/a1701fc2-89a9-d8e2-efd4-d7ce21e039ea/original/1715755777810.png",
                                    "cat_name": "Exotic Catch_Blr-Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/850476b8-1730-f091-3598-f29b13d66858/original/1715755780254.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/9652e29d-65e8-e22b-a130-8212c8791289/original/1715755782412.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/fd899588-7d9d-60c5-1dc1-f96462abf268/original/1715755772023.png",
                                    "created_at": "2024-05-15T06:50:08.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1065,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Exotic Catch",
                                    "meta_keyword": "Exotic Catch",
                                    "meta_title": "Exotic Catch",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/cefcd770-082d-3ef4-7db4-dd6b85a299e1/original/1715755784956.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/57ed0f03-6287-5c54-953c-e70859ffb639/original/1715755787238.png",
                                    "msite_desc": "<p>Exotic Catch<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "exotic-catch_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Exotic Catch",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:50:08.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/9e93ccff-c86a-e181-b54c-a580b3836c7c/original/1715755789653.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/88a7e135-2150-b11c-a8ec-b3c03a8207f5/original/1715755791714.png"
                                },
                                {
                                    "cat_desc": "Freshwater Prawns                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/54fdcffe-0f6e-9336-412b-c4567b7113b0/original/1715755856777.png",
                                    "cat_name": "Freshwater Prawns_Blr-Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/6f640ba0-1756-737f-4ff7-cd935e0b7978/original/1715755854049.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/784d969a-e421-86ed-f7a0-9942f85ab0fa/original/1715755858881.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/73c77cda-d5a5-f639-4515-107e70d0d6a6/original/1715755851774.png",
                                    "created_at": "2024-05-15T06:51:21.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1066,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Freshwater Prawns",
                                    "meta_keyword": "Freshwater Prawns",
                                    "meta_title": "Freshwater Prawns",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/21b60ef8-bbb3-c2fe-be8e-94d5ec1d4a38/original/1715755861355.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/b1a6d7ed-65dc-5316-5594-0227fe3e1d04/original/1715755863781.png",
                                    "msite_desc": "<p>Freshwater Prawns<br></p>",
                                    "order": 1,
                                    "parent_id": 1055,
                                    "popular": 0,
                                    "slug": "freshwater-prawns_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Freshwater Prawns",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T06:51:21.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/9334f914-20d1-acf4-e9d5-978dc03d90b8/original/1715755865911.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/0787c6ed-76c6-80af-458a-97524e15b073/original/1715755868136.png"
                                }
                            ],
                            "filter_id": 222
                        },
                        {
                            "id": 1056,
                            "cat_name": "  Seawater ",
                            "cat_desc": "                                                                                                        Seawater                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/fc7363d5-e7e1-0f96-5007-dae11f3c27fd/original/1715754333405.png",
                            "slug": "seawater_fish-and-seafood-exp-blr",
                            "meta_desc": "Seawater",
                            "meta_keyword": "Seawater",
                            "meta_title": "Seawater",
                            "status": 1,
                            "parent_id": 1052,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/dfc615b8-23cb-c870-4e40-e8de27fcceb0/original/1715754338340.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/82379faf-db84-6bb6-118a-7c82ec29af00/original/1715754335699.png",
                            "msite_desc": "                                                                                                        <p>Seawater<br></p>",
                            "subtitle": "Seawater",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/25627a86-e5fd-29bc-5729-268250d56c19/original/1715754340644.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/218f696d-d447-8e48-9cb4-076f0c4d23f2/original/1715754343779.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/43efc36e-909f-3d72-8a7e-2b433906b5cb/original/1715754346211.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/7492065b-f848-e810-6246-6de3ebef8aa0/original/1715754349226.png",
                            "created_at": "2024-05-15T06:26:04.000Z",
                            "updated_at": "2024-06-13T10:54:36.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/9b9175ea-cd01-ac92-8bb6-627ef7629efd/original/1715754328746.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/f977a6a7-34c9-bb5c-825a-5a83f3a08403/original/1715754331041.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 1,
                            "sub_categories": [
                                {
                                    "cat_desc": "Seer                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/ed242760-b32a-9f76-2504-7d293480171c/original/1715756971163.png",
                                    "cat_name": "Seer_Ble-exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/dea0f709-c529-8564-469a-f7ad3d172bcd/original/1715756973668.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/82877ffb-6933-ea3c-766f-46f63c47ef9e/original/1715756975839.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/e7f9c747-b415-ffda-bf61-d89a33b1bc71/original/1715756968743.png",
                                    "created_at": "2024-05-15T07:12:44.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1067,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Seer",
                                    "meta_keyword": "Seer",
                                    "meta_title": "Seer",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/32fde751-1b8a-85d0-1a4a-696e7e99dee1/original/1715756978296.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/c6788c87-354b-45de-e37c-2e98fa8bcdad/original/1715756980763.png",
                                    "msite_desc": "<p>Seer<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "seer_ble-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Seer",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:12:44.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/778f8f85-0e8b-d5e8-77ad-377839117970/original/1715756983144.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/6c4a75e6-8e8c-9e08-5fa4-2c7f7bd4ebe8/original/1715756985577.png"
                                },
                                {
                                    "cat_desc": "                                                                                                        Pomfrets-Blr-EXP                                                \n                                                \n                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/afcfc90f-cb84-23a2-34c7-b59b1a973b8b/original/1715757247576.png",
                                    "cat_name": "Pomfrets-Blr-EXP",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/044f7106-2c8b-6e99-d306-0f8cac07f9c1/original/1715757250199.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/810ba5ef-33d6-265f-476d-d99883799b2f/original/1715757252597.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/86eacfe0-5bd1-ce3d-133f-0851225f79c5/original/1715757244357.png",
                                    "created_at": "2024-05-15T07:14:53.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1068,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Pomfrets-Blr-EXP",
                                    "meta_keyword": "Pomfrets-Blr-EXP",
                                    "meta_title": "Pomfrets-Blr-EXP",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/dbd07872-01f2-cfff-b33b-c7b3fa609d97/original/1715757255003.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/91790d14-c3f5-79c5-76d7-f03bd02fabf4/original/1715757272905.png",
                                    "msite_desc": "                                                                                                        <p>Pomfrets-Blr-EXP<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "pomfrets-blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Pomfret",
                                    "theme_data": null,
                                    "updated_at": "2024-05-23T05:57:12.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/e76f3e59-d869-e1c1-94b2-684102145935/original/1715757259611.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/47f26424-7a2b-8418-0a73-fea3a9dfbe6b/original/1715757262075.png"
                                },
                                {
                                    "cat_desc": "                                                                                                        Salmons                                                \n                                                \n                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/b71d1821-5497-52d6-d752-99819f20202b/original/1715757368874.png",
                                    "cat_name": " Salmons_Blr_Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/bbbb44c8-19ba-98ce-e367-3fe4b74346bc/original/1715757371537.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/1257ec88-70f7-1f2f-8fad-63c7f1b4b578/original/1715757374129.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/e38496ae-480f-b1d1-e72a-d9136f441482/original/1715757366584.png",
                                    "created_at": "2024-05-15T07:16:43.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1069,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Salmons",
                                    "meta_keyword": "Salmons",
                                    "meta_title": "Salmons",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/9a179b5f-7f65-42ef-1cfb-229a89505a61/original/1715757376728.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/a1540c1f-e8aa-bfb5-81b5-1c570e93928f/original/1715757379510.png",
                                    "msite_desc": "                                                                                                        <p>Salmons<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "salmons_blr_exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Salmon",
                                    "theme_data": null,
                                    "updated_at": "2024-05-23T05:56:58.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/a278f6e5-f757-c746-2399-c92609c3b497/original/1715757382201.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/8cd323b0-6f1e-d2fe-5ac4-5d702d156b82/original/1715757384878.png"
                                },
                                {
                                    "cat_desc": "                                                    Ancovy \n                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/e3c183c2-8897-0a9c-c873-4714a2a1ab6e/original/1715757466268.png",
                                    "cat_name": "Ancovy & Sardine-Blr_EXP",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/46edb7d6-3c50-06e2-e0a8-c2d972a2f581/original/1715757468661.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/81a0f034-3953-465a-0176-da58b76d33a8/original/1715757471180.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/fec33f79-ffa6-1ab3-16a8-7e23c588a36b/original/1715757459649.png",
                                    "created_at": "2024-05-15T07:18:20.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1070,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Ancovy & Sardine",
                                    "meta_keyword": "Ancovy & Sardine",
                                    "meta_title": "Ancovy & Sardine",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/c8237901-6782-2e04-47f0-c2906a19f6d9/original/1715757473545.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/19a03ce2-1f61-f6fa-f8ea-63755123ad13/original/1715757476402.png",
                                    "msite_desc": "                                                    <p>Ancovy ",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "ancovy-and-sardine-blr_exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Anchovy & Sardine",
                                    "theme_data": null,
                                    "updated_at": "2024-05-23T05:53:36.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/ad3dbc69-4082-b081-a145-ed68f140cf60/original/1715757479507.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/40f38605-3742-21e1-8e3f-2ece24fcf256/original/1715757482342.png"
                                },
                                {
                                    "cat_desc": "Mackerel                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/ea46ec8b-2165-8b8d-4339-4a79f1d0a1e5/original/1715757586130.png",
                                    "cat_name": "Mackerel_Blr_Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/a97fdcf6-0432-94b3-242e-89bf1a71f88c/original/1715757588923.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/e9639c3a-7e9b-f799-cfa5-f3c5013988e5/original/1715757591556.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/206dfe39-143a-0c1f-2f89-983e33ffbfc2/original/1715757583188.png",
                                    "created_at": "2024-05-15T07:20:21.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1071,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Mackerel",
                                    "meta_keyword": "Mackerel",
                                    "meta_title": "Mackerel",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/df220542-1793-dd43-ecc5-e35f96a68d2b/original/1715757594189.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/40ce75ff-2dbb-02e5-530c-cbaf7dc8caaa/original/1715757596674.png",
                                    "msite_desc": "<p>Mackerel<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "mackerel_blr_exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Mackerel",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:20:21.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/cef28dff-04f7-845c-578e-80fb7a204390/original/1715757599610.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/68041e27-7aef-0549-0433-e46cca2c339a/original/1715757602502.png"
                                },
                                {
                                    "cat_desc": "Bombay Duck-Blr_EXP                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/96f62473-eba3-21fb-f5cb-279e5ec1ce3e/original/1715757676541.png",
                                    "cat_name": "Bombay Duck-Blr_EXP",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/5001f0d7-2159-4160-54ad-60f7e4d3c64b/original/1715757679131.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/5b2076d3-000f-9572-85fe-cb8d1420b7d3/original/1715757681600.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/12bb9e06-81d5-9aac-bac8-933afb571e37/original/1715757674072.png",
                                    "created_at": "2024-05-15T07:25:54.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1072,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Bombay Duck-Blr_EXP",
                                    "meta_keyword": "Bombay Duck-Blr_EXP",
                                    "meta_title": "Bombay Duck-Blr_EXP",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/06264a7d-0a26-250a-5c5f-483a17d677b5/original/1715757684494.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/f3ed5743-c2b5-2920-f28c-6ea8b205b5fe/original/1715757689475.png",
                                    "msite_desc": "<p>Bombay Duck-Blr_EXP<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "bombay-duck-blr_exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Bombay Duck",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:25:54.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/5dd2eda6-e37b-f6ac-c740-fb9aaa70d5c1/original/1715757692814.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/2a1ab5d7-177b-c0a8-d3fe-6a555d88bd12/original/1715757695956.png"
                                },
                                {
                                    "cat_desc": "                                                    Tuna\n                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/7b1130eb-8fca-43d3-1370-0b181be31022/original/1715758042473.png",
                                    "cat_name": "Tuna_Blr EXp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/9bb11685-91ba-2923-0d83-0e1ca2e6f7ef/original/1715758045212.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/35874a14-becc-b583-fb69-741d7970a4d0/original/1715758047682.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/e8162d4b-5e7f-6f23-062e-862cd95fd83a/original/1715758039790.png",
                                    "created_at": "2024-05-15T07:27:52.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1073,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Tuna",
                                    "meta_keyword": "Tuna",
                                    "meta_title": "Tuna",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/2037c7e8-31a2-7885-5df7-aeb1e8741dc3/original/1715758050444.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/f379f63d-4b9d-d9a9-d03d-5cbb405d8d5a/original/1715758052953.png",
                                    "msite_desc": "                                                    <p>Tuna<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "tuna_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Tuna",
                                    "theme_data": null,
                                    "updated_at": "2024-05-22T11:42:37.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/16fdde34-2b7d-7355-e9cf-b7d008dab831/original/1715758055652.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/ade4c7e1-bf5b-4dce-d851-a93a31261aa0/original/1715758058225.png"
                                },
                                {
                                    "cat_desc": "Lady Fish_Blr Exp                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/b7afedcb-b46c-292e-4603-34f9c1b110f6/original/1715758136879.png",
                                    "cat_name": "Lady Fish_Blr Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/7c842acd-0866-69b7-2041-cad878976325/original/1715758139446.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/0913f6a0-45bb-cad1-d6c4-b99d16ddef79/original/1715758141871.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/ffe1674b-78d7-a655-1947-197a3addfc56/original/1715758134208.png",
                                    "created_at": "2024-05-15T07:29:26.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1074,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Lady Fish_Blr Exp",
                                    "meta_keyword": "Lady Fish_Blr Exp",
                                    "meta_title": "Lady Fish_Blr Exp",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/0d60e701-739e-9d5b-556a-99013854c90a/original/1715758144342.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/727878f5-f44e-f647-7aca-55b429b1c47a/original/1715758146841.png",
                                    "msite_desc": "<p>Lady Fish_Blr Exp<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "lady-fish_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Lady Fish",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:29:26.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/b9d28f08-3844-6b0e-725b-38f9c3dc6298/original/1715758149283.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/ef62be9a-9c9a-1ba7-4c9e-150720b4fce7/original/1715758152094.png"
                                },
                                {
                                    "cat_desc": "Pink Perch-Blr_Exp                                                ",
                                    "cat_img": "https://assets.licious.in/OMS-Category/c7b6e636-6b7d-8b43-e7c9-ae3f33787d31/original/1715758213973.png",
                                    "cat_name": "Pink Perch-Blr_Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/2f9119fc-a2d1-e0aa-dd39-b0663df4db41/original/1715758216483.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/289f2afe-cd8a-2ecb-0c11-43ee81f2893d/original/1715758219000.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/038a23e8-4d2d-5ffe-3fb9-5d7b8de75564/original/1715758211897.png",
                                    "created_at": "2024-05-15T07:30:45.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1075,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Pink Perch-Blr_Exp",
                                    "meta_keyword": "Pink Perch-Blr_Exp",
                                    "meta_title": "Pink Perch-Blr_Exp",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/15122c15-7e83-3352-8cbb-569dc8895e10/original/1715758221406.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/ca8c5ec5-f764-fff2-9f68-41a44b46075d/original/1715758223994.png",
                                    "msite_desc": "<p>Pink Perch-Blr_Exp<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "pink-perch-blr_exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Pink Perch",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:30:45.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/7f7524c5-9490-f6bc-4580-536625b612b7/original/1715758226922.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/5cd111f1-df66-8a5e-dfeb-0d0beb1afb92/original/1715758229828.png"
                                },
                                {
                                    "cat_desc": "Exotic Catch",
                                    "cat_img": "https://assets.licious.in/OMS-Category/0ba91367-33a3-78c6-b665-5dd6a6871c80/original/1715758356600.png",
                                    "cat_name": "Exotic Catch Sewater _ Blr-Exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/9b9d43e6-0740-dbb1-1601-20fc74617ed2/original/1715758359057.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/774fac78-6308-9c01-47c1-75c97f636b21/original/1715758361899.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/235a294c-0e39-8e52-fd3c-3db5c646f910/original/1715758354036.png",
                                    "created_at": "2024-05-15T07:33:08.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1076,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Exotic Catch",
                                    "meta_keyword": "Exotic Catch",
                                    "meta_title": "Exotic Catch",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/cf737f72-f6fe-6841-3845-6b9589fbfffc/original/1715758364539.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/69f4868a-0237-9be8-6954-168729798e95/original/1715758367381.png",
                                    "msite_desc": "<p>Exotic Catch<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "exotic-catch-sewater-_-blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Exotic Catch",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:33:08.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/543f469c-abe3-a97b-4d29-d4befee572e0/original/1715758369864.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/523e9ce0-f8ab-2c26-762a-759a39ddda79/original/1715758372496.png"
                                },
                                {
                                    "cat_desc": "Seawater Prawns",
                                    "cat_img": "https://assets.licious.in/OMS-Category/9114142d-c884-4096-943e-7100b76e82fc/original/1715758454848.png",
                                    "cat_name": "Seawater Prawns _Blr -exp",
                                    "cat_tile_img": "https://assets.licious.in/OMS-Category/40dafc83-f443-d98e-c8c1-06f9dad128c1/original/1715758457460.png",
                                    "cat_web_img": "https://assets.licious.in/OMS-Category/0b2d1c15-9894-c330-bfb1-da5c42fa0e99/original/1715758459988.png",
                                    "category_nav_page_img": "noImage",
                                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/c632f19e-5156-6ee9-3a77-cd4a6eed9416/original/1715758452231.png",
                                    "created_at": "2024-05-15T07:34:45.000Z",
                                    "display_type": "DEFAULT",
                                    "filter_id": 223,
                                    "id": 1077,
                                    "is_old_flow": 1,
                                    "is_tree_flow": 1,
                                    "l0_subtext": "",
                                    "meta_desc": "Seawater Prawns",
                                    "meta_keyword": "Seawater Prawns",
                                    "meta_title": "Seawater Prawns",
                                    "mobile_icon": "https://assets.licious.in/OMS-Category/54202055-b6af-c3b4-26c9-0074e2d370b6/original/1715758462259.png",
                                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/419effd6-20ab-1857-71b3-f7c8d32ec66b/original/1715758464554.png",
                                    "msite_desc": "<p>Seawater Prawns<br></p>",
                                    "order": 1,
                                    "parent_id": 1056,
                                    "popular": 0,
                                    "slug": "seawater-prawns-_blr-exp",
                                    "status": 1,
                                    "sub_categories": [],
                                    "subtitle": "Seawater Prawns",
                                    "theme_data": null,
                                    "updated_at": "2024-05-15T07:34:45.000Z",
                                    "web_icon": "https://assets.licious.in/OMS-Category/f3ebf70f-76df-36f9-5979-af1853525edc/original/1715758467253.png",
                                    "web_icon_active": "https://assets.licious.in/OMS-Category/8f8773c8-be67-514c-074a-2df8ce1babd3/original/1715758469929.png"
                                }
                            ],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 2,
                    "cat_name": "Mutton ",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            This is no ordinary meat. All our lambs and goats have been farm-fed and raised with care. We remove excess fat and offal to give you more meat per kg. Taste it and you can’t go back.\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/657d6f9d-2d9c-5275-91d3-8d37f94cf6e3/original/Mutton_(1)_(1).png",
                    "slug": "red-meat",
                    "meta_desc": "Want to buy fresh mutton/red meat without stepping out? Order fresh fat-trimmed lamb/goat meat online and get safe, contactless delivery right to your doorstep. Order Now!",
                    "meta_keyword": "mutton, mutton online, red meat, goat meat, lamb meat, order meat online, buy mutton online, goat meat prices, lamb meat prices",
                    "meta_title": "Meat Online - Order Goat Mutton & Lamb Mutton Online - Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2119874c-38a6-df8c-22f1-5cd8a2eb4d80/original/Mutton_(1)_(1).png",
                    "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c95b10ce-7b8a-2617-ea11-35a1ee20674b/original/Mutton_(1)_(1).png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            This is no ordinary meat. All our lambs and goats have been farm-fed and raised with care. We remove excess fat and offal to give you more meat per kg. Taste it and you can’t go back.",
                    "subtitle": "Mutton ",
                    "popular": 1,
                    "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4b9ade21-4569-531f-b8f0-01cca8dd5419/original/Mutton_(1)_(1).png",
                    "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0359a66c-cb87-8f96-a154-b8a1072ff2f5/original/Mutton_(1)_(1).png",
                    "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/107b3f30-2927-0726-bce1-3e53a361bd96/original/Mutton_(1)_(1).png",
                    "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/088d9a02-8206-9b58-6878-96e5bab6017b/original/Mutton_(1)_(1).png",
                    "created_at": "2016-04-29T11:00:19.000Z",
                    "updated_at": "2024-04-22T03:50:57.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/00830f50-7796-9eff-8cac-e97abcb5f897/original/Mutton_(1)_(1).png",
                    "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/be1f0bf6-2de4-5608-558c-37039f279108/original/Mutton_(1)_(1).png",
                    "l0_subtext": "Pasture raised lamb & goats",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 2,
                    "sub_categories": [
                        {
                            "id": 709,
                            "cat_name": "Choose Your Own Mutton",
                            "cat_desc": "                                                                                                                                                                                                                                                                    <span style=\"color: rgb(34, 34, 34); font-family: Arial, Helvetica, sans-serif; font-size: small;\">Choose Your Own Mutton</span>                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/03b011d6-51bc-c61a-ac87-12582ccf9175/original/1699891127189.png",
                            "slug": "choose-your-own-mutton",
                            "meta_desc": "Choose Your Own Mutton",
                            "meta_keyword": "Choose Your Own Mutton",
                            "meta_title": "Choose Your Own Mutton",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/0ed2fcf3-571a-1b78-5b30-7282a1a23e1b/original/1699891137194.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/fb424f2f-2b88-765f-f563-9d0d382ebb2e/original/1699891132849.png",
                            "msite_desc": "                                                                                                                                                                                                                                                                    <p><span style=\"color: rgb(34, 34, 34); font-family: Arial, Helvetica, sans-serif; font-size: small;\">Choose Your Own Mutton</span><br></p>",
                            "subtitle": "Choose Your Own Mutton",
                            "popular": 1,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/eccc5ab6-7084-c48c-424c-9c6f5bf69d8f/original/1699891142308.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/862f9f3c-4504-9497-7736-6dac66787071/original/1699891145910.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/3c2cccac-a992-4c77-a93b-963c855152de/original/1699891150208.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/0521c3e4-bb63-843c-eaa8-504b68d60130/original/1699891155209.png",
                            "created_at": "2023-11-13T12:06:23.000Z",
                            "updated_at": "2023-11-13T10:29:20.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/a80f6f6f-2fa3-bfb0-48d5-460c3162f3cb/original/1699891115934.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/8b74f18c-f113-7f83-cdbc-6d6426bc9842/original/1699891121238.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 766,
                            "cat_name": "Mutton_Curry Cut",
                            "cat_desc": "Curry Cuts                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/d79bafb3-aa92-5062-bbd4-56537309bc1c/original/1701888667562.png",
                            "slug": "mutton_curry-cut",
                            "meta_desc": "Curry Cuts",
                            "meta_keyword": "Curry Cuts",
                            "meta_title": "Curry Cuts",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/44d16a0a-cefe-5a95-9f2d-5507ee883a6b/original/1701888674591.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/694ba62a-e4b2-8a39-46ce-0df8c96a8bf9/original/1701888671079.png",
                            "msite_desc": "<p>Curry Cuts<br></p>",
                            "subtitle": "Curry Cuts",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/f765f397-39ff-b9a5-cd8f-87bcf6267543/original/1701888675879.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/2c81d320-e546-61d0-84d8-5c1ae455a241/original/1701888678869.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/6cde3255-a1ee-6bd0-ad78-b9d82662eb53/original/1701888680862.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/26d4ff44-3960-7737-f8c2-dd17c71ebe2a/original/1701888683952.png",
                            "created_at": "2023-12-06T18:52:51.000Z",
                            "updated_at": "2023-12-06T18:52:51.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/a0014c04-13a6-ce54-0a62-3700283ad92d/original/1701888663130.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/d054f18a-d822-d341-f64f-cff8dac85fa4/original/1701888666352.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 767,
                            "cat_name": "Mutton_Boneless & Mince",
                            "cat_desc": "Boneless ",
                            "cat_img": "https://assets.licious.in/OMS-Category/bb4b0e21-c56f-6170-998d-d1fa9419554b/original/1701888909881.png",
                            "slug": "mutton_boneless-and-mince",
                            "meta_desc": "Boneless & Mince_Mutton",
                            "meta_keyword": "Boneless & Mince_Mutton",
                            "meta_title": "Boneless & Mince_Mutton",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/c18e4302-e9ef-cfa4-00ff-ff0e3613d992/original/1701888915544.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/8a2c5c15-012c-23d9-7772-c106fa891f2d/original/1701888912922.png",
                            "msite_desc": "<p>Boneless ",
                            "subtitle": "Boneless & Mince",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/c2784221-4f3d-12a3-1fae-0bc24c27a512/original/1701888920322.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/9ac55047-d09e-a960-91f9-17b7833387da/original/1701888921859.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/020356e6-bd74-650a-b2aa-6d130f7eb044/original/1701888924866.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/e94e6e4f-3b72-eff3-31d8-747016addcc3/original/1701888926888.png",
                            "created_at": "2023-12-06T18:55:54.000Z",
                            "updated_at": "2023-12-06T18:55:54.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/a9d84429-6369-712e-cab5-286fd5cf3183/original/1701888906780.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/39854325-862e-dd83-8575-15f73e4ba5ce/original/1701888906424.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 768,
                            "cat_name": " Mutton_Speciality Cuts",
                            "cat_desc": "Speciality Cuts                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/0ecb139a-7013-51fd-b57d-229e69c5eac8/original/1701889104674.png",
                            "slug": "mutton_speciality-cuts-7727097d-19cf-4039-8dd6-86226f304ae4",
                            "meta_desc": "Speciality Cuts",
                            "meta_keyword": "Speciality Cuts",
                            "meta_title": "Speciality Cuts",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/228e678f-0d95-5f38-51d3-e3e3ecdc469c/original/1701889109792.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/f9174eb5-5a94-f8a5-24cd-7acd0b9b9ab6/original/1701889112313.png",
                            "msite_desc": "<p>Speciality Cuts<br></p>",
                            "subtitle": "Speciality Cuts",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/7aecfebf-5a39-1b8f-ac09-a171d015f82b/original/1701889112399.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/d047a451-a6f4-028a-b5e8-5b8edb1f3f40/original/1701889115076.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/ca86c628-6b2a-41e2-30d8-e197b1023f7d/original/1701889117176.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/5966e985-3f7b-4aa1-434d-75b61259e79e/original/1701889119787.png",
                            "created_at": "2023-12-06T18:58:59.000Z",
                            "updated_at": "2023-12-06T18:58:59.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/8adad8cc-ed8a-fc26-f35c-5e60e55bd111/original/1701889099089.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/296a34f6-0b0c-bd81-e405-97810b93dbb2/original/1701889101770.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 769,
                            "cat_name": "Mutton_Liver & More Offals",
                            "cat_desc": "Liver ",
                            "cat_img": "https://assets.licious.in/OMS-Category/8f30ab23-22bd-7c89-46de-4d618bc5549e/original/1701889298877.png",
                            "slug": "mutton_liver-and-more-offals",
                            "meta_desc": "Liver & More",
                            "meta_keyword": "Liver & More",
                            "meta_title": "Liver & More",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/1489e385-6c51-50a6-e523-bee9ccc5edf1/original/1701889304877.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/bf9d6578-5561-c083-a6e8-434c2adbb2a8/original/1701889302763.png",
                            "msite_desc": "<p>Liver ",
                            "subtitle": "Liver & More",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/1a131680-27b4-f55c-8707-3ac221e5e95c/original/1701889307263.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/c4002ec1-569c-a0d1-a33c-e7f29c4dfcd2/original/1701889310500.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/e1997840-7a37-d581-b87d-bd8b1e64caf4/original/1701889315061.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/e1732b5a-368c-cbf4-3c82-44dcc7a58553/original/1701889316835.png",
                            "created_at": "2023-12-06T19:02:23.000Z",
                            "updated_at": "2023-12-06T19:02:23.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/09887cce-4aaa-94f4-2ba7-d40c600cd3e3/original/1701889293858.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/3c78a95b-b7a5-0cec-9ef0-5da8f4f930cb/original/1701889297323.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 770,
                            "cat_name": "Mutton_Premium Cuts",
                            "cat_desc": "Premium Cuts                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/a2b66db1-56a0-fffa-1883-f72089695ea7/original/1701889640818.webp",
                            "slug": "mutton_premium-cuts",
                            "meta_desc": "Premium Cuts",
                            "meta_keyword": "Premium Cuts",
                            "meta_title": "Premium Cuts",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/1bd5311f-852e-9fd7-9bcd-ee81ce7c6069/original/1701889647073.webp",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/1c0c3463-92b6-fc54-f9f7-1dab6de06c5b/original/1701889643567.webp",
                            "msite_desc": "<p>Premium Cuts<br></p>",
                            "subtitle": "Premium Cuts",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/3fd39445-b64b-4547-002a-ef2e9dc52f28/original/1701889649364.webp",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/760f48e3-70c9-ffd0-c9af-75c6a91be3b5/original/1701889651947.webp",
                            "web_icon": "https://assets.licious.in/OMS-Category/45221fab-b113-c596-355b-614864a6b769/original/1701889654969.webp",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/8015207c-f996-58ac-7f9e-c0c3c750eb2f/original/1701889657272.webp",
                            "created_at": "2023-12-06T19:10:44.000Z",
                            "updated_at": "2023-12-06T19:10:44.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/6bc37d20-3b5a-daab-eb8c-80a950afdb6c/original/1701889636174.webp",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/02863ee1-5e80-1165-328e-b199894442ba/original/1701889638451.webp",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 856,
                            "cat_name": "Ready to Cook_",
                            "cat_desc": "                                                    <span style=\"color: rgb(29, 28, 29); font-family: Slack-Lato, Slack-Fractions, appleLogo, sans-serif; font-size: 15px; font-variant-ligatures: common-ligatures; background-color: rgb(248, 248, 248);\">Ready to Cook</span>                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/6559ebee-fdf6-4885-b105-4397646015e7/original/1706860092767.png",
                            "slug": "ready-to-cook_",
                            "meta_desc": "Ready to Cook",
                            "meta_keyword": "Ready to Cook",
                            "meta_title": "Ready to Cook",
                            "status": 1,
                            "parent_id": 2,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/72e0ede8-7d12-08d3-4f9d-a5e5b844fe99/original/1706860104622.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/9685230f-37e3-37ab-8897-049de446a6ae/original/1706860098656.png",
                            "msite_desc": "                                                    <p><span style=\"color: rgb(29, 28, 29); font-family: Slack-Lato, Slack-Fractions, appleLogo, sans-serif; font-size: 15px; font-variant-ligatures: common-ligatures; background-color: rgb(248, 248, 248);\">Ready to Cook</span><br></p>",
                            "subtitle": "Ready to Cook",
                            "popular": 1,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/e27f697e-8045-2651-077d-a1ba1619f0db/original/1706860114324.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/f872689d-54c5-0e3d-2ed2-21ffe342146e/original/1706860119669.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/7b0f3c7a-8c6d-498b-0db2-e439bc72dfd7/original/1706860125134.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/30a8f868-bb86-bdc4-21e3-1bc734dcc319/original/1706860130004.png",
                            "created_at": "2024-02-02T07:49:12.000Z",
                            "updated_at": "2024-02-02T02:22:53.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/662d905f-bd8a-2ff1-e4c4-b3cfa920dc10/original/1706860082324.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/c9259d62-750f-a983-a068-6086ba8fb8fc/original/1706860087206.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 761,
                    "cat_name": " Liver & More",
                    "cat_desc": "                                                                                                                                                            <span class=\"selectable-text copyable-text\">Rich \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/1d8d23da-9f17-e724-0012-2d58f1726006/original/1701430404465.png",
                    "slug": "offals-19b160f7-f41e-4e2c-b3b8-d8324189d468",
                    "meta_desc": "Offals",
                    "meta_keyword": "Offals",
                    "meta_title": "Offals",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/2b1d8de6-4083-ea97-281f-5c48a68dce9d/original/1701430415338.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/eb0ab768-12ed-6838-9cd6-68f4f5df1f9a/original/1701430410353.png",
                    "msite_desc": "                                                                                                                                                            <span class=\"selectable-text copyable-text\">Rich ",
                    "subtitle": "Liver & More",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/3bef792f-70dd-33be-d2d7-e6cbe5ffdd21/original/1701430422908.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/7e929c0a-bd13-1896-205b-a161f75b6ae2/original/1701430419469.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/a0a558f1-f05e-832a-6d32-a5ee1512707f/original/1701430426401.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/aad3b662-126c-8ed3-891e-b5b2e2b2906c/original/1701430430048.png",
                    "created_at": "2023-11-30T18:23:48.000Z",
                    "updated_at": "2024-06-12T06:54:16.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/e3b86082-d8a9-1823-e384-ff6d211bb507/original/1701430397534.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/48bc8ff0-2be6-a7b9-3017-4d15032656fa/original/1701430406100.png",
                    "l0_subtext": "Rich & flavourful cuts of liver, kidney, Paya & more.",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 2,
                    "sub_categories": [
                        {
                            "id": 762,
                            "cat_name": "Mutton_ Offals",
                            "cat_desc": "<span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "cat_img": "https://assets.licious.in/OMS-Category/5b40ea97-0c5d-0b59-4049-e32a1da636e1/original/1701368756277.png",
                            "slug": "mutton_-offals",
                            "meta_desc": "Mutton_ Offals",
                            "meta_keyword": "Mutton_ Offals",
                            "meta_title": "Mutton_ Offals",
                            "status": 1,
                            "parent_id": 761,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/e39fbfcd-c519-6789-3c4a-2ec26ac3840a/original/1701368762940.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/03fea6ae-270d-beba-d5d3-3ecc80c5e77a/original/1701368753610.png",
                            "msite_desc": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Mutton",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/23db7f3d-6c95-b0d6-ef3f-3ef4769c7b9d/original/1701368759737.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/30275795-b74b-1c65-e810-b1d115097dba/original/1701368766244.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/92d3f27b-2c87-349d-7de3-cf514c156a83/original/1701368768927.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/38147401-061a-9a6f-ac51-0a4817943e04/original/1701368771800.png",
                            "created_at": "2023-11-30T18:26:25.000Z",
                            "updated_at": "2023-11-30T18:26:25.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/56f2ae32-e70a-6577-cfd2-5d711938c971/original/1701368748233.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/bb5a9619-a429-023b-d5e4-b723d4591dec/original/1701368750791.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 763,
                            "cat_name": "Chicken_Offals",
                            "cat_desc": "<span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "cat_img": "https://assets.licious.in/OMS-Category/396763de-d4e3-1d07-d111-24ce3f4fbc6b/original/1701368854180.png",
                            "slug": "chicken_offals",
                            "meta_desc": "Chicken_Offals",
                            "meta_keyword": "Chicken_Offals",
                            "meta_title": "Chicken_Offals",
                            "status": 1,
                            "parent_id": 761,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/191c77f8-65b3-4c44-d4bd-e69a810e49e1/original/1701368860406.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/6f8d8be1-10fd-4fc2-85b8-89e77e0394b8/original/1701368858043.png",
                            "msite_desc": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Chicken",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/983b6abc-8a62-2afe-e905-03349c164d8f/original/1701368863899.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/f9aa18bd-4d32-558c-5c93-7fdae84f98b1/original/1701368866502.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/0ad9b975-d10f-4259-8d72-5a750fdb1ac2/original/1701368870962.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/1b09a6eb-6f6c-c2b4-b61c-e43345926af3/original/1701368873090.png",
                            "created_at": "2023-11-30T18:28:07.000Z",
                            "updated_at": "2023-11-30T18:28:07.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/d7fa6efc-49e6-35c1-b64e-b4ea9bf61d3f/original/1701368844358.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/c2b3ccfd-700f-6f28-52f9-26ee2d79f3ef/original/1701368850779.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 2,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 641,
                    "cat_name": "Prawns & Crabs",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                Prawns                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/dac6f464-d5ef-a291-98b5-2f9e4cca782d/original/1697219776195.png",
                    "slug": "prawns_kolkata",
                    "meta_desc": "Prawns",
                    "meta_keyword": "Prawns",
                    "meta_title": "Prawns",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/bfd348af-bbcf-1ef4-cfc0-e6c962692419/original/1697219789195.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/cdd38326-5487-bb00-0a09-838abdefb748/original/1697219782510.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <p>Prawns<br></p>",
                    "subtitle": "Prawns & Crabs",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/b4391a7a-ae32-d90e-365b-bbc99b510021/original/1697219795907.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/a95c2614-4b57-1537-5dfb-fe9bb0a3834a/original/1697219807342.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/64debf18-9640-93ef-8ce6-7681ba1472d0/original/1697219815440.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/0fd7c9c2-6143-299d-515b-9959505f0ca0/original/1697219822307.png",
                    "created_at": "2023-10-13T17:57:35.000Z",
                    "updated_at": "2024-04-22T04:08:39.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/1ea0a40f-2774-c838-5da7-e6ee9e1c79a6/original/1697219747226.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/711c3659-d551-3d0f-fba4-59d828212ec4/original/1697219768475.png",
                    "l0_subtext": "Cleaned, peeled & deveined",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 6,
                    "sub_categories": [
                        {
                            "id": 642,
                            "cat_name": "Crab_Prawns Kolkata",
                            "cat_desc": "                                                                                                        Crab                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/cd9decb4-eb71-895e-f88e-b04c9d19b7b7/original/1697220066703.png",
                            "slug": "crab_prawns-kolkata",
                            "meta_desc": "Crab",
                            "meta_keyword": "Crab",
                            "meta_title": "Crab",
                            "status": 1,
                            "parent_id": 641,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/a7d06371-44d8-78b6-8e55-d8de62b2afca/original/1697220083308.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/f6fe9d94-7bbd-5f08-c219-751ab420bb5e/original/1697220076830.png",
                            "msite_desc": "                                                                                                        <p>Crab<br></p>",
                            "subtitle": "Crab",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/d426bfd5-be39-a52a-05ef-019c17d17418/original/1697220091966.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/73804d9d-7dcb-eeef-5371-89cd32c09953/original/1697220100284.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/7f4ea6fc-018d-9c3e-882e-a07f5d9dbc66/original/1697220112154.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/a7b6c7e7-9072-1f19-5fe3-3f4dd4d6a9ae/original/1697220119807.png",
                            "created_at": "2023-10-13T18:02:21.000Z",
                            "updated_at": "2023-10-13T12:57:30.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/8b5cc0f3-0637-188c-4432-03ee1a4bdd4c/original/1697220051510.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/105aabb9-dec6-bd46-7a18-6f9dc4ab8551/original/1697220059714.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 6,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 643,
                            "cat_name": "Small Prawns_Kolkata",
                            "cat_desc": "Small Prawns                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/b6a0cf68-7058-aedb-1ea9-842ac4351e21/original/1697220343200.png",
                            "slug": "small-prawns_kolkata",
                            "meta_desc": "Small Prawns",
                            "meta_keyword": "Small Prawns",
                            "meta_title": "Small Prawns",
                            "status": 1,
                            "parent_id": 641,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/737e00c3-aaca-96ad-7bf5-52bbe3458f63/original/1697220360815.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/48553b00-dcd4-04ac-bfe3-3f03b16c38ef/original/1697220351302.png",
                            "msite_desc": "<p>Small Prawns<br></p>",
                            "subtitle": "Small Prawns",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/90b7e66e-5806-a09f-3b25-51572c538a75/original/1697220368178.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/70f43f77-bca3-0fe1-e7e5-e1fe7ad756fd/original/1697220375879.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/24708445-3201-91c2-9b43-a5f4886602bc/original/1697220383049.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/81c8adaa-7dd3-0be0-6033-b00bd1b6d4f7/original/1697220395553.png",
                            "created_at": "2023-10-13T18:06:57.000Z",
                            "updated_at": "2023-10-13T18:06:57.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/7fb6b3bc-b61d-edd7-cbdd-82c4b30515cf/original/1697220326723.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/9a79a6e4-71ea-a74d-99be-ca1ff2752ce0/original/1697220334329.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 6,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 644,
                            "cat_name": "Medium Prawns_Kolkata",
                            "cat_desc": "Medium Prawns                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/d067b84a-69dc-dbfb-1497-72d153121fd8/original/1697220500227.png",
                            "slug": "medium-prawns_kolkata",
                            "meta_desc": "Medium Prawns",
                            "meta_keyword": "Medium Prawns",
                            "meta_title": "Medium Prawns",
                            "status": 1,
                            "parent_id": 641,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/ee0e1157-3dee-3ae9-ac78-ac84894664cf/original/1697220514642.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/468de158-c317-1680-b760-529dc0a51d99/original/1697220506958.png",
                            "msite_desc": "<p>Medium Prawns<br></p>",
                            "subtitle": "Medium Prawns",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/7552a54d-5add-02ce-e386-d80db71f3c55/original/1697220522338.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/349f1ee2-3967-b58c-4914-93ce3331b9ab/original/1697220531174.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/68b2f6de-fbc9-04e5-0765-90872234eb02/original/1697220542579.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/070fb6c0-eaf5-de34-4e53-a5c90f723979/original/1697220549592.png",
                            "created_at": "2023-10-13T18:09:28.000Z",
                            "updated_at": "2023-10-13T18:09:28.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/f5443ce1-9adc-75cb-c57f-54c273791d0a/original/1697220486139.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/2cf485f1-3240-c31e-840a-78c16d226052/original/1697220492856.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 6,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 645,
                            "cat_name": "Large Prawns_Kolkata",
                            "cat_desc": "Large Prawns                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/c618df09-b147-205d-8035-d4d498f873fc/original/1697220664149.png",
                            "slug": "large-prawns_kolkata",
                            "meta_desc": "Large Prawns",
                            "meta_keyword": "Large Prawns",
                            "meta_title": "Large Prawns",
                            "status": 1,
                            "parent_id": 641,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/51c67c55-39a6-c75e-1db6-53cd99787098/original/1697220678090.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/748da0da-dd84-b669-7628-6d6401d7fe00/original/1697220671238.png",
                            "msite_desc": "<p>Large Prawns<br></p>",
                            "subtitle": "Large Prawns",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/2a9628fe-4911-037f-9ace-1717e044ad3c/original/1697220685617.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/2f787ee9-7af5-a528-8040-3e9258b34b55/original/1697220692991.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/a10307b2-bf5e-f788-8237-20b37981e287/original/1697220700363.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/6d798f74-7dc1-8e3d-a3bb-0e7d7030a726/original/1697220707411.png",
                            "created_at": "2023-10-13T18:12:19.000Z",
                            "updated_at": "2023-10-13T18:12:19.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/9191d24a-fb18-6c60-7071-3ebd41af5c04/original/1697220649716.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/e35e1803-73e3-6d18-eb05-442ac5d2ea6a/original/1697220657441.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 6,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 30,
                    "cat_name": "Eggs",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Fresh, natural county eggs and classic eggs from farm-raised chickens. \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e931d464-bb6b-8e96-4cca-fb2fc172f43a/original/Eggs.png",
                    "slug": "eggs",
                    "meta_desc": "Looking for good quality fresh eggs online? Licious serves the best quality brown eggs, classic eggs as well as country eggs. These eggs are naturally laid and antibiotic-free. Order now!",
                    "meta_keyword": "eggs, eggs online, buy eggs online, order eggs online, fresh eggs, healthy eggs, egg online price, chicken eggs online",
                    "meta_title": "Eggs Online - Buy Fresh Brown, Country or Classic Eggs from Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/544bddc9-5775-cd44-511c-8e7e78f75a10/original/Eggs.png",
                    "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1dc99eb6-402a-978d-13cd-edc9da0faa97/original/Eggs.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Fresh, natural county eggs and classic eggs from farm-raised chickens. ",
                    "subtitle": "Eggs",
                    "popular": 1,
                    "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/bd3b8135-e738-29e3-e522-56d6dd9547e4/original/Eggs.png",
                    "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/61cca0d7-09cf-882d-13b7-0e822b8d3037/original/Eggs.png",
                    "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1bd08fae-c971-390a-ce8a-6f6502f5bd0d/original/Eggs_(1).png",
                    "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/eb1cc2f3-f4e6-d093-920c-330a37a39eba/original/Eggs_(1).png",
                    "created_at": "2017-05-07T14:14:11.000Z",
                    "updated_at": "2024-04-22T04:21:46.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7ee22866-0f60-74c5-c206-21f065100d18/original/Eggs.png",
                    "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d2d8ea03-3bb6-d596-80d3-fd7e8bdb55f7/original/Eggs.png",
                    "l0_subtext": "No antibiotic residue",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 7,
                    "sub_categories": [
                        {
                            "id": 85,
                            "cat_name": "Classic_Eggs",
                            "cat_desc": "                                                                                                                                                            Classic Eggs                                                                                                                                                            \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2793ed2e-d976-0823-c090-bead4390fe4b/original/Classic_Eggs_12_264x204.png",
                            "slug": "farmclassic",
                            "meta_desc": "Classic Eggs",
                            "meta_keyword": "Classic Eggs",
                            "meta_title": "Classic Eggs",
                            "status": 1,
                            "parent_id": 30,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ddc019e3-083b-f44f-ca0c-5cb25024d608/original/Classic_Eggs_12_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f114202f-4aaa-37ed-b7f6-fb881de1a19d/original/Classic_Eggs_12_264x204.png",
                            "msite_desc": "                                                                                                                                                            Classic Eggs                                                                                                                                                            <p></p>",
                            "subtitle": "Classic Eggs",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/456b2892-4c10-2d66-f520-ed73bb42e518/original/Classic_Eggs_12_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c40ec830-bc4f-4136-4a0b-831649daf972/original/Classic_Eggs_12_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/eea1f8dc-04ba-aeaa-1f71-013a07a85e79/original/Classic_Eggs_12_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/927a2833-e422-a33b-657e-5e51ac243807/original/Classic_Eggs_12_264x204.png",
                            "created_at": "2022-05-19T17:58:26.000Z",
                            "updated_at": "2023-06-27T05:28:09.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/923cd95f-bfd5-c3d2-ba9c-f070db943d3a/original/Classic_Eggs_12_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/75deb12d-a360-9de1-c932-d35c9bf61f33/original/Classic_Eggs_12_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 0,
                            "order": 7,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 87,
                            "cat_name": "Speciality Eggs",
                            "cat_desc": "                                                                                                        <span data-sheets-value=\"{\n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/431c3224-cbb1-eab6-1090-641ed71bfd8e/original/Brown_Eggs_264x204.png",
                            "slug": "speciality-eggs",
                            "meta_desc": "Speciality Eggs",
                            "meta_keyword": "Speciality Eggs",
                            "meta_title": "Speciality Eggs",
                            "status": 1,
                            "parent_id": 30,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ec92e8ef-77e8-63f5-dbce-2d8a4270fd2e/original/Brown_Eggs_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8c3c35a5-d1d1-0cd4-ff77-05602219f46f/original/Brown_Eggs_264x204.png",
                            "msite_desc": "                                                                                                        <p><span data-sheets-value=\"{",
                            "subtitle": "Speciality Eggs",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4f8854e3-26ac-1b21-d25d-a850b99766e7/original/Brown_Eggs_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7c7b5a90-fdbd-e770-80e5-16e1614d6aed/original/Brown_Eggs_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3673e18a-ef4b-428d-9958-5ea615f5115d/original/Brown_Eggs_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a6f01f30-792f-c3df-5de5-78a1023d43cc/original/Brown_Eggs_264x204.png",
                            "created_at": "2022-05-19T18:00:51.000Z",
                            "updated_at": "2023-06-27T05:30:09.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7a0c23d2-7b6f-7453-53b3-0aa081e44bdc/original/Brown_Eggs_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/90ae7303-1b8c-477b-1a39-b2d5e44d309a/original/Brown_Eggs_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 0,
                            "order": 7,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 88,
                            "cat_name": "Combos_Eggs",
                            "cat_desc": "                                                                                                        <span data-sheets-value=\"{\n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/35a73435-04dd-7cae-9c4d-0610362a6e14/original/sample-imgEggs-Combo_(1).png",
                            "slug": "combos_eggs",
                            "meta_desc": "Combos",
                            "meta_keyword": "Combos",
                            "meta_title": "Combos",
                            "status": 1,
                            "parent_id": 30,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1fe0ea70-1087-9db4-75f0-b3b713f1cdfa/original/sample-imgEggs-Combo_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/28859045-539c-cbbb-1458-787a6a58e238/original/sample-imgEggs-Combo_(1).png",
                            "msite_desc": "                                                                                                        <p><span data-sheets-value=\"{",
                            "subtitle": "Combos",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/73c8016b-59fc-2360-c15a-6df43222568d/original/sample-imgEggs-Combo.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/322b824f-6cee-f9a6-ec5b-13a719b8d207/original/sample-imgEggs-Combo_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f4545150-8b51-6147-eb51-24472bb3bc22/original/sample-imgEggs-Combo_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/83c2bb1b-cced-1fa3-582f-bf641cd58e2b/original/sample-imgEggs-Combo_(1).png",
                            "created_at": "2022-05-19T18:01:59.000Z",
                            "updated_at": "2023-06-27T05:31:07.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3f8d0096-b2ec-dfb4-b955-44e8f26ecaf3/original/sample-imgEggs-Combo_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/dc0c0d83-9557-0216-656e-bccd97a954f0/original/sample-imgEggs-Combo_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 0,
                            "order": 7,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 891,
                            "cat_name": "Ready to Cook - Eggs",
                            "cat_desc": "                                                                                                        <p>Ready to Cook\n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/779b6d73-5dc4-da5e-a22a-890df554db83/original/1709024023167.png",
                            "slug": "ready-to-cook-eggs",
                            "meta_desc": "Ready to Cook",
                            "meta_keyword": "Ready to Cook",
                            "meta_title": "Ready to Cook",
                            "status": 1,
                            "parent_id": 30,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/8173ddaf-5a24-6ff7-26be-32365061e6e0/original/1709024019622.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/50c8f3c2-a84b-f6fd-67f5-148e5d0ec113/original/1709024021551.png",
                            "msite_desc": "                                                                                                        <p>Ready to Cook<br></p>",
                            "subtitle": "Breakfast Specials",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/fae1255a-a67c-a112-26c4-9ad561a54e71/original/1709024031074.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/bb492397-1ba0-a3ef-55c1-49a2ef0fcead/original/1709024032530.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/8373418b-9e4f-9da6-d223-af04f63a8fe0/original/1709024034175.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/3433fb57-64e1-0b02-6d64-e87e4407c4d5/original/1709024036066.png",
                            "created_at": "2024-02-27T09:02:02.000Z",
                            "updated_at": "2024-02-27T07:07:54.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/dc14e3a3-9c2e-3212-cbed-9fe5c2470482/original/1709024017703.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/b7c8e7d7-7464-68a3-5d7d-877f482c7486/original/1709024024699.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 7,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 841,
                    "cat_name": " Crispy Snacks",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Crispy Snacks                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/85b97926-e909-3d14-5874-c941549d1e7d/original/1706766727099.png",
                    "slug": "crispy-snacks-b75bdeb3-0a4d-4bfc-9014-947c22f2750a",
                    "meta_desc": "Crispy Snacks",
                    "meta_keyword": "Crispy Snacks",
                    "meta_title": "Crispy Snacks",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/0f948ef1-047b-7adf-f913-bab53946f16b/original/1706766736268.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/a19ac58a-6be6-9fda-745b-fddaf348bf66/original/1706766731982.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <p>Crispy Snacks<br></p>",
                    "subtitle": "Crispy Snacks",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/819ab31a-90a8-4d04-b7dd-9b908c761a68/original/1706766741415.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/756eb9c9-4590-e581-daf9-ebe608a9dc7b/original/1706766746546.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/86b2f435-adb6-e64f-3573-a2bc3b5c2fcf/original/1706766751975.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/1f66f4de-9310-bb9d-8dc6-5bd1df16310a/original/1706766756998.png",
                    "created_at": "2024-01-24T07:14:05.000Z",
                    "updated_at": "2024-04-22T04:07:35.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/60aeb8f9-d854-a5e0-33f9-37b8a8134237/original/1706766717014.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/44067855-6dae-b54d-365d-faabe486b34f/original/1706766721896.png",
                    "l0_subtext": "Breadcrumb-coated fresh meats ",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 7,
                    "sub_categories": [
                        {
                            "id": 842,
                            "cat_name": "Chicken_Crispy snacks",
                            "cat_desc": "                                                    Chicken_Crispy snacks                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/ce91d909-71d1-1202-1834-b865417e6ab9/original/1706107219015.png",
                            "slug": "chicken_crispy-snacks",
                            "meta_desc": "Chicken_Crispy snacks",
                            "meta_keyword": "Chicken_Crispy snacks",
                            "meta_title": "Chicken_Crispy snacks",
                            "status": 1,
                            "parent_id": 841,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/0a111f0d-ec6a-c292-ff40-330f6fd8ade6/original/1706107210153.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/82ea8a50-b894-9562-8059-a5f682b5965c/original/1706107213964.png",
                            "msite_desc": "                                                    <p>Chicken_Crispy snacks<br></p>",
                            "subtitle": "Chicken",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/88b720d1-bd30-e219-0e8b-b0c68e6dfd91/original/1706107205427.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/b5db53ad-8a8b-5aa9-152c-04f4f97291ec/original/1706107175860.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/40dc5ab0-98b3-1cac-fca8-f55d08519ba7/original/1706107171059.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/e031ea91-fa18-ae3f-4c0a-be77be30e137/original/1706107163253.png",
                            "created_at": "2024-01-24T07:18:28.000Z",
                            "updated_at": "2024-01-24T09:10:40.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/8b29ddb8-ed65-0dda-8d0d-c44b2e6561f7/original/1706107233892.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/789e099b-85d9-5943-821a-2028e97c09a0/original/1706107222975.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 7,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 843,
                            "cat_name": "Fish & Seafood_Crispy snacks",
                            "cat_desc": "                                                                                                        Fish                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/7960fb49-7bdf-c0df-5d42-33535dc9a7fb/original/1706081408769.png",
                            "slug": "fish_crispy-snacks",
                            "meta_desc": "Fish",
                            "meta_keyword": "Fish",
                            "meta_title": "Fish",
                            "status": 1,
                            "parent_id": 841,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/92b11d8a-2b47-0b8d-fdae-29962309aa95/original/1706081416218.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/1abcdd87-17ad-4986-3be8-d10a7495fa65/original/1706081412425.png",
                            "msite_desc": "                                                                                                        <p>Fish<br></p>",
                            "subtitle": "Fish & Seafood",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/0e85a6f7-9e26-7173-1681-065c5bcdfb30/original/1706081419774.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/a9c3b2d3-f063-4787-2b57-91f56be53c81/original/1706081423347.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/73a56a98-1ba0-6065-3880-b7594bb73c95/original/1706081427275.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/a99fe35e-7451-bdcb-2914-11dee8e8d7ed/original/1706081431011.png",
                            "created_at": "2024-01-24T07:24:39.000Z",
                            "updated_at": "2024-01-24T09:08:19.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/649702b1-50d8-6a96-5f59-0a9aac17bac0/original/1706081400291.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/408b17c4-224a-15b1-7ad7-5d9d9739c9d3/original/1706081404750.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 7,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 537,
                    "cat_name": "Kebab & Biryani",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Enjoy our range of Ready to Cook Kebabs made with legacy Nawabi recipes and marinated in over 40 authentic spices. Ready to enjoy in less than 8 minutes.                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/4d3824cb-54b9-6cd2-6ab3-5e632abc6ac6/original/1704969405257.png",
                    "slug": "biryani-and-kebab",
                    "meta_desc": "Looking for ready to cook kebabs bursting with flavour? Order on Licious and get kebabs handcrafted by experts using high grade meat and spiced to perfection. Order now!",
                    "meta_keyword": "kebab, kabab, chicken kabab, mutton kabab, mutton kebab, chicken kebab, best kebab, kebab online, seekh",
                    "meta_title": "Kebabs Online - Buy Chicken Kebab, Mutton Kebab Online on Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/7ddfb1e6-7650-96b3-041f-fdb81673d532/original/1704969411805.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/b1d99455-f29a-2b21-16f6-225030801f1e/original/1704969408841.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <p>Enjoy our range of Ready to Cook Kebabs made with legacy Nawabi recipes and marinated in over 40 authentic spices. Ready to enjoy in less than 8 minutes.<br></p>",
                    "subtitle": "Kebab & Biryani",
                    "popular": 1,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/e330d500-5d92-f884-a04a-26ed09bd0d2a/original/1704969414847.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/c65f886d-ac5f-d419-7c38-0f6ada1aa431/original/1704969417871.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/c0ad1242-cfd7-7047-a6c9-9fc50f81e7ec/original/1704969421161.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/1bc626fe-0dcb-ef1b-5605-463f35571f11/original/1704969424957.png",
                    "created_at": "2023-06-15T15:16:14.000Z",
                    "updated_at": "2024-04-22T04:00:04.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/ab772709-b5a6-3047-3dc9-35b078d98fd9/original/1704969398940.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/306b5a36-28c9-b6cb-e594-8b137071242f/original/1704969402297.png",
                    "l0_subtext": "Chef-crafted authentic recipes",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 8,
                    "sub_categories": [
                        {
                            "id": 538,
                            "cat_name": "Kebab _ Biryani and Kebab",
                            "cat_desc": "                                                    Kebab                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ab1a054e-eac0-a635-bca4-7a27128009d2/original/Afghani_Seekh_264x204_(1).png",
                            "slug": "kebab-_-biryani-and-kebab",
                            "meta_desc": "Kebab",
                            "meta_keyword": "Kebab",
                            "meta_title": "Kebab",
                            "status": 1,
                            "parent_id": 537,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/008d1e46-cb02-c301-dccf-3678c850c9e9/original/Afghani_Seekh_264x204_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/21c726fe-9488-1668-3480-0f4e094e1008/original/Afghani_Seekh_264x204_(1).png",
                            "msite_desc": "                                                    <p>Kebab<br></p>",
                            "subtitle": "Kebab",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3601a229-f409-0242-28d5-82f43615625b/original/Afghani_Seekh_264x204_(1).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9b532422-5887-bde7-93df-0be2c5bb74db/original/Afghani_Seekh_264x204_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/271a5094-6977-2341-aeea-86dfcbebf653/original/Afghani_Seekh_264x204_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ce62f414-af6b-bd4c-ca57-9852c6626fec/original/Afghani_Seekh_264x204_(1).png",
                            "created_at": "2023-06-15T15:35:58.000Z",
                            "updated_at": "2023-10-12T06:18:24.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/75a81750-e6f0-0f0c-05de-66ec97da5c97/original/Afghani_Seekh_264x204_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a8e4c841-5b45-6a09-5188-76b44c05f931/original/Afghani_Seekh_264x204_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 8,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 539,
                            "cat_name": "Tandoor _ Biryani and Kebab",
                            "cat_desc": "Tandoor                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/6da356bf-b9b6-4a5f-9e09-e422a9a2b34e/original/Angara_Chicken_264x204.png",
                            "slug": "tandoor-_-biryani-and-kebab",
                            "meta_desc": "Tandoor",
                            "meta_keyword": "Tandoor",
                            "meta_title": "Tandoor",
                            "status": 1,
                            "parent_id": 537,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a7558625-6247-045d-1a5b-fe24dd4150b4/original/Angara_Chicken_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/71f7ad98-72d7-48c7-2799-2b3fac81920e/original/Angara_Chicken_264x204.png",
                            "msite_desc": "<p>Tandoor<br></p>",
                            "subtitle": "Tandoor",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ec60d148-af0a-fe16-e1cf-d43604d8dcb1/original/Angara_Chicken_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/5471cc7d-132f-18ee-a65c-0bb0d1c8cbf2/original/Angara_Chicken_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4977237a-2c49-6a9b-75b5-a959672de76f/original/Angara_Chicken_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fc011783-38e0-aaa2-7a41-ea40aecee874/original/Angara_Chicken_264x204.png",
                            "created_at": "2023-06-15T15:40:04.000Z",
                            "updated_at": "2023-06-15T15:40:04.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3bc311f4-24a9-1ac6-a98b-c33bc850c807/original/Angara_Chicken_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e4ef7116-f2c9-e93d-27da-7f65f12e021b/original/Angara_Chicken_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 8,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 540,
                            "cat_name": "Biryani _ Biryani and Kebab",
                            "cat_desc": "Biryani                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/53c92ccc-0681-d3b2-d1f8-52f39b3b572a/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "slug": "biryani-_-biryani-and-kebab",
                            "meta_desc": "Biryani",
                            "meta_keyword": "Biryani",
                            "meta_title": "Biryani",
                            "status": 1,
                            "parent_id": 537,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e6a16b2b-4dc4-7af2-009c-52bed161b5d0/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d4b8c0ae-60cd-fb4f-4fba-5499ebb42941/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "msite_desc": "<p>Biryani<br></p>",
                            "subtitle": "Biryani",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ac8c7201-f2cd-52d8-e3db-8096330e084a/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2ff95d5a-456f-8a3a-35f7-47ffea41f49e/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/6587a694-e658-5b59-c49b-b059ca3c85c5/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fefe5d59-a0a1-6ac1-fbb3-4c1038a14405/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "created_at": "2023-06-15T15:43:56.000Z",
                            "updated_at": "2023-06-15T15:43:56.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/76699906-4ab2-5039-f41f-3f731d122577/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/18b72a27-9cca-e412-abba-44498d9dbc7f/original/Hyderabadi-Chicken-Biryani_264x204Artboard-1_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 8,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 541,
                            "cat_name": "Combos_Biryani and Kebab",
                            "cat_desc": "                                                    Combos                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f2824086-35d7-67ac-16f8-396c4978059c/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "slug": "combos_biryani-and-kebab-24fd257f-d084-44df-bb53-bdbf9cb1ce3",
                            "meta_desc": "Combos",
                            "meta_keyword": "Combos",
                            "meta_title": "Combos",
                            "status": 1,
                            "parent_id": 537,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/22f0c2b3-bd38-9983-1859-c7e2967d7da1/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d1bfc651-0498-2fa9-dfcc-2b34668c07e3/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "msite_desc": "                                                    <p>Combos<br></p>",
                            "subtitle": "Combos",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7f8a2f1e-bda8-7feb-c0aa-86c78211ecb3/original/Assorted_Kebab_platter_264x204_(1).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/23b15621-1611-7e26-fb4b-a1ca1a46984c/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/29253c26-d659-c39e-6a66-ee431a73e2f0/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8d62e719-25f7-04b9-3737-dae3047684d0/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "created_at": "2023-06-15T15:48:34.000Z",
                            "updated_at": "2023-06-27T05:40:42.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e86aa583-d051-326b-57d9-b3a289e68259/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/786d8c70-7654-3162-4dfb-4a2a2f5dfcc8/original/Assorted_Kebab_platter_264x204_(1)_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 8,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 19,
                    "cat_name": "Cold Cuts",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Delicious fresh and delectable, gluten-free salamis and sausages for the perfect pick-me-up breakfast to keep you going through the day\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/c2d7a1ca-e60c-9f2a-152e-359026f9fdd5/original/1704969145715.png",
                    "slug": "breakfast",
                    "meta_desc": "Looking for cold cut meat online in india? Licious offers different types of cold cuts and lunch meat prepared from 100% fresh ingredients and high grade meats. Order now!",
                    "meta_keyword": "lunch meat, cold cuts, cold meats, types of cold cuts, best cold cuts, buy lunch meat online, order cold cuts online, salami, sausages",
                    "meta_title": "Buy Fresh Cold Cuts Online | Salami and Sausages - Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/894f6c43-d07c-4ba9-2c7d-e53c53ef2e14/original/1704969151486.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/d0410ccc-2718-67ac-f785-20ea31200a84/original/1704969148643.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Delicious fresh and delectable, gluten-free salamis and sausages for the perfect pick-me-up breakfast to keep you going through the day",
                    "subtitle": "Cold Cuts",
                    "popular": 1,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/15202633-0a4b-12a9-3e62-17dbb293567b/original/1704969154682.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/fa4efeab-4a22-401b-fda3-51f2456d108f/original/1704969157712.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/8a0997fe-6e24-1d34-e9ba-a9a7b10bab26/original/1704969160667.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/730249f1-2292-0b61-7aa4-9c106d9e74d7/original/1704969163759.png",
                    "created_at": "2017-02-08T12:58:16.000Z",
                    "updated_at": "2024-04-22T03:54:36.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/1ee1449a-e4c0-3944-26bf-d6b14d9d0697/original/1704969132785.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/8e74fa39-e7a8-9eae-36a0-1edb95d8c5a2/original/1704969139117.png",
                    "l0_subtext": "Crafted by master chefs",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 9,
                    "sub_categories": [
                        {
                            "id": 95,
                            "cat_name": "Sausages_Cold_Cuts",
                            "cat_desc": "                                                                                                        Sausages                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/b6d8da3d-9309-8d03-73bd-bffd694f986f/original/3_264x204_(3).png",
                            "slug": "sausages_cold_cuts",
                            "meta_desc": "Sausages",
                            "meta_keyword": "Sausages",
                            "meta_title": "Sausages",
                            "status": 1,
                            "parent_id": 19,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/02b688cd-f142-4a26-066d-40790245ab5a/original/3_264x204_(3).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ebe544a9-27d8-c727-0471-cd38321e0ad2/original/3_264x204_(3).png",
                            "msite_desc": "                                                                                                        <p>Sausages<br></p>",
                            "subtitle": "Sausages",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7586d527-ecfe-ec98-fbba-c9f4ccd80216/original/3_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9098a414-7987-5215-b8ae-b0c72e1ccf88/original/3_264x204_(3).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ec46849c-d760-ae2b-73be-02db23cb7c0a/original/3_264x204_(3).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d3dd2fc2-7cd0-05c8-1650-9bb49a7d7e0d/original/3_264x204_(3).png",
                            "created_at": "2022-05-19T18:42:52.000Z",
                            "updated_at": "2023-06-27T05:35:29.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/24c03e48-524a-59d7-2d90-142452db132e/original/3_264x204_(3).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/18664e95-f016-9b7f-5ea8-45e92c8445a8/original/3_264x204_(3).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 9,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 97,
                            "cat_name": "Frankfurters",
                            "cat_desc": "                                                                                                        <span style=\"font-family: Arial; white-space: pre-wrap;\">Frankfurters</span>                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a1603508-3c79-d8ab-4368-bf9e2f270f4c/original/4_264x204_(1).png",
                            "slug": "frankfurters",
                            "meta_desc": "Frankfurters",
                            "meta_keyword": "Frankfurters",
                            "meta_title": "Frankfurters",
                            "status": 1,
                            "parent_id": 19,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/917aa1cd-f3fc-ff0d-79eb-86bbd9319d30/original/4_264x204_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/47b00cad-d16f-65cc-55ca-c55c8e5e158d/original/4_264x204_(1).png",
                            "msite_desc": "                                                                                                        <p><span style=\"font-family: Arial; white-space: pre-wrap;\">Frankfurters</span><br></p>",
                            "subtitle": "Frankfurters",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a9eda532-d930-df47-a76b-64b06dde7319/original/4_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1de64c10-a12a-b274-9ed9-913f5f7c0a2e/original/4_264x204_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c3837e65-1e50-e35d-ba9e-f5491276c354/original/4_264x204_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e2122e10-51b0-afa4-0dde-73aa2ba7bdbd/original/4_264x204_(1).png",
                            "created_at": "2022-05-19T18:44:07.000Z",
                            "updated_at": "2023-06-27T05:36:43.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/141e7a20-4ef6-e3a3-f1ca-83b0998b2633/original/4_264x204_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fe9c9135-0aa7-9308-493f-747c35fb3fb9/original/4_264x204_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 9,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 98,
                            "cat_name": "Lyoners",
                            "cat_desc": "                                                                                                        <span style=\"font-family: Arial; white-space: pre-wrap;\">Lyoners</span>                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8212224c-2e03-8d47-2a6b-8917216f49b0/original/1_264x204_(1).png",
                            "slug": "lyoners",
                            "meta_desc": "Lyoners",
                            "meta_keyword": "Lyoners",
                            "meta_title": "Lyoners",
                            "status": 1,
                            "parent_id": 19,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7b56dd58-0cc8-0dd6-10bf-1ae3c611b997/original/1_264x204_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fd7ac56e-be55-caa3-a923-7543441988f7/original/1_264x204_(1).png",
                            "msite_desc": "                                                                                                        <p><span style=\"font-family: Arial; white-space: pre-wrap;\">Lyoners</span><br></p>",
                            "subtitle": "Lyoners",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/29234087-0428-3c5a-5cc0-697108253d20/original/1_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/cc0c6926-718c-03af-ee00-7ae40332444a/original/1_264x204_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/480ea808-690a-8e54-ffd5-7c0b10883ec2/original/1_264x204_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e1368759-729b-4a99-3d4b-e1d81a45dccd/original/1_264x204_(1).png",
                            "created_at": "2022-05-19T18:45:38.000Z",
                            "updated_at": "2023-06-27T05:37:46.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/923a9bbf-b1b2-8e24-f22f-740825550948/original/1_264x204_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d436cee5-171f-47ab-3177-0252bba0ed0c/original/1_264x204_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 9,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 99,
                            "cat_name": "Salamis",
                            "cat_desc": "                                                                                                        <span style=\"font-family: Arial; white-space: pre-wrap;\">Salamis</span>                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/30172f3c-5498-6168-b176-3b27a4b65d04/original/2_264x204_(2).png",
                            "slug": "salamis",
                            "meta_desc": "Salamis",
                            "meta_keyword": "Salamis",
                            "meta_title": "Salamis",
                            "status": 1,
                            "parent_id": 19,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f9f06d2c-2257-242c-3575-914eb909fd3c/original/2_264x204_(2).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4738793e-185a-a86d-6e88-6ce3278e48d4/original/2_264x204_(2).png",
                            "msite_desc": "                                                                                                        <p><span style=\"font-family: Arial; white-space: pre-wrap;\">Salamis</span><br></p>",
                            "subtitle": "Salamis",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a4d6353c-2939-99e8-047f-465443008048/original/2_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/faba3271-fe0e-50ea-4400-a623b2fb0447/original/2_264x204_(2).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a24ad5de-2c32-52c7-90e9-6f50ea4a3033/original/2_264x204_(2).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/755c9d2b-a6f3-f30d-589f-78fa958c9315/original/2_264x204_(2).png",
                            "created_at": "2022-05-19T18:49:55.000Z",
                            "updated_at": "2023-06-27T05:38:54.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4c8f64ee-a275-2df6-e25b-ba4b8dae9650/original/2_264x204_(2).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/df19b00b-fa0c-923f-2b88-6b31364895f0/original/2_264x204_(2).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 9,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 892,
                            "cat_name": "Ready to Cook - Cold Cuts",
                            "cat_desc": "                                                                                                                                                            Ready to Cook                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/52b544ea-b5b4-7a76-729c-559d6cbc96b4/original/1709026427786.png",
                            "slug": "ready-to-cook-cold-cuts",
                            "meta_desc": "Ready to Cook",
                            "meta_keyword": "Ready to Cook",
                            "meta_title": "Ready to Cook",
                            "status": 1,
                            "parent_id": 19,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/1489371c-ecfa-8ef1-ca87-77094949baed/original/1709026424356.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/2598df32-3817-2680-7bdb-6404e519e0ce/original/1709026429614.png",
                            "msite_desc": "                                                                                                                                                            <p>Ready to Cook<br></p>",
                            "subtitle": "Breakfast Specials",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/34dd424b-a279-a173-61f1-d927ee86c844/original/1709026436673.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/611beda5-c9be-c9fd-7722-24be06c550d8/original/1709026438236.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/ba144d7b-9ecd-4c5e-2f32-c565825b626b/original/1709026439434.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/90346971-5fc6-869e-a24f-f0801fb0423d/original/1709026435250.png",
                            "created_at": "2024-02-27T09:34:14.000Z",
                            "updated_at": "2024-02-28T00:02:24.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/0362b6d1-a69a-1a86-9989-93e7e4398e1a/original/1709026422676.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/0b99ee4b-c33b-7674-1dcd-908d647643a6/original/1709026426315.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 9,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 20,
                    "cat_name": "Spreads",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                Chunky spreads made from fresh meats with all-natural ingredients. Strictly no preservatives, just handmade goodness. Your perfect accompaniment for every meal.\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/f601d954-a69b-8128-60f2-2194695a7ac6/original/1704968973586.png",
                    "slug": "spreads",
                    "meta_desc": "Looking for good quality chicken spread online? Order on Licious and choose from a variety of delicious, fresh and the chunkiest chicken spreads. Order now!",
                    "meta_keyword": "chicken spread, chicken spread online, spreads, chunky chicken spread",
                    "meta_title": "Buy Tasty Chicken Spread With Fresh Meat Chunks Online On Licious",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/cf13a412-3f09-263e-1ace-06652a968936/original/1704968980564.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/2bdc197e-cb7f-e018-8589-4a11bd4b833f/original/1704968976963.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                Chunky spreads made from fresh meats with all-natural ingredients. Strictly no preservatives, just handmade goodness. Your perfect accompaniment for every meal.",
                    "subtitle": "Spreads",
                    "popular": 1,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/e261dfb3-2aae-5849-56db-9ed0e468fa95/original/1704968983727.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/ec0bd4be-e98f-2b4a-c534-a067026c32ee/original/1704969049843.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/dcb18429-712a-e18a-0c92-b1006537e955/original/1704969053178.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/14d1b5ab-d12c-a335-bd51-5ec8bc171d95/original/1704969056482.png",
                    "created_at": "2017-02-08T13:12:40.000Z",
                    "updated_at": "2024-04-22T03:55:19.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/0c3e7fae-989a-fff9-d9a8-5fca8d2af4c0/original/1704968961350.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/ae61ada6-1118-ed39-4c42-2103f987eada/original/1704968969447.png",
                    "l0_subtext": "No artificial preservatives",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 10,
                    "sub_categories": [
                        {
                            "id": 92,
                            "cat_name": "Chicken_Spreads",
                            "cat_desc": "                                                                                                        Chicken_Spreads                                                                                                        \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/63964494-babb-992b-d672-be43227b90da/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "slug": "chicken_spreads",
                            "meta_desc": "Chicken",
                            "meta_keyword": "Chicken",
                            "meta_title": "Chicken",
                            "status": 1,
                            "parent_id": 20,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9c140d49-0622-dbb6-004e-c4b7b787a325/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/b91e77ee-3a31-325e-b683-f78b1a6666dd/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "msite_desc": "                                                                                                        Chicken_Spreads                                                                                                        <p></p>",
                            "subtitle": "Chicken",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a80758a4-bbfd-6e64-c215-25aa44eb36ba/original/Chunky_Butter_Chicken_264x204_(1).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/81ceec69-5277-00a4-ee1f-ad296cc887f1/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7dd83b71-8e12-03b8-60a6-2daf38f1cfb3/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f91ae64d-6345-37f0-f4ef-6b2243ffd70e/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "created_at": "2022-05-19T18:38:41.000Z",
                            "updated_at": "2023-06-27T05:41:49.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f4ba6869-ed07-a206-c135-926bdf7be114/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8bb8203a-f7f2-737e-0795-b7db3827af62/original/Chunky_Butter_Chicken_264x204_(1)_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 10,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 94,
                            "cat_name": "Egg_Spreads",
                            "cat_desc": "                                                                                                                                                            Egg_Spreads                                                                                                        \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a79ffe24-1d3a-c53b-4186-06c846bcbefd/original/Chunky_Continental_Egg_264x204_(1).png",
                            "slug": "egg_spreads",
                            "meta_desc": "Egg",
                            "meta_keyword": "Egg",
                            "meta_title": "Egg",
                            "status": 1,
                            "parent_id": 20,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c988653d-57a1-9d26-41d2-2557a67c357b/original/Chunky_Continental_Egg_264x204_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9ce08d45-55a4-281a-6121-be3733ac6491/original/Chunky_Continental_Egg_264x204_(1).png",
                            "msite_desc": "                                                                                                                                                            Egg_Spreads                                                                                                        <p></p>",
                            "subtitle": "Egg",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/dc5ff1e5-22d6-d171-76e6-7e3e51481c13/original/Chunky_Continental_Egg_264x204_(1).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/f2cda731-5612-0174-2e40-b1ac80910a40/original/Chunky_Continental_Egg_264x204_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/cf8ba05b-5065-2fd1-1cb3-1476ec050932/original/Chunky_Continental_Egg_264x204_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/6b0781f3-806c-3ffc-9ac2-6a79b338af85/original/Chunky_Continental_Egg_264x204_(1).png",
                            "created_at": "2022-05-19T18:41:24.000Z",
                            "updated_at": "2023-06-27T05:42:53.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c3305566-21b4-378d-d799-9cb51402086d/original/Chunky_Continental_Egg_264x204_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9ab4d14c-0750-a9a5-90a4-f7480928e58c/original/Chunky_Continental_Egg_264x204_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 10,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 96,
                            "cat_name": "Combos_Spreads",
                            "cat_desc": "                                                                                                        Combos_Spreads                                                                                                        \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/45ff39fe-c2ac-d50e-5cc9-0ebcdc73c6f5/original/sample-imgspreads-combo_(1)_(2).png",
                            "slug": "combos_spreads",
                            "meta_desc": "Combos",
                            "meta_keyword": "Combos",
                            "meta_title": "Combos",
                            "status": 1,
                            "parent_id": 20,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3d0d78ff-d002-5f16-b81e-0385d6d951d2/original/sample-imgspreads-combo_(1)_(2).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e188d8a2-453e-1dc1-a586-7f42ccb05679/original/sample-imgspreads-combo_(1)_(2).png",
                            "msite_desc": "                                                                                                        Combos_Spreads                                                                                                        <p></p>",
                            "subtitle": "Combos",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3417559a-885d-6370-2236-d5c61d253dca/original/sample-imgspreads-combo_(1).png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8265293c-556c-1888-c7ab-e983126b172d/original/sample-imgspreads-combo_(1)_(2).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/101ad18b-ed1d-233b-9e52-f5436b024638/original/sample-imgspreads-combo_(1)_(2).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0de13ae0-56b0-4fd8-22f8-5eac9fffb404/original/sample-imgspreads-combo_(1)_(2).png",
                            "created_at": "2022-05-19T18:42:54.000Z",
                            "updated_at": "2023-06-27T05:44:09.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/dbf4cd7b-e95a-06b4-ae0d-206e8bbf2ed1/original/sample-imgspreads-combo_(1)_(2).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/93b52628-7dc8-29c6-0740-bfac15fb5e03/original/sample-imgspreads-combo_(1)_(2).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 10,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 893,
                            "cat_name": "Ready to Cook - Spreads",
                            "cat_desc": "                                                                                                        Ready to Cook                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/9490d4a2-9f74-9f78-6038-12b9a7d779f9/original/1709026656020.png",
                            "slug": "ready-to-cook-spreads",
                            "meta_desc": "Ready to Cook",
                            "meta_keyword": "Ready to Cook",
                            "meta_title": "Ready to Cook",
                            "status": 1,
                            "parent_id": 20,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/af901f40-7843-a51a-62ff-5f0770fe0bb1/original/1709026650188.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/af0fafff-a952-6b40-8f60-8e42bdae9811/original/1709026652907.png",
                            "msite_desc": "                                                                                                        <p>Ready to Cook<br></p>",
                            "subtitle": "Breakfast Specials",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/56f9f46e-c9be-81b1-fb83-977883b12ddd/original/1709026661724.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/52eff02d-097a-1e42-008e-735d4f62b49d/original/1709026665180.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/682410be-c506-2e59-2372-ecb8d639ca12/original/1709026667377.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/88e8712e-15a3-a4fa-8d63-61551f96d982/original/1709026663248.png",
                            "created_at": "2024-02-27T09:39:54.000Z",
                            "updated_at": "2024-02-27T07:08:30.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/0a087971-8bc2-b6f1-208c-e0253ad73a2d/original/1709026648633.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/c98dcf87-3e58-e9b8-dc23-4b062b8500a0/original/1709026654670.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 10,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 297,
                    "cat_name": "Meat Masala",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <span style=\"color: rgb(29, 28, 29); font-family: Slack-Lato, Slack-Fractions, appleLogo, sans-serif; font-size: 15px; font-variant-ligatures: common-ligatures; background-color: rgb(248, 248, 248);\">The Perfect Match for all meat recipes</span>\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/5d0aec03-956e-73f4-9a18-5124f725954c/original/Masala_1.png",
                    "slug": "masalas",
                    "meta_desc": "Order 100% Fresh Meats @Licious. Home Delivered in 120 mins.",
                    "meta_keyword": "licious chicken, licious fish, today's offers, free delivery, chicken online",
                    "meta_title": "Buy Fresh Meats & Seafood @best price | masalas",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/4ad0a144-8830-a4b5-90ee-216753328bbd/original/Masala_1.png",
                    "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/bb3ecdd5-07db-8d23-dfa5-1f186828f209/original/Masala_1.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <span style=\"color: rgb(29, 28, 29); font-family: Slack-Lato, Slack-Fractions, appleLogo, sans-serif; font-size: 15px; font-variant-ligatures: common-ligatures; background-color: rgb(248, 248, 248);\">The Perfect Match for all meat recipes</span><p></p>",
                    "subtitle": "Meat Masala",
                    "popular": 1,
                    "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/98a5efd1-41d2-32f5-d3a2-ade13a8a2e57/original/Masala_1.png",
                    "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/cc8210cc-843d-07e8-d022-9867f450ead4/original/Masala_1.png",
                    "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e18763b6-5e6a-ec04-29b2-b1aa18e5b9a7/original/Masala_320x320.png",
                    "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/231614a2-42f2-2d3b-25aa-3cc88fa0e947/original/Masala_320x320.png",
                    "created_at": "2022-11-15T09:46:42.000Z",
                    "updated_at": "2024-04-22T04:02:12.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/5bac1e68-95e2-741b-f634-ff99a48cc6bd/original/Masala_1.png",
                    "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d46a2142-8e36-729a-3256-d1d2dcd8c1c6/original/Masala_1.png",
                    "l0_subtext": "The Perfect Match for all meat recipes",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 11,
                    "sub_categories": [
                        {
                            "id": 312,
                            "cat_name": "Combo_Blended Masala_",
                            "cat_desc": "                                                                                                                                                                                                                                                                    Combo                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e4a0f3f2-4c22-7e7c-752a-6d942b1c21eb/original/sample-imgMasala-combo_(1).png",
                            "slug": "chicken-masala_blended-masala",
                            "meta_desc": "Combo",
                            "meta_keyword": "Combo",
                            "meta_title": "Combo",
                            "status": 1,
                            "parent_id": 297,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fc67f6bb-3823-499d-615b-4c9967d4a34e/original/sample-imgMasala-combo_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/6e0cca03-60ba-4894-9b6d-82428fbb73e5/original/sample-imgMasala-combo_(1).png",
                            "msite_desc": "                                                                                                                                                                                                                                                                    <p>Combo<br></p>",
                            "subtitle": "Combos",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/933da611-c650-d2a5-609e-92e6ab59a3eb/original/sample-imgMasala-combo.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/61963389-2c00-8fc4-032b-8f5a13f0dff7/original/sample-imgMasala-combo_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/99734bde-bb53-0a9e-e41a-f28e34d79d95/original/sample-imgMasala-combo_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/bc16c18b-635c-6f5e-6502-a802b0d9cadf/original/sample-imgMasala-combo_(1).png",
                            "created_at": "2022-11-24T17:39:16.000Z",
                            "updated_at": "2023-06-27T05:45:44.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/560c5299-c7f4-feee-aa8a-38f8c65b5acf/original/sample-imgMasala-combo_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9ed1fc7e-26bd-2c85-64cb-93941688b23c/original/sample-imgMasala-combo_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 11,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 313,
                            "cat_name": "Chicken Masala_Blended Masala_",
                            "cat_desc": "                                                                                                                                                                                                                Chicken                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e31e3b90-14e9-1ce0-c752-33ffb4f22e72/original/Classic_chicken_masala_264x204.png",
                            "slug": "mutton-masala_blended-masala",
                            "meta_desc": "Chicken",
                            "meta_keyword": "Chicken",
                            "meta_title": "Chicken",
                            "status": 1,
                            "parent_id": 297,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/455e2826-7de8-5659-d05d-6b3d2bdfdc97/original/Classic_chicken_masala_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2ff631ca-627e-0eba-b12b-777c68216725/original/Classic_chicken_masala_264x204.png",
                            "msite_desc": "                                                                                                                                                                                                                <p>Chicken<br></p>",
                            "subtitle": "Chicken",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/76875787-f3e3-8948-5f08-59629c79f028/original/Classic_chicken_masala_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/360c1e98-62c4-fe7c-61ee-fc8db821cf9c/original/Classic_chicken_masala_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/b53b5f55-5089-599c-2886-1396fc458e05/original/Classic_chicken_masala_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/92c713a9-025b-7ed4-1d6f-280b3b80daea/original/Classic_chicken_masala_264x204.png",
                            "created_at": "2022-11-24T17:43:05.000Z",
                            "updated_at": "2023-06-27T05:46:45.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/425fca73-0acd-f832-2f57-acd46b11c5e3/original/Classic_chicken_masala_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/78f9d571-d4ea-cdb3-705a-530ae70b12c3/original/Classic_chicken_masala_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 11,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 314,
                            "cat_name": "Meat Masala_Blended Masala",
                            "cat_desc": "                                                                                                                                                                                                                                                                                                                        Mutton                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0effa84d-df29-ffa1-5764-dab2324b269a/original/Classic_meat_masala_264x204.png",
                            "slug": "fish-masala_blended-masala",
                            "meta_desc": "Mutton Masala",
                            "meta_keyword": "Mutton Masala",
                            "meta_title": "Mutton Masala",
                            "status": 1,
                            "parent_id": 297,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a755e940-7a58-58ca-527a-693fc124f5c5/original/Classic_meat_masala_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3d88b672-2f40-efff-900c-5c7690710530/original/Classic_meat_masala_264x204.png",
                            "msite_desc": "                                                                                                                                                                                                                                                                                                                        <p>Mutton<br></p>",
                            "subtitle": "Mutton",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/650210ec-638e-2d05-1a9b-3ce4bed4275a/original/Classic_meat_masala_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/84c3b416-9145-02db-5faf-fca073cf6e8b/original/Classic_meat_masala_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/b58cfba5-4c19-dc6a-15c4-d89ccf7fe243/original/Classic_meat_masala_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ba52753b-d470-c3bf-4c7d-068a252df571/original/Classic_meat_masala_264x204.png",
                            "created_at": "2022-11-24T17:46:56.000Z",
                            "updated_at": "2023-06-27T05:48:00.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fa7e1154-c005-c14a-6e13-24de970f8cd3/original/Classic_meat_masala_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1a104c34-e481-f341-6928-36833032a072/original/Classic_meat_masala_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 11,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 315,
                            "cat_name": "Fish Masala_Blended Masala",
                            "cat_desc": "                                                                                                                                                                                                                Fish                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d2693cb3-cc72-b4c5-4652-ed6edd8e03a4/original/Fish_Fry_264x204.png",
                            "slug": "all-purpose-masala_blended-masala",
                            "meta_desc": "Fish Masala",
                            "meta_keyword": "Fish Masala",
                            "meta_title": "Fish Masala",
                            "status": 1,
                            "parent_id": 297,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9ba43fc2-c554-bbf2-d816-34f77c5fbf12/original/Fish_Fry_264x204.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7e66fb7a-3587-f8f4-3434-f53fb8074bfa/original/Fish_Fry_264x204.png",
                            "msite_desc": "                                                                                                                                                                                                                <p>Fish<br></p>",
                            "subtitle": "Fish",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/09615d45-c2f0-418e-1f8a-85e5ccd2c135/original/Fish_Fry_264x204.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0e936038-981a-48c1-feb7-46875522c8d9/original/Fish_Fry_264x204.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8b8dbbf9-ce3b-6ebc-c883-f073ad411d34/original/Fish_Fry_264x204.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/489f5318-f91f-2556-9c75-aa82d5ff375d/original/Fish_Fry_264x204.png",
                            "created_at": "2022-11-24T17:51:31.000Z",
                            "updated_at": "2023-06-27T05:49:14.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/10935231-415d-24af-d35d-0d6101269fa2/original/Fish_Fry_264x204.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/ead7fb0a-1aa5-6dbb-7666-2cf166e071f4/original/Fish_Fry_264x204.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 11,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 316,
                            "cat_name": "All Purpose Masala_Blended Masala__",
                            "cat_desc": "                                                                                                        <div>All Purpose Masala</div><div><br></div>\n                                                \n                                                ",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/38e7e06c-606a-83d5-a3da-a46a7c62ff08/original/sample-imgall-purpose-masala_(1).png",
                            "slug": "combo_blended-masala",
                            "meta_desc": "All Purpose Masala",
                            "meta_keyword": "All Purpose Masala",
                            "meta_title": "All Purpose Masala",
                            "status": 1,
                            "parent_id": 297,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2872aa8d-fe0b-8a37-b618-00bc06ed41fc/original/sample-imgall-purpose-masala_(1).png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3bdc2983-96db-4424-2c9d-fc4a9f174ca4/original/sample-imgall-purpose-masala_(1).png",
                            "msite_desc": "                                                                                                                                                                                                                                                                                                                        <p>All Purpose Masala</p><div><br></div>",
                            "subtitle": "All Purpose ",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9e3b8d31-61be-15bb-0a3e-2946ea72faac/original/sample-imgall-purpose-masala.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e48f1aaa-285a-36ae-af33-b2390082c874/original/sample-imgall-purpose-masala_(1).png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/e23ac211-258b-abff-bcf9-acb010933a8d/original/sample-imgall-purpose-masala_(1).png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/36fda46c-930d-21f6-a69e-ec8c511c43b2/original/sample-imgall-purpose-masala_(1).png",
                            "created_at": "2022-11-24T17:55:03.000Z",
                            "updated_at": "2023-06-27T05:50:22.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/b63ba963-590a-31d6-c4b6-ed55de2ddb18/original/sample-imgall-purpose-masala_(1).png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a7491364-3a5c-5918-c734-15e81b37379a/original/sample-imgall-purpose-masala_(1).png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 11,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 270,
                    "cat_name": "Plant Based Meat",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <span style=\"color: rgb(32, 33, 36); font-family: Roboto, sans-serif; font-size: 14px; white-space: pre-wrap; background-color: rgba(32, 33, 36, 0.04);\">Plant Based Meat</span>\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/7ac36a29-ce88-050a-b5db-0e74338584bf/original/Uncrave.png",
                    "slug": "pbm",
                    "meta_desc": "Order 100% Fresh Plant Based Meat @Licious. Home Delivered in 120 mins.",
                    "meta_keyword": "licious Plant Based Meat , licious fish, today's offers, free delivery, chicken online",
                    "meta_title": "Buy Fresh Plant Based Meat @best price | Plant Based Meat",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/da303776-1989-e6a8-2113-74cf19d314d8/original/Uncrave.png",
                    "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/af1bae10-312c-9acf-7fba-2f5f50cccac7/original/Uncrave.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <p><span style=\"color: rgb(32, 33, 36); font-family: Roboto, sans-serif; font-size: 14px; white-space: pre-wrap; background-color: rgba(32, 33, 36, 0.04);\">Plant Based Meat</span><br></p>",
                    "subtitle": "Plant Based Meat",
                    "popular": 1,
                    "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/aaaf603f-5aa1-7b52-97b5-1da94469e62d/original/Uncrave.png",
                    "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/718e09cc-a0b8-003d-6fcb-021b4549c5e0/original/Uncrave.png",
                    "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/66e49926-d949-dfb3-2e79-8052d07f0a3b/original/PBM_6_(8).png",
                    "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0201ade0-47f0-136b-2d62-236336e9271c/original/PBM_6_(8).png",
                    "created_at": "2022-09-25T13:32:42.000Z",
                    "updated_at": "2024-04-22T04:01:06.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/d155882b-e23a-ff84-d1a1-9544ca9ea60d/original/Uncrave.png",
                    "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/244203b9-0335-17b1-299b-9176ba2a2ec5/original/Uncrave.png",
                    "l0_subtext": "All vegetarian but so meaty",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 15,
                    "sub_categories": [
                        {
                            "id": 401,
                            "cat_name": "Chick~n_PBM",
                            "cat_desc": "<span data-sheets-value=\"{",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2d23b034-a1fd-78f9-6341-17d9c1022507/original/new-chicken.png",
                            "slug": "chick~n_pbm",
                            "meta_desc": "Chick~n",
                            "meta_keyword": "Chick~n",
                            "meta_title": "Chick~n",
                            "status": 1,
                            "parent_id": 270,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c258eb39-be69-e321-f288-e1064ae43d67/original/new-chicken.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3bc76419-0eb9-cca4-21a9-e8eee14e0579/original/new-chicken.png",
                            "msite_desc": "<p><span data-sheets-value=\"{",
                            "subtitle": "Chick~n",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a13a7570-4669-33f9-628f-06d5b38d719d/original/new-chicken.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/bcad4d05-4912-8d61-c7ac-0d5101550071/original/new-chicken.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/72191d64-0148-b908-a147-faf6c21b8a1c/original/new-chicken.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9ed52473-2561-cbac-8c4e-7ff251878061/original/new-chicken.png",
                            "created_at": "2023-03-07T17:17:15.000Z",
                            "updated_at": "2023-03-07T17:17:15.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0919d147-1da6-6138-8bb7-23ba7a98cae8/original/new-chicken.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a690e736-e300-a138-12c3-e9190b0efcb7/original/new-chicken.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 15,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 402,
                            "cat_name": "Mutt~n_PBM",
                            "cat_desc": "<span data-sheets-value=\"{",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/002e1f8c-8f5e-bff5-4aec-53c9bae3dfd1/original/new-mutton.png",
                            "slug": "mutt~n_pbm",
                            "meta_desc": "Mutt~n",
                            "meta_keyword": "Mutt~n",
                            "meta_title": "Mutt~n",
                            "status": 1,
                            "parent_id": 270,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0e2cc927-e0ed-4285-3251-5bf83e6787ed/original/new-mutton.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/fe7b1a73-84a1-ad94-6734-abe78af81e12/original/new-mutton.png",
                            "msite_desc": "<p><span data-sheets-value=\"{",
                            "subtitle": "Mutt~n",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/cbeda390-cb5b-3c6e-2270-3701e70f7868/original/new-mutton.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/5779381c-6ea4-e5ec-ee31-0c8b8fbc5973/original/new-mutton.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/2ade00f2-2712-5e7e-cf82-a5fb289b8e14/original/new-mutton.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/c4e577e0-6bfd-c4bf-a0c2-842fc397cd26/original/new-mutton.png",
                            "created_at": "2023-03-07T17:19:12.000Z",
                            "updated_at": "2023-03-07T17:19:12.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/84907548-520f-fa17-e075-cd365e159910/original/new-mutton.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/9034d5ef-af7a-18a2-d699-230ad0c37505/original/new-mutton.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 15,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 403,
                            "cat_name": "Trial Packs_PBM",
                            "cat_desc": "<span data-sheets-value=\"{",
                            "cat_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/6ba4659b-326d-8d78-a5cc-e20b0e787d2d/original/single-serve.png",
                            "slug": "trial-packs_pbm",
                            "meta_desc": "Trial Packs",
                            "meta_keyword": "Trial Packs",
                            "meta_title": "Trial Packs",
                            "status": 1,
                            "parent_id": 270,
                            "cat_web_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/b98c2858-8404-2ff5-2dc1-043b7c38a665/original/single-serve.png",
                            "cat_tile_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0b86809f-ee2c-8267-59a6-f1daf9a4cabd/original/single-serve.png",
                            "msite_desc": "<p><span data-sheets-value=\"{",
                            "subtitle": "Trial Packs",
                            "popular": 0,
                            "mobile_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a7a3a68d-3cba-0670-ecd4-e7fb0afd27c7/original/single-serve.png",
                            "mobile_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/a2fbb285-5535-6cb9-3776-82882988974e/original/single-serve.png",
                            "web_icon": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/3a54af2d-272f-ca77-cae3-affd84694b90/original/single-serve.png",
                            "web_icon_active": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/0d645cd5-5bd9-2046-94b7-dd07049d307d/original/single-serve.png",
                            "created_at": "2023-03-07T17:21:04.000Z",
                            "updated_at": "2023-03-07T17:21:04.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/8edc5807-4409-a82d-65ba-9ed94c99f8b4/original/single-serve.png",
                            "category_nav_page_img": "https://dao54xqhg9jfa.cloudfront.net/OMS-Category/1366f885-9b27-847d-f817-22090cb072fa/original/single-serve.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 15,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 864,
                    "cat_name": "Daily Fish Delights",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <span style=\"color: rgb(31, 31, 31); font-family: \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/9b8da6c8-15bb-75ed-467c-53c7fab7d28c/original/1713945380414.png",
                    "slug": "daily-fish-delights",
                    "meta_desc": "Daily Fish Delights",
                    "meta_keyword": "Daily Fish Delights",
                    "meta_title": "Daily Fish Delights",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/73126fac-87f2-63d0-de5d-bdff6ab906d2/original/1713945390042.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/4adb9d6f-4d3b-c6c1-054d-633d26bdad56/original/1713945385010.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <p><span style=\"color: rgb(31, 31, 31); font-family: ",
                    "subtitle": "Daily Fish Delights",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/05cdbae0-64cb-df36-96c5-bede9e6cab4b/original/1713945394351.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/64d7e159-f557-1c83-cc55-8418ce9170a5/original/1713945398595.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/441c385f-568b-1861-f5ed-36814307264f/original/1713945402923.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/6a251075-be88-012c-b6f2-cad26dba3863/original/1713945406094.png",
                    "created_at": "2024-02-05T11:25:03.000Z",
                    "updated_at": "2024-04-24T02:26:54.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/92800d87-5366-2de2-03c8-b5b71554540d/original/1713945371056.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/cfbb1c9e-ffc1-26fd-0996-f47ff0cae38f/original/1713945374606.png",
                    "l0_subtext": "Curated selection of everyday seafood staples",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 100,
                    "sub_categories": [
                        {
                            "id": 865,
                            "cat_name": "Scrumptious Curries",
                            "cat_desc": "                                                                                                        Scrumptious Curries                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/bad0029e-0e42-f1ac-f80d-91a42352cf0e/original/1707132453281.png",
                            "slug": "scrumptious-curries",
                            "meta_desc": "Scrumptious Curries",
                            "meta_keyword": "Scrumptious Curries",
                            "meta_title": "Scrumptious Curries",
                            "status": 1,
                            "parent_id": 864,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/b0fcbcdc-5573-5e7f-92e8-11a465ded4e6/original/1707132449545.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/ed06aed5-0ce4-6846-0c58-eb59245e3def/original/1707132451584.png",
                            "msite_desc": "                                                                                                        <p>Scrumptious Curries<br></p>",
                            "subtitle": "For Curries",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/376c12b2-a079-5048-581d-c97ddbd76d3e/original/1707132468653.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/1c496578-7b3c-3133-659d-9d031e39b360/original/1707132467135.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/f703871c-2caa-6ddf-8178-3391c1be30dc/original/1707132465474.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/b30b9020-c456-173d-a2b4-244a7af1080f/original/1707132463995.png",
                            "created_at": "2024-02-05T11:28:06.000Z",
                            "updated_at": "2024-02-14T12:06:26.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/d776f3f1-efa8-2e82-a4da-4bc369c8e435/original/1707132456266.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/a077c40d-0a15-88b5-a831-3dcc63bcfef7/original/1707132454942.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 100,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 866,
                            "cat_name": "Fish Fries",
                            "cat_desc": "                                                    <span style=\"color: rgb(31, 31, 31); font-family: \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/5b37502b-bf72-f37b-362b-57feced51995/original/1707132604332.png",
                            "slug": "fish-fries",
                            "meta_desc": "Fish Fries",
                            "meta_keyword": "Fish Fries",
                            "meta_title": "Fish Fries",
                            "status": 1,
                            "parent_id": 864,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/bfdf0b89-305d-ee9b-e17b-dd71a30c9174/original/1707132599491.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/9b9cc078-84b7-7c07-a621-4781f805fbfe/original/1707132601473.png",
                            "msite_desc": "                                                    <p><span style=\"color: rgb(31, 31, 31); font-family: ",
                            "subtitle": "For Fish Fries",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/3335538a-c0b4-145b-7b97-3fc6ada2ea09/original/1707132620718.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/9880bb00-4a04-05f6-58f7-fd122a385dcb/original/1707132619125.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/b2bd32f1-f3e2-ab8f-20af-9270cd8b6d07/original/1707132617401.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/9056aad6-03f7-c7bb-1c4f-bb122921c598/original/1707132615704.png",
                            "created_at": "2024-02-05T11:30:38.000Z",
                            "updated_at": "2024-02-06T02:41:31.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/e6f06972-2005-3610-51b1-49f39ab5bbc8/original/1707132607561.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/f40b1df9-899c-b454-3d45-685a611088e7/original/1707132606018.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 100,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 867,
                            "cat_name": "First time eats",
                            "cat_desc": "                                                                                                        First time eats                                                                                                                                                                                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/2a998a3e-b55e-10fc-49d9-3ab6a870f34b/original/1708513745923.png",
                            "slug": "gourmet-meals",
                            "meta_desc": "First time eats",
                            "meta_keyword": "First time eats",
                            "meta_title": "First time eats",
                            "status": 1,
                            "parent_id": 864,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/955e251e-bb52-df6a-dd83-b8106499d970/original/1708513749267.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/9a473982-5dca-74dc-1e92-f6fe7cfbbd98/original/1708513747615.png",
                            "msite_desc": "                                                                                                        First time eats                                                                                                                                                                                                                <p></p>",
                            "subtitle": "First Time Eats",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/0b7b7df9-b8c0-2e35-808f-204f91a7f264/original/1708513751297.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/af609f41-8ebe-516d-caac-14198327ce9d/original/1708513744076.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/27ebabde-e50a-cbae-6906-42069be4e9ed/original/1708513758834.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/d2f242c0-de8d-7dff-3111-37bd6817c420/original/1708513762617.png",
                            "created_at": "2024-02-05T11:33:11.000Z",
                            "updated_at": "2024-02-21T05:50:16.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/5ee874dd-ed48-a0bd-cea5-0a513315f6b0/original/1708513739864.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/0ceb34a2-0bc9-547c-5136-f3acccb3345a/original/1707132732926.png",
                            "l0_subtext": "For Gourmet Meals",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 100,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 868,
                            "cat_name": "Healthy Bites",
                            "cat_desc": "                                                    <span style=\"color: rgb(31, 31, 31); font-family: \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/7eb9787d-7c31-a97c-414d-384203a4b46e/original/1707132974755.png",
                            "slug": "healthy-bites",
                            "meta_desc": "Healthy Bites",
                            "meta_keyword": "Healthy Bites",
                            "meta_title": "Healthy Bites",
                            "status": 1,
                            "parent_id": 864,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/429c2e27-504f-c995-e388-c46842a4b7c4/original/1707132978689.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/c7f1b6d0-56c4-ef56-5b2f-d785f6191562/original/1707132976430.png",
                            "msite_desc": "                                                    <p><span style=\"color: rgb(31, 31, 31); font-family: ",
                            "subtitle": "For Healthy Bites",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/d89839aa-880e-b3b7-3257-527712bd46dc/original/1707132991041.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/325c3a15-8676-33bd-20c4-2442d956e40e/original/1707132989532.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/021b402b-ab51-1fe5-cbe6-551bd96ac18a/original/1707132988017.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/d2fa47d9-1cdc-4f2a-1888-67693eb50fba/original/1707132986531.png",
                            "created_at": "2024-02-05T11:37:12.000Z",
                            "updated_at": "2024-02-06T02:42:19.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/ca7274a0-af9d-0793-c716-8142968896ad/original/1707132971572.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/64b722f7-352a-efc3-74af-4016dc89e4a4/original/1707132972850.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 100,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 860,
                    "cat_name": "Kids Favourites",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Kids Favourites\n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/47e8954f-99bc-2ecc-25b0-507f7b52f6d7/original/1713944960366.png",
                    "slug": "kids-favourites-snacking",
                    "meta_desc": "Kids Favourites - Snacking",
                    "meta_keyword": "Kids Favourites - Snacking",
                    "meta_title": "Kids Favourites - Snacking",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/b0f45123-091a-06ed-0ff6-315e54e556ec/original/1713944974798.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/d8a336b1-570e-022e-250e-163ce2f342fb/original/1713944970409.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <p>Kids Favourites<br></p>",
                    "subtitle": "Kids Favourites",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/fd0a3fa7-a1e8-29e7-5cee-ee023e97ff36/original/1713944978994.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/ac3b9645-4504-7724-45b2-3f95b0165aa6/original/1713944983222.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/0175ac17-4438-0bee-b08d-082bccc55068/original/1713944988091.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/21bed17c-bf04-5071-9c20-149cf6e8f5ce/original/1713944992705.png",
                    "created_at": "2024-02-05T10:19:54.000Z",
                    "updated_at": "2024-06-02T14:36:46.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/1a300f2c-53ea-0660-ee92-d4126ed8d891/original/1713944954682.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/0dc18428-841d-127a-c5da-e01036e19388/original/1713944964414.png",
                    "l0_subtext": "Mild flavoured & kid palate friendly",
                    "is_old_flow": 0,
                    "is_tree_flow": 1,
                    "order": 101,
                    "sub_categories": [
                        {
                            "id": 861,
                            "cat_name": "Snacking",
                            "cat_desc": "                                                                                                                                                                                                                                                                                                                        Kids Favourites - Breakfast                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/a7a04357-413e-ff39-3e54-f4475e8a4396/original/1707131818745.png",
                            "slug": "kids-favourites-breakfast",
                            "meta_desc": "Kids Favourites - Breakfast",
                            "meta_keyword": "Kids Favourites - Breakfast",
                            "meta_title": "Kids Favourites - Breakfast",
                            "status": 1,
                            "parent_id": 860,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/520c56f7-29d6-1a05-018e-5618fcf80ecb/original/1707131815333.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/b78cbb98-5eb7-972e-3bfc-829a69f478bd/original/1707131817335.png",
                            "msite_desc": "                                                                                                                                                                                                                                                                                                                        <p>Kids Favourites - Breakfast<br></p>",
                            "subtitle": "Evening Snacks",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/0abb680c-4b57-c62e-cb4c-a3985f91ab0c/original/1707131813462.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/9ea9c773-080b-37b2-31eb-b0f1f7fb931f/original/1707131811090.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/32b84b08-d4ce-daaa-a1ec-43cd07249cf8/original/1707131798107.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/7c9522c7-b342-7295-f48c-1d607320a111/original/1707131796484.png",
                            "created_at": "2024-02-05T10:25:17.000Z",
                            "updated_at": "2024-02-06T02:39:53.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/698b0127-475a-bc16-4f27-2d9c2b92f41f/original/1707131838569.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/caeb03de-c3cd-b28e-bbb5-0d2286d2860a/original/1707131836711.png",
                            "l0_subtext": "Kids Favourites - Breakfast",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 101,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 862,
                            "cat_name": "Breakfast!",
                            "cat_desc": "                                                                                                                                                                                                                                                                                                                        Kids Favourites - Tiffin                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/415c6e8c-a4e5-2683-be46-e9a02c8ba30f/original/1707131699210.png",
                            "slug": "kids-favourites-tiffin",
                            "meta_desc": "Kids Favourites - Tiffin",
                            "meta_keyword": "Kids Favourites - Tiffin",
                            "meta_title": "Kids Favourites - Tiffin",
                            "status": 1,
                            "parent_id": 860,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/c180cf04-a8f1-2338-cd9a-12333da713af/original/1707131730256.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/9a29d8ed-2a0a-4da9-e7fa-61ac8f8c6b85/original/1707131700782.png",
                            "msite_desc": "                                                                                                                                                                                                                                                                                                                        <p>Kids Favourites - Tiffin<br></p>",
                            "subtitle": "Breakfast Staples",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/f22cf175-132b-ec23-aa5f-bca952d92e4a/original/1707131723502.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/6bf01129-8ad4-37e9-fe63-b06d7a6a0a83/original/1707131721893.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/b75b94f3-386b-ee52-4dd6-23354cfa55e0/original/1707131719998.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/9385fc39-fd05-1b0c-c568-b31a702c9ed3/original/1707131718230.png",
                            "created_at": "2024-02-05T10:27:09.000Z",
                            "updated_at": "2024-02-06T02:40:29.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/342b41f6-7adc-1121-ac9a-21c0c3484208/original/1707131695847.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/6a2475b7-1784-45b1-7eb8-171de7712a98/original/1707131697555.png",
                            "l0_subtext": "Kids Favourites - Tiffin",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 101,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 863,
                            "cat_name": "Tiffin",
                            "cat_desc": "                                                                                                                                                            Kids Favourites - Tiffin                                                                                                                                                            \n                                                \n                                                \n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/6b8e9f4a-a5aa-fa25-fc7b-d8479175ff4b/original/1707131898838.png",
                            "slug": "kids-favourites",
                            "meta_desc": "Kids Favourites",
                            "meta_keyword": "Kids Favourites",
                            "meta_title": "Kids Favourites",
                            "status": 1,
                            "parent_id": 860,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/131cae26-5cb5-7f3c-37db-000698c4b4e5/original/1707131907130.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/bcb81dc3-e0e7-3703-5fbd-6eec516b66f8/original/1707131900666.png",
                            "msite_desc": "                                                                                                                                                            Kids Favourites - Tiffin                                                                                                                                                            <p></p>",
                            "subtitle": "Yummy Tiffins",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/216072e8-152b-596b-6786-090669c9b18d/original/1707131909077.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/2de2a764-2641-27dd-99c8-08b95fd737fa/original/1707131910554.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/8f8ae3d0-49f7-3b0a-f65e-909c688c94a3/original/1707131912511.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/18593419-4abd-7f20-7582-161d2aafd0ba/original/1707131918203.png",
                            "created_at": "2024-02-05T10:49:43.000Z",
                            "updated_at": "2024-02-06T02:40:48.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/9d66130e-6342-b581-0da8-b501104f8cdf/original/1707131895096.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/022c8bae-535c-4013-de9d-a3d2010ce98e/original/1707131896971.png",
                            "l0_subtext": "Kids Favourites",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 101,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "category_details": {
                    "id": 869,
                    "cat_name": "Party Starters.",
                    "cat_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <span style=\"color: rgb(31, 31, 31); font-family: \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                \n                                                ",
                    "cat_img": "https://assets.licious.in/OMS-Category/cae41a7c-fa3f-226f-a442-4c490afd7269/original/1713945682314.png",
                    "slug": "party-starters-f249fc26-7b4f-49e1-a291-e461148ce3ef",
                    "meta_desc": "Party Starters",
                    "meta_keyword": "Party Starters",
                    "meta_title": "Party Starters",
                    "status": 1,
                    "parent_id": 0,
                    "cat_web_img": "https://assets.licious.in/OMS-Category/accf7322-fc76-79e6-8d7f-509b76ee3961/original/1713945689275.png",
                    "cat_tile_img": "https://assets.licious.in/OMS-Category/9ac46c5b-e1bd-542a-9fb2-5e3f36f1fd0d/original/1713945685275.png",
                    "msite_desc": "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <p><span style=\"color: rgb(31, 31, 31); font-family: ",
                    "subtitle": "Party Starters",
                    "popular": 0,
                    "mobile_icon": "https://assets.licious.in/OMS-Category/2b137965-a184-e77a-4f59-17bd9ec176a2/original/1713945692650.png",
                    "mobile_icon_active": "https://assets.licious.in/OMS-Category/a18b9a5a-8779-322f-d23a-ff5d93ab03d4/original/1713945696493.png",
                    "web_icon": "https://assets.licious.in/OMS-Category/57e8c800-d7a6-9ef0-80c5-1eea7b1dc24a/original/1713945700384.png",
                    "web_icon_active": "https://assets.licious.in/OMS-Category/9b4e4d1b-2318-b995-e3e8-b161c7c77ec7/original/1713945703204.png",
                    "created_at": "2024-02-05T12:02:10.000Z",
                    "updated_at": "2024-04-24T02:31:50.000Z",
                    "theme_data": "",
                    "category_nav_section_img": "https://assets.licious.in/OMS-Category/65d5382d-b419-1f8a-eda1-6cc3e8689ff5/original/1713945674010.png",
                    "category_nav_page_img": "https://assets.licious.in/OMS-Category/2da831c6-4105-7b0e-299e-4e7638b6c569/original/1713945677126.png",
                    "l0_subtext": "Chef crafted kebabs, tikkas, munchies & more",
                    "is_old_flow": 1,
                    "is_tree_flow": 1,
                    "order": 102,
                    "sub_categories": [
                        {
                            "id": 870,
                            "cat_name": "House Parties",
                            "cat_desc": "<span style=\"color: rgb(31, 31, 31); font-family: ",
                            "cat_img": "https://assets.licious.in/OMS-Category/447e8ac8-2b24-9f23-9a7b-ef2efa35492a/original/1707134642193.png",
                            "slug": "house-parties",
                            "meta_desc": "House Parties",
                            "meta_keyword": "House Parties",
                            "meta_title": "House Parties",
                            "status": 1,
                            "parent_id": 869,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/6ac47b62-3cd3-bb4f-1173-7ef49d400d25/original/1707134639492.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/1d7196b5-fbc1-ed02-31e7-e6ae66f841cd/original/1707134640893.png",
                            "msite_desc": "<p><span style=\"color: rgb(31, 31, 31); font-family: ",
                            "subtitle": "House Parties",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/5a4d5af8-86f0-3b31-6c9a-b93a8d187a3a/original/1707134637625.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/cad4a255-8a20-3712-5813-be30076d1519/original/1707134659738.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/2985caba-3e59-a44a-4072-b8d7ecd66394/original/1707134658369.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/62bc65db-778d-04cc-94f4-2b2b2a3bbfac/original/1707134655617.png",
                            "created_at": "2024-02-05T12:04:39.000Z",
                            "updated_at": "2024-02-05T12:04:39.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/ea07025e-5701-e670-49b7-7c7ccebd7d18/original/1707134650091.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/41ee73a9-14af-7c32-fcba-b270b9fe56f3/original/1707134643604.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 102,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 871,
                            "cat_name": "Match Time Munchies",
                            "cat_desc": "<span style=\"color: rgb(31, 31, 31); font-family: ",
                            "cat_img": "https://assets.licious.in/OMS-Category/4880a4a8-1cc9-b986-e76c-a0e52f214918/original/1707134791176.png",
                            "slug": "match-time-munchies",
                            "meta_desc": "Match Time Munchies",
                            "meta_keyword": "Match Time Munchies",
                            "meta_title": "Match Time Munchies",
                            "status": 1,
                            "parent_id": 869,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/c37edf60-7aef-5dd0-1754-da4d58ef4c88/original/1707134810450.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/868a92ad-910d-8f6c-f008-7cbaec4bc644/original/1707134793075.png",
                            "msite_desc": "<p><span style=\"color: rgb(31, 31, 31); font-family: ",
                            "subtitle": "Match Time Munchies",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/7af577db-26a0-856b-72a2-cae4b0e98d25/original/1707134809151.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/baeec5c8-bc93-4587-103e-3102ae0eb9cb/original/1707134806774.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/0b2f9960-83b5-915d-4f40-72af349724d3/original/1707134805207.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/4a137545-4790-6763-9733-53d9959ffe12/original/1707134803543.png",
                            "created_at": "2024-02-05T12:07:06.000Z",
                            "updated_at": "2024-02-05T12:07:06.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/7539b7de-0956-4bf5-9169-6cd0d8ddaff6/original/1707134787901.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/3df78619-2367-3ba0-bd09-731a71019d87/original/1707134789445.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 102,
                            "sub_categories": [],
                            "filter_id": 222
                        },
                        {
                            "id": 872,
                            "cat_name": "BBQ at Home",
                            "cat_desc": "                                                    <span data-sheets-root=\"1\" data-sheets-value=\"{\n                                                ",
                            "cat_img": "https://assets.licious.in/OMS-Category/30732f37-cbe9-93d6-026f-7fb3a5ac3971/original/1707134893246.png",
                            "slug": "bbq-at-home",
                            "meta_desc": "BBQ at Home",
                            "meta_keyword": "BBQ at Home",
                            "meta_title": "BBQ at Home",
                            "status": 1,
                            "parent_id": 869,
                            "cat_web_img": "https://assets.licious.in/OMS-Category/1f5d231f-a959-4373-f7aa-12be1a7d4852/original/1707134912641.png",
                            "cat_tile_img": "https://assets.licious.in/OMS-Category/8b54b6d1-3e5d-b98f-c00c-76328f027ea6/original/1707134895071.png",
                            "msite_desc": "                                                    <p><span data-sheets-root=\"1\" data-sheets-value=\"{",
                            "subtitle": "Barbeque at Home",
                            "popular": 0,
                            "mobile_icon": "https://assets.licious.in/OMS-Category/f1624899-6f37-4d28-217d-e5fa0dd62d27/original/1707134910548.png",
                            "mobile_icon_active": "https://assets.licious.in/OMS-Category/8989ed58-31a5-5c8e-409a-af73fea0abd4/original/1707134909248.png",
                            "web_icon": "https://assets.licious.in/OMS-Category/ca30a5bd-2acf-c738-e09d-3ea1c5567529/original/1707134907909.png",
                            "web_icon_active": "https://assets.licious.in/OMS-Category/59998966-248c-3f1b-69c2-78e7855a5827/original/1707134906452.png",
                            "created_at": "2024-02-05T12:08:52.000Z",
                            "updated_at": "2024-02-14T12:07:15.000Z",
                            "theme_data": null,
                            "category_nav_section_img": "https://assets.licious.in/OMS-Category/2b114360-dc55-90d4-282d-2969d43690c4/original/1707134890628.png",
                            "category_nav_page_img": "https://assets.licious.in/OMS-Category/71789208-c9bb-8981-68ab-e8dfeac2f213/original/1707134891832.png",
                            "l0_subtext": "",
                            "is_old_flow": 1,
                            "is_tree_flow": 1,
                            "order": 102,
                            "sub_categories": [],
                            "filter_id": 222
                        }
                    ]
                }
            }
        ],
        "carouselType": "normal",
        "pageName": "homepage",
        "primaryIndex": 2
    },
    {
        "id": 368,
        "order": 3,
        "name": "Bestsellers",
        "widgetName": "NU/O1-O4 Product",
        "widgetIdentifier": "",
        "type": "PRODUCT",
        "subText": "Fresh meats at extra special prices",
        "iosEnabled": true,
        "androidEnabled": true,
        "webEnabled": true,
        "msiteEnabled": true,
        "layoutName": "product1",
        "status": "ACTIVE",
        "mappingType": "RULE_BASED",
        "widgetMediaType": "IMAGE",
        "widgetMappings": [
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "productDetails": {
                    "variantId": "pr_5785b9065d7e1",
                    "primaryTag": {
                        "name": "NA"
                    },
                    "productId": "",
                    "categoryId": 0,
                    "merchandiseName": "Chicken Curry Cut - Small Pieces",
                    "slug": "chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1",
                    "comboProps": null,
                    "isCombo": 0,
                    "weightAndPieces": {
                        "netWeight": "500",
                        "pieces": "12-18",
                        "uom": "Weight",
                        "serves": "4",
                        "unit": "g",
                        "displayWeight": {
                            "value": "526 g",
                            "text": "(Before cleaning/cutting)"
                        }
                    },
                    "serves": "",
                    "basePrice": 195,
                    "baseDiscount": 8,
                    "cityDiscount": 0,
                    "hubDiscount": 0,
                    "appDiscount": 0,
                    "discountPercentage": 8,
                    "discountedPrice": 179,
                    "nextAvailableBy": "Today in 120 mins",
                    "slotMessage": "",
                    "slotAvailable": 0,
                    "scoreValue": 0,
                    "hasAddOns": false,
                    "deliveryType": "EXPRESS",
                    "media": {
                        "prImage": "https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png"
                    },
                    "productDescriptors": {
                        "uspDescription": "Juicy bone-in & boneless chicken for delectable curries"
                    },
                    "productLevelExperiment": {
                        "fnsGrossWtExp": "CONTROL"
                    }
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "productDetails": {
                    "variantId": "pr_3nqjtznab5c",
                    "primaryTag": {
                        "name": "NA"
                    },
                    "productId": "",
                    "categoryId": 0,
                    "merchandiseName": "Chicken Breast - Boneless",
                    "slug": "chicken-breast-boneless-pr_3nqjtznab5c",
                    "comboProps": null,
                    "isCombo": 0,
                    "weightAndPieces": {
                        "netWeight": "450",
                        "pieces": "2-4",
                        "uom": "Weight",
                        "serves": "4",
                        "unit": "g",
                        "displayWeight": {
                            "value": "600 g",
                            "text": "(Before cleaning/cutting)"
                        }
                    },
                    "serves": "",
                    "basePrice": 315,
                    "baseDiscount": 5,
                    "cityDiscount": 0,
                    "hubDiscount": 0,
                    "appDiscount": 0,
                    "discountPercentage": 5,
                    "discountedPrice": 299,
                    "nextAvailableBy": "Today in 120 mins",
                    "slotMessage": "",
                    "slotAvailable": 0,
                    "scoreValue": 0,
                    "hasAddOns": false,
                    "deliveryType": "EXPRESS",
                    "media": {
                        "prImage": "https://assets.licious.in/OMS-ProductMerchantdising/469c9ea4-4c1a-fe2a-0f2b-7dba03860c67/original/1716980533039.png"
                    },
                    "productDescriptors": {
                        "uspDescription": "Enjoy tender pieces of juicy chicken breast"
                    },
                    "productLevelExperiment": {
                        "fnsGrossWtExp": "CONTROL"
                    }
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "productDetails": {
                    "variantId": "pr_fhijtqu0u5q",
                    "productId": "",
                    "categoryId": 0,
                    "merchandiseName": "Chicken Boneless - Mini Bites",
                    "slug": "chicken-mini-bites---boneless-pr_fhijtqu0u5q",
                    "comboProps": null,
                    "isCombo": 0,
                    "weightAndPieces": {
                        "netWeight": "250",
                        "pieces": "20-25",
                        "uom": "Weight",
                        "serves": "4",
                        "unit": "g",
                        "displayWeight": {
                            "value": "350 g",
                            "text": "(Before cleaning/cutting)"
                        }
                    },
                    "serves": "",
                    "basePrice": 229,
                    "baseDiscount": 0,
                    "cityDiscount": 0,
                    "hubDiscount": 0,
                    "appDiscount": 0,
                    "discountPercentage": 0,
                    "discountedPrice": 229,
                    "nextAvailableBy": "Today in 120 mins",
                    "slotMessage": "",
                    "slotAvailable": 0,
                    "scoreValue": 0,
                    "hasAddOns": false,
                    "deliveryType": "EXPRESS",
                    "media": {
                        "prImage": "https://assets.licious.in/OMS-ProductMerchantdising/b1b27aed-5dd7-b09b-f2da-63e64aafb003/original/1716976077502.png"
                    },
                    "productDescriptors": {
                        "uspDescription": "Juicy, tender goodness of Chicken in a mouthful"
                    },
                    "productLevelExperiment": {
                        "fnsGrossWtExp": "CONTROL"
                    }
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "productDetails": {
                    "variantId": "pr_okil7rg4jj5",
                    "productId": "",
                    "categoryId": 0,
                    "merchandiseName": "Goat Curry Cut",
                    "slug": "premium-goat-curry-cut-pr_okil7rg4jj5",
                    "comboProps": null,
                    "isCombo": 0,
                    "weightAndPieces": {
                        "netWeight": "500",
                        "pieces": "13-17",
                        "uom": "Weight",
                        "serves": "4",
                        "unit": "g",
                        "displayWeight": {
                            "value": "660 g",
                            "text": "(Before cleaning/cutting)"
                        }
                    },
                    "serves": "",
                    "basePrice": 665,
                    "baseDiscount": 10,
                    "cityDiscount": 0,
                    "hubDiscount": 0,
                    "appDiscount": 0,
                    "discountPercentage": 10,
                    "discountedPrice": 599,
                    "nextAvailableBy": "Today in 120 mins",
                    "slotMessage": "",
                    "slotAvailable": 0,
                    "scoreValue": 0,
                    "hasAddOns": false,
                    "deliveryType": "EXPRESS",
                    "media": {
                        "prImage": "https://dao54xqhg9jfa.cloudfront.net/OMS-ProductMerchantdising/0f60f685-78f1-f3ed-c684-636ed40f868a/original/PDP_6._Premium_Goat_Curry_Cut-01_(1).jpg"
                    },
                    "productDescriptors": {
                        "uspDescription": "Perfect balance of fat & meat, make rich curries"
                    },
                    "productLevelExperiment": {
                        "fnsGrossWtExp": "CONTROL"
                    }
                }
            },
            {
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z",
                "productDetails": {
                    "variantId": "pr_590f2bc508b4a",
                    "productId": "",
                    "categoryId": 0,
                    "merchandiseName": "Farm Fresh Classic Eggs - Pack of 6",
                    "slug": "classic-eggs---pack-of-6-pr_590f2bc508b4a",
                    "comboProps": null,
                    "isCombo": 0,
                    "weightAndPieces": {
                        "netWeight": "",
                        "pieces": "6",
                        "uom": "Unit",
                        "serves": "3-4",
                        "unit": ""
                    },
                    "serves": "",
                    "basePrice": 89,
                    "baseDiscount": 34,
                    "cityDiscount": 0,
                    "hubDiscount": 0,
                    "appDiscount": 0,
                    "discountPercentage": 34,
                    "discountedPrice": 59,
                    "nextAvailableBy": "Today in 120 mins",
                    "slotMessage": "",
                    "slotAvailable": 0,
                    "scoreValue": 0,
                    "hasAddOns": false,
                    "deliveryType": "EXPRESS",
                    "media": {
                        "prImage": "https://dao54xqhg9jfa.cloudfront.net/OMS-ProductMerchantdising/1f7e9e0b-741a-311b-b896-59e11532924f/original/PDP_1._Classic_Eggs_-_Pack_of_6_(1).jpg"
                    },
                    "productDescriptors": {
                        "uspDescription": "Handpicked farm fresh eggs for a satiating meal."
                    },
                    "productLevelExperiment": {
                        "fnsGrossWtExp": "CONTROL"
                    }
                }
            }
        ],
        "ruleId": 4,
        "ruleDeeplink": "type=category%26category_id=1083",
        "carouselType": "normal",
        "pageName": "homepage",
        "primaryIndex": 3,
        "contentType": "sm-product",
        "showViewAll": true
    },
    {
        "id": 356,
        "order": 4,
        "name": "What our customers say",
        "widgetName": "new user testimonials",
        "widgetIdentifier": "",
        "type": "COLLECTION",
        "subText": "Hear it directly from people like you",
        "iosEnabled": true,
        "androidEnabled": true,
        "webEnabled": true,
        "msiteEnabled": true,
        "layoutName": "short2",
        "status": "ACTIVE",
        "widgetMediaType": "IMAGE",
        "widgetMappings": [
            {
                "integerId": 2243,
                "cardName": " ",
                "webImage": "https://assets.licious.in/oms/771bdb4d-95c9-fc34-2a5a-2da7a0b3c5a3/original/1714641102145.png",
                "msiteImage": "https://assets.licious.in/oms/9b153674-43ed-321e-131a-b67b8afc8b2a/original/1714641108077.png",
                "appImage": "https://assets.licious.in/oms/9b153674-43ed-321e-131a-b67b8afc8b2a/original/1714641108077.png",
                "webMedia": "https://assets.licious.in/oms/771bdb4d-95c9-fc34-2a5a-2da7a0b3c5a3/original/1714641102145.png",
                "msiteMedia": "https://assets.licious.in/oms/9b153674-43ed-321e-131a-b67b8afc8b2a/original/1714641108077.png",
                "appMedia": "https://assets.licious.in/oms/9b153674-43ed-321e-131a-b67b8afc8b2a/original/1714641108077.png",
                "mediaType": "IMAGE",
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z"
            },
            {
                "integerId": 2244,
                "cardName": " ",
                "webImage": "https://assets.licious.in/oms/5bf3f0ef-70be-4498-4acb-cee8ad2bbba5/original/1714641145708.png",
                "msiteImage": "https://assets.licious.in/oms/48d0fa99-39a5-6758-d876-d9bb950697e8/original/1714641151768.png",
                "appImage": "https://assets.licious.in/oms/48d0fa99-39a5-6758-d876-d9bb950697e8/original/1714641151768.png",
                "webMedia": "https://assets.licious.in/oms/5bf3f0ef-70be-4498-4acb-cee8ad2bbba5/original/1714641145708.png",
                "msiteMedia": "https://assets.licious.in/oms/48d0fa99-39a5-6758-d876-d9bb950697e8/original/1714641151768.png",
                "appMedia": "https://assets.licious.in/oms/48d0fa99-39a5-6758-d876-d9bb950697e8/original/1714641151768.png",
                "mediaType": "IMAGE",
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z"
            },
            {
                "integerId": 2241,
                "cardName": " ",
                "webImage": "https://assets.licious.in/oms/bd10cee8-f8ba-96a1-50ed-465bf0986008/original/1714641062748.png",
                "msiteImage": "https://assets.licious.in/oms/1b5a1e05-435e-a5c1-8588-ce6164546c3e/original/1714641067719.png",
                "appImage": "https://assets.licious.in/oms/1b5a1e05-435e-a5c1-8588-ce6164546c3e/original/1714641067719.png",
                "webMedia": "https://assets.licious.in/oms/bd10cee8-f8ba-96a1-50ed-465bf0986008/original/1714641062748.png",
                "msiteMedia": "https://assets.licious.in/oms/1b5a1e05-435e-a5c1-8588-ce6164546c3e/original/1714641067719.png",
                "appMedia": "https://assets.licious.in/oms/1b5a1e05-435e-a5c1-8588-ce6164546c3e/original/1714641067719.png",
                "mediaType": "IMAGE",
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z"
            },
            {
                "integerId": 2238,
                "cardName": " ",
                "webImage": "https://assets.licious.in/oms/af88fb24-cc35-10a8-0078-a9dfd8f38efb/original/1714640932931.png",
                "msiteImage": "https://assets.licious.in/oms/148330e5-1394-9f83-a150-dbd8119d8aee/original/1714640937146.png",
                "appImage": "https://assets.licious.in/oms/148330e5-1394-9f83-a150-dbd8119d8aee/original/1714640937146.png",
                "webMedia": "https://assets.licious.in/oms/af88fb24-cc35-10a8-0078-a9dfd8f38efb/original/1714640932931.png",
                "msiteMedia": "https://assets.licious.in/oms/148330e5-1394-9f83-a150-dbd8119d8aee/original/1714640937146.png",
                "appMedia": "https://assets.licious.in/oms/148330e5-1394-9f83-a150-dbd8119d8aee/original/1714640937146.png",
                "mediaType": "IMAGE",
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z"
            },
            {
                "integerId": 2239,
                "cardName": " ",
                "webImage": "https://assets.licious.in/oms/cd63a44b-a5d9-ab51-2e9e-385afe535a86/original/1714641007912.png",
                "msiteImage": "https://assets.licious.in/oms/f7b1edce-d423-4d11-ff3c-d450757c8b6a/original/1714641011904.png",
                "appImage": "https://assets.licious.in/oms/f7b1edce-d423-4d11-ff3c-d450757c8b6a/original/1714641011904.png",
                "webMedia": "https://assets.licious.in/oms/cd63a44b-a5d9-ab51-2e9e-385afe535a86/original/1714641007912.png",
                "msiteMedia": "https://assets.licious.in/oms/f7b1edce-d423-4d11-ff3c-d450757c8b6a/original/1714641011904.png",
                "appMedia": "https://assets.licious.in/oms/f7b1edce-d423-4d11-ff3c-d450757c8b6a/original/1714641011904.png",
                "mediaType": "IMAGE",
                "createdAt": "0001-01-01T00:00:00Z",
                "updatedAt": "0001-01-01T00:00:00Z"
            }
        ],
        "carouselType": "normal",
        "pageName": "homepage",
        "primaryIndex": 4,
        "contentType": "IMAGE"
    }
]


export const cities = ["Bengaluru",
"NCR",
"Hyderabad",
"Chandigarh",
"Panchkula",
"Mohali",
"Mumbai",
"Pune",
"Chennai",
"Coimbatore",
"Jaipur",
"Cochin",
"Vijayawada",
"Visakhapatnam",
"Kolkata",
"Lucknow",
"Kanpur",
"Nagpur"
]

export const popularSearches =  [
        {
            "category_name": "Chicken",
            "products": [
                {
                    "id": 1,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Chicken Breast (Boneless)",
                    "url": "http://licious.in/chicken/chicken-breast-boneless-pr_57234a4f6f77b",
                    "deeplink": "type=products&productId=pr_57234a4f6f77b",
                    "status": 1,
                    "created_at": "2017-08-08T10:39:04.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_57234a4f6f77b",
                    "product_slug": "chicken-breast-boneless-pr_57234a4f6f77b",
                    "cat_slug": "chicken"
                },
                {
                    "id": 2,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Chicken (Skinless) - Curry Cut (Large)",
                    "url": "http://licious.in/chicken/chicken-curry-cut-large-pieces-pr_57234c427648b",
                    "deeplink": "type=products&productId=pr_57234c427648b",
                    "status": 1,
                    "created_at": "2017-08-08T10:39:04.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_57234c427648b",
                    "product_slug": "chicken-curry-cut-large-pieces-pr_57234c427648b",
                    "cat_slug": "chicken"
                },
                {
                    "id": 5,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Chicken Mince/Keema",
                    "url": "http://licious.in/chicken/chicken-mince-keema-pr_57234d5b5ee73",
                    "deeplink": "type=products&productId=pr_57234d5b5ee73",
                    "status": 1,
                    "created_at": "2017-08-08T10:39:05.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_57234d5b5ee73",
                    "product_slug": "chicken-mince-keema-pr_57234d5b5ee73",
                    "cat_slug": "chicken"
                },
                {
                    "id": 122,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Chicken Leg Curry Cut (Large - 4 pieces)",
                    "url": "http://licious.in/chicken/chicken-leg-curry-cut-large---4-pieces-pr_2j9jxbzk1cl",
                    "deeplink": "type=product&productId=pr_2j9jxbzk1cl",
                    "status": 1,
                    "created_at": "2020-05-05T10:02:07.000Z",
                    "updated_at": "2020-05-05T10:02:07.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_2j9jxbzk1cl",
                    "product_slug": "chicken-leg-curry-cut-large---4-pieces-pr_2j9jxbzk1cl",
                    "cat_slug": "chicken"
                },
                {
                    "id": 123,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Chicken Lollipop - 10 Pieces",
                    "url": "http://licious.in/chicken/chicken-lollipop---10-pieces-pr_ejejbf09h51",
                    "deeplink": "type=product&productId=pr_ejejbf09h51",
                    "status": 1,
                    "created_at": "2020-05-05T10:02:07.000Z",
                    "updated_at": "2020-05-05T10:02:07.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_ejejbf09h51",
                    "product_slug": "chicken-lollipop---10-pieces-pr_ejejbf09h51",
                    "cat_slug": "chicken"
                },
                {
                    "id": 124,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Tender Spring Chicken Curry Cut",
                    "url": "http://licious.in/chicken/tender-spring-chicken-curry-cu-pr_hn6k8alrcck",
                    "deeplink": "type=product&productId=pr_hn6k8alrcck",
                    "status": 1,
                    "created_at": "2020-05-05T10:09:06.000Z",
                    "updated_at": "2020-05-05T10:09:06.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_hn6k8alrcck",
                    "product_slug": "tender-spring-chicken-curry-cu-pr_hn6k8alrcck",
                    "cat_slug": "chicken"
                },
                {
                    "id": 125,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "",
                    "category_id": 1,
                    "product_name": "Chicken - Whole with Skin",
                    "url": "http://licious.in/chicken/chicken-whole-with-skin-pr_5723564821da3",
                    "deeplink": "type=product&productId=pr_5723564821da3",
                    "status": 1,
                    "created_at": "2020-05-05T10:09:06.000Z",
                    "updated_at": "2020-12-26T11:13:19.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_5723564821da3",
                    "product_slug": "chicken-whole-with-skin-pr_5723564821da3",
                    "cat_slug": "chicken"
                },
                {
                    "id": 126,
                    "city_id": 1,
                    "category": "Chicken",
                    "category_url": "https://www.licious.in/chicken",
                    "category_id": 1,
                    "product_name": "Chicken Curry Cut (Small - 13 to 16 Pieces)",
                    "url": "http://licious.in/chicken/chicken-curry-cut-small-pieces-pr_5785b9065d7e1",
                    "deeplink": "type=product&productId=pr_5785b9065d7e1",
                    "status": 1,
                    "created_at": "2020-05-05T10:09:06.000Z",
                    "updated_at": "2020-05-05T10:09:06.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedchicken/undefined",
                    "msite_category_url": "https://m.licious.in/chicken",
                    "product_id": "pr_5785b9065d7e1",
                    "product_slug": "chicken-curry-cut-small-pieces-pr_5785b9065d7e1",
                    "cat_slug": "chicken"
                }
            ],
            "category_url": "https://www.licious.in/chicken",
            "msite_category_url": "https://m.licious.in/chicken"
        },
        {
            "category_name": "Eggs",
            "products": [
                {
                    "id": 11,
                    "city_id": 1,
                    "category": "Eggs",
                    "category_url": "",
                    "category_id": 30,
                    "product_name": "Classic Eggs - Pack Of 6",
                    "url": "http://licious.in/eggs/classic-eggs---pack-of-6-pr_590f2bc508b4a",
                    "deeplink": "type=product&productId=pr_590f2bc508b4a",
                    "status": 1,
                    "created_at": "2017-08-08T14:24:25.000Z",
                    "updated_at": "2021-04-29T19:07:05.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedeggs/undefined",
                    "msite_category_url": "https://m.licious.in/eggs",
                    "product_id": "pr_590f2bc508b4a",
                    "product_slug": "classic-eggs---pack-of-6-pr_590f2bc508b4a",
                    "cat_slug": "eggs"
                }
            ],
            "category_url": "",
            "msite_category_url": "https://m.licious.in/eggs"
        },
        {
            "category_name": "Mutton",
            "products": [
                {
                    "id": 22,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "",
                    "category_id": 2,
                    "product_name": "Goat Mince/Keema",
                    "url": "http://licious.in/red-meat/goat-mince-keema-pr_579a530679ede",
                    "deeplink": "type=product&productId=pr_579a530679ede",
                    "status": 1,
                    "created_at": "2017-08-18T11:30:14.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://m.licious.in/red-meat/",
                    "product_id": "pr_579a530679ede",
                    "product_slug": "goat-mince-keema-pr_579a530679ede",
                    "cat_slug": "red-meat"
                },
                {
                    "id": 127,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "https://www.licious.in/red-meat",
                    "category_id": 2,
                    "product_name": "Rich Goat Curry Cut (Small - 16 to 20 pieces)",
                    "url": "http://licious.in/red-meat/rich-goat-curry-cut-small-16-t-pr_nbzk1sx8n3k",
                    "deeplink": "type=product&productId=pr_nbzk1sx8n3k",
                    "status": 1,
                    "created_at": "2020-05-05T10:53:24.000Z",
                    "updated_at": "2020-05-05T10:53:24.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://m.licious.in/red-meat",
                    "product_id": "pr_nbzk1sx8n3k",
                    "product_slug": "rich-goat-curry-cut-small-16-t-pr_nbzk1sx8n3k",
                    "cat_slug": "red-meat"
                },
                {
                    "id": 128,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "https://www.licious.in/red-meat",
                    "category_id": 2,
                    "product_name": "Lean Goat Curry Cut (Small - 16 to 20 pieces)",
                    "url": "http://licious.in/red-meat/lean-goat-curry-cut-small-16-t-pr_nbzk1sybkyi",
                    "deeplink": "type=product&productId=pr_nbzk1sybkyi",
                    "status": 1,
                    "created_at": "2020-05-05T10:53:24.000Z",
                    "updated_at": "2020-05-05T10:53:24.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://m.licious.in/red-meat",
                    "product_id": "pr_nbzk1sybkyi",
                    "product_slug": "lean-goat-curry-cut-small-16-t-pr_nbzk1sybkyi",
                    "cat_slug": "red-meat"
                },
                {
                    "id": 129,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "https://www.licious.in/red-meat",
                    "category_id": 2,
                    "product_name": "Lean Lamb Curry Cut (Small - 16 to 20 pieces)",
                    "url": "http://licious.in/red-meat/lean-lamb-curry-cut-small-16-t-pr_3isk1syezv7",
                    "deeplink": "type=product&productId=pr_3isk1syezv7",
                    "status": 1,
                    "created_at": "2020-05-05T10:53:24.000Z",
                    "updated_at": "2020-05-05T10:53:24.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://www.licious.in/red-meat",
                    "product_id": "pr_3isk1syezv7",
                    "product_slug": "lean-lamb-curry-cut-small-16-t-pr_3isk1syezv7",
                    "cat_slug": "red-meat"
                },
                {
                    "id": 130,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "https://www.licious.in/red-meat",
                    "category_id": 2,
                    "product_name": "Rich Lamb Curry Cut (Small - 16 to 20 pieces)",
                    "url": "http://licious.in/red-meat/rich-lamb-curry-cut-small-16-t-pr_ouuk1sxrqbr",
                    "deeplink": "type=product&productId=pr_ouuk1sxrqbr",
                    "status": 1,
                    "created_at": "2020-05-05T10:53:24.000Z",
                    "updated_at": "2020-05-05T10:53:24.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://m.licious.in/red-meat",
                    "product_id": "pr_ouuk1sxrqbr",
                    "product_slug": "rich-lamb-curry-cut-small-16-t-pr_ouuk1sxrqbr",
                    "cat_slug": "red-meat"
                },
                {
                    "id": 131,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "https://www.licious.in/red-meat",
                    "category_id": 2,
                    "product_name": "Lamb Ribs and Chops",
                    "url": "http://licious.in/red-meat/lamb-ribs-chops-pr_o5pjg4pmg3n",
                    "deeplink": "type=product&productId=pr_o5pjg4pmg3n",
                    "status": 1,
                    "created_at": "2020-05-05T10:53:24.000Z",
                    "updated_at": "2020-05-05T10:53:24.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://m.licious.in/red-meat",
                    "product_id": "pr_o5pjg4pmg3n",
                    "product_slug": "lamb-ribs-chops-pr_o5pjg4pmg3n",
                    "cat_slug": "red-meat"
                },
                {
                    "id": 132,
                    "city_id": 1,
                    "category": "Mutton",
                    "category_url": "https://www.licious.in/red-meat",
                    "category_id": 2,
                    "product_name": "Goat Ribs and Chops",
                    "url": "http://licious.in/red-meat/goat-ribs-chops-pr_4dmjfl18hj2",
                    "deeplink": "type=product&productId=pr_4dmjfl18hj2",
                    "status": 1,
                    "created_at": "2020-05-05T10:53:24.000Z",
                    "updated_at": "2020-05-05T10:53:24.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmutton/undefined",
                    "msite_category_url": "https://m.licious.in/red-meat",
                    "product_id": "pr_4dmjfl18hj2",
                    "product_slug": "goat-ribs-chops-pr_4dmjfl18hj2",
                    "cat_slug": "red-meat"
                }
            ],
            "category_url": "",
            "msite_category_url": "https://m.licious.in/red-meat/"
        },
        {
            "category_name": "Fish & Seafood",
            "products": [
                {
                    "id": 25,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Basa Fillet (Platinum Grade) ",
                    "url": "http://licious.in/seafood/basa-fillet-platinum-grade-pr_5746a6e241199",
                    "deeplink": "type=product&productId=pr_5746a6e241199",
                    "status": 1,
                    "created_at": "2017-08-18T11:36:30.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_5746a6e241199",
                    "product_slug": "basa-fillet-platinum-grade-pr_5746a6e241199",
                    "cat_slug": "seafood"
                },
                {
                    "id": 26,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Premium Grade Mackerel (Cleaned)",
                    "url": "http://licious.in/seafood/mackerel-gutted-pr_57235831e3960",
                    "deeplink": "type=product&productId=pr_57235831e3960",
                    "status": 1,
                    "created_at": "2017-08-18T11:37:32.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_57235831e3960",
                    "product_slug": "mackerel-gutted-pr_57235831e3960",
                    "cat_slug": "seafood"
                },
                {
                    "id": 133,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Freshwater Rohu Large - Bengali Cut (w/o Head)",
                    "url": "http://licious.in/seafood/freshwater-rohu-large---bengali-cut-no-head-pr_599441c9064f2",
                    "deeplink": "type=product&productId=pr_599441c9064f2",
                    "status": 1,
                    "created_at": "2020-05-05T11:02:46.000Z",
                    "updated_at": "2020-05-05T11:02:46.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_599441c9064f2",
                    "product_slug": "freshwater-rohu-large---bengali-cut-no-head-pr_599441c9064f2",
                    "cat_slug": "seafood"
                },
                {
                    "id": 134,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Freshwater Rohu - Bengali Cut (Without Head)",
                    "url": "http://licious.in/seafood/freshwater-rohu-bengali-cut-without-head-pr_6j4jhlmxsk1",
                    "deeplink": "type=product&productId=pr_6j4jhlmxsk1",
                    "status": 1,
                    "created_at": "2020-05-05T11:02:46.000Z",
                    "updated_at": "2020-05-05T11:02:46.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_6j4jhlmxsk1",
                    "product_slug": "freshwater-rohu-bengali-cut-without-head-pr_6j4jhlmxsk1",
                    "cat_slug": "seafood"
                },
                {
                    "id": 135,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Medium Prawns -  Without Tail",
                    "url": "http://licious.in/seafood/freshwater-prawns-60c---cleaned-deveined,-no-tail-pr_6zvk7zqjeap",
                    "deeplink": "type=product&productId=pr_6zvk7zqjeap",
                    "status": 1,
                    "created_at": "2020-05-05T11:02:46.000Z",
                    "updated_at": "2020-05-05T11:02:46.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_6zvk7zqjeap",
                    "product_slug": "freshwater-prawns-60c---cleaned-deveined,-no-tail-pr_6zvk7zqjeap",
                    "cat_slug": "seafood"
                },
                {
                    "id": 136,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Seer (Surmai) Steaks",
                    "url": "http://licious.in/seafood/seer-large---steaks-pr_5723580b90fd9",
                    "deeplink": "type=product&productId=pr_5723580b90fd9",
                    "status": 1,
                    "created_at": "2020-05-05T11:02:46.000Z",
                    "updated_at": "2020-05-05T11:02:46.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_5723580b90fd9",
                    "product_slug": "seer-large---steaks-pr_5723580b90fd9",
                    "cat_slug": "seafood"
                },
                {
                    "id": 137,
                    "city_id": 1,
                    "category": "Fish & Seafood",
                    "category_url": "https://www.licious.in/seafood",
                    "category_id": 3,
                    "product_name": "Freshwater Rohu Small - Bengali Cut (without Head)",
                    "url": "http://licious.in/seafood/freshwater-rohu-small---bengali-cut-no-head-pr_k3yk8iu1vgp",
                    "deeplink": "type=product&productId=pr_k3yk8iu1vgp",
                    "status": 1,
                    "created_at": "2020-05-05T11:02:46.000Z",
                    "updated_at": "2020-05-05T11:02:46.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedfish & seafood/undefined",
                    "msite_category_url": "https://m.licious.in/seafood",
                    "product_id": "pr_k3yk8iu1vgp",
                    "product_slug": "freshwater-rohu-small---bengali-cut-no-head-pr_k3yk8iu1vgp",
                    "cat_slug": "seafood"
                }
            ],
            "category_url": "https://www.licious.in/seafood",
            "msite_category_url": "https://m.licious.in/seafood"
        },
        {
            "category_name": "Ready to Cook",
            "products": [
                {
                    "id": 31,
                    "city_id": 1,
                    "category": "Ready to Cook",
                    "category_url": "",
                    "category_id": 4,
                    "product_name": "Caribbean Jerk Chicken (Boneless)",
                    "url": "http://licious.in/marinades/caribbean-jerk-chicken-pr_572358cee5c09",
                    "deeplink": "type=product&productId=pr_572358cee5c09",
                    "status": 1,
                    "created_at": "2017-09-07T12:35:36.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedready to cook/undefined",
                    "msite_category_url": "https://m.licious.in/marinades",
                    "product_id": "pr_572358cee5c09",
                    "product_slug": "caribbean-jerk-chicken-pr_572358cee5c09",
                    "cat_slug": "marinades"
                },
                {
                    "id": 138,
                    "city_id": 1,
                    "category": "Ready to Cook",
                    "category_url": "https://www.licious.in/marinades",
                    "category_id": 4,
                    "product_name": "Habanero Chicken Wings (Hot) - 10 Pieces",
                    "url": "http://licious.in/marinades/habanero-chicken-wings-hot-10-pr_4rqjeo4sujr",
                    "deeplink": "type=product&productId=pr_4rqjeo4sujr",
                    "status": 1,
                    "created_at": "2020-05-05T11:09:31.000Z",
                    "updated_at": "2020-05-05T11:09:31.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedready to cook/undefined",
                    "msite_category_url": "https://m.licious.in/marinades",
                    "product_id": "pr_4rqjeo4sujr",
                    "product_slug": "habanero-chicken-wings-hot-10-pr_4rqjeo4sujr",
                    "cat_slug": "marinades"
                },
                {
                    "id": 139,
                    "city_id": 1,
                    "category": "Ready to Cook",
                    "category_url": "https://www.licious.in/marinades",
                    "category_id": 4,
                    "product_name": "Creamy Afghani Chicken",
                    "url": "http://licious.in/marinades/creamy-afghani-chicken-pr_8izjkuohf8n",
                    "deeplink": "type=product&productId=pr_8izjkuohf8n",
                    "status": 1,
                    "created_at": "2020-05-05T11:09:31.000Z",
                    "updated_at": "2020-05-05T11:09:31.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedready to cook/undefined",
                    "msite_category_url": "https://m.licious.in/marinades",
                    "product_id": "pr_8izjkuohf8n",
                    "product_slug": "creamy-afghani-chicken-pr_8izjkuohf8n",
                    "cat_slug": "marinades"
                },
                {
                    "id": 140,
                    "city_id": 1,
                    "category": "Ready to Cook",
                    "category_url": "https://www.licious.in/marinades",
                    "category_id": 4,
                    "product_name": "Peri Peri Chicken (Spicy)",
                    "url": "http://licious.in/marinades/peri-peri-chicken-spicy-pr_572359462392e",
                    "deeplink": "type=product&productId=pr_572359462392e",
                    "status": 1,
                    "created_at": "2020-05-05T11:09:31.000Z",
                    "updated_at": "2020-05-05T11:09:31.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedready to cook/undefined",
                    "msite_category_url": "https://m.licious.in/marinades",
                    "product_id": "pr_572359462392e",
                    "product_slug": "peri-peri-chicken-spicy-pr_572359462392e",
                    "cat_slug": "marinades"
                },
                {
                    "id": 141,
                    "city_id": 1,
                    "category": "Ready to Cook",
                    "category_url": "https://www.licious.in/marinades",
                    "category_id": 4,
                    "product_name": "Chicken Cutlet (Bengali Style)",
                    "url": "http://licious.in/marinades/chicken-cutlet---bengali-style-pr_ntcjmw19kw5",
                    "deeplink": "type=product&productId=pr_ntcjmw19kw5",
                    "status": 1,
                    "created_at": "2020-05-05T11:09:31.000Z",
                    "updated_at": "2020-05-05T11:09:31.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedready to cook/undefined",
                    "msite_category_url": "https://m.licious.in/marinades",
                    "product_id": "pr_ntcjmw19kw5",
                    "product_slug": "chicken-cutlet---bengali-style-pr_ntcjmw19kw5",
                    "cat_slug": "marinades"
                }
            ],
            "category_url": "",
            "msite_category_url": "https://m.licious.in/marinades"
        },
        {
            "category_name": "Exotic Meats",
            "products": [
                {
                    "id": 35,
                    "city_id": 1,
                    "category": "Exotic Meats",
                    "category_url": "https://www.licious.in/exotic",
                    "category_id": 7,
                    "product_name": "Atlantic Salmon Steaks",
                    "url": "http://licious.in/exotic/atlantic-salmon-steaks-pr_579203c67b2ef",
                    "deeplink": "type=product&productId=pr_579203c67b2ef",
                    "status": 1,
                    "created_at": "2017-09-07T12:40:48.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedexotic meats/undefined",
                    "msite_category_url": "https://m.licious.in/exotic",
                    "product_id": "pr_579203c67b2ef",
                    "product_slug": "atlantic-salmon-steaks-pr_579203c67b2ef",
                    "cat_slug": "exotic"
                },
                {
                    "id": 36,
                    "city_id": 1,
                    "category": "Exotic Meats",
                    "category_url": "https://www.licious.in/exotic",
                    "category_id": 7,
                    "product_name": "Blue Crab",
                    "url": "http://licious.in/exotic/blue-crab-pr_57235852e4987",
                    "deeplink": "type=product&productId=pr_57235852e4987",
                    "status": 1,
                    "created_at": "2017-09-07T12:41:53.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedexotic meats/undefined",
                    "msite_category_url": "https://m.licious.in/exotic",
                    "product_id": "pr_57235852e4987",
                    "product_slug": "blue-crab-pr_57235852e4987",
                    "cat_slug": "exotic"
                },
                {
                    "id": 37,
                    "city_id": 1,
                    "category": "Exotic Meats",
                    "category_url": "https://www.licious.in/exotic",
                    "category_id": 7,
                    "product_name": "Sea Bass/ Bhetki Fillet ",
                    "url": "http://licious.in/exotic/sea-bass-fillet  -pr_572db2eb17e6e",
                    "deeplink": "type=product&productId=pr_572db2eb17e6e",
                    "status": 1,
                    "created_at": "2017-09-07T12:42:51.000Z",
                    "updated_at": "2020-05-05T09:49:53.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedexotic meats/undefined",
                    "msite_category_url": "https://m.licious.in/exotic",
                    "product_id": "pr_572db2eb17e6e",
                    "product_slug": "sea-bass-fillet  -pr_572db2eb17e6e",
                    "cat_slug": "exotic"
                }
            ],
            "category_url": "https://www.licious.in/exotic",
            "msite_category_url": "https://m.licious.in/exotic"
        },
        {
            "category_name": "Spreads",
            "products": [
                {
                    "id": 142,
                    "city_id": 1,
                    "category": "Spreads",
                    "category_url": "https://www.licious.in/spreads",
                    "category_id": 20,
                    "product_name": "Chunky Butter Chicken Spread (Single Serve)",
                    "url": "http://licious.in/spreads/chunky-butter-chicken-spread-s-pr_4cyjya5vxs7",
                    "deeplink": "type=product&productId=pr_4cyjya5vxs7",
                    "status": 1,
                    "created_at": "2020-05-05T11:13:37.000Z",
                    "updated_at": "2020-05-05T11:13:37.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedspreads/undefined",
                    "msite_category_url": "https://m.licious.in/spreads",
                    "product_id": "pr_4cyjya5vxs7",
                    "product_slug": "chunky-butter-chicken-spread-s-pr_4cyjya5vxs7",
                    "cat_slug": "spreads"
                },
                {
                    "id": 143,
                    "city_id": 1,
                    "category": "Spreads",
                    "category_url": "https://www.licious.in/spreads",
                    "category_id": 20,
                    "product_name": "Chunky Continental Chicken Spread",
                    "url": "http://licious.in/spreads/chunky-continental-chicken-spr-pr_4q4jya5rq6v",
                    "deeplink": "type=product&productId=pr_4q4jya5rq6v",
                    "status": 1,
                    "created_at": "2020-05-05T11:13:37.000Z",
                    "updated_at": "2020-05-05T11:13:37.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedspreads/undefined",
                    "msite_category_url": "https://m.licious.in/spreads",
                    "product_id": "pr_4q4jya5rq6v",
                    "product_slug": "chunky-continental-chicken-spr-pr_4q4jya5rq6v",
                    "cat_slug": "spreads"
                },
                {
                    "id": 144,
                    "city_id": 1,
                    "category": "Spreads",
                    "category_url": "https://www.licious.in/spreads",
                    "category_id": 20,
                    "product_name": "Chunky Shawarma Chicken Spread (Single Serve)",
                    "url": "http://licious.in/spreads/chunky-shawarma-chicken-spread-pr_4q4jya5vg2a",
                    "deeplink": "type=product&productId=pr_4q4jya5vg2a",
                    "status": 1,
                    "created_at": "2020-05-05T11:13:37.000Z",
                    "updated_at": "2020-05-05T11:13:37.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedspreads/undefined",
                    "msite_category_url": "https://m.licious.in/spreads",
                    "product_id": "pr_4q4jya5vg2a",
                    "product_slug": "chunky-shawarma-chicken-spread-pr_4q4jya5vg2a",
                    "cat_slug": "spreads"
                }
            ],
            "category_url": "https://www.licious.in/spreads",
            "msite_category_url": "https://m.licious.in/spreads"
        },
        {
            "category_name": "Kebabs",
            "products": [
                {
                    "id": 145,
                    "city_id": 1,
                    "category": "Kebabs",
                    "category_url": "https://www.licious.in/kebabs",
                    "category_id": 39,
                    "product_name": "Afghani Murgh Seekh Kebab",
                    "url": "http://licious.in/kebabs/afghani-murgh-seekh-kebab-pr_ikuk3ilucko",
                    "deeplink": "type=product&productId=pr_ikuk3ilucko",
                    "status": 1,
                    "created_at": "2020-05-05T11:21:03.000Z",
                    "updated_at": "2020-05-05T11:21:03.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedkebabs/undefined",
                    "msite_category_url": "https://m.licious.in/kebabs",
                    "product_id": "pr_ikuk3ilucko",
                    "product_slug": "afghani-murgh-seekh-kebab-pr_ikuk3ilucko",
                    "cat_slug": "kebabs"
                },
                {
                    "id": 146,
                    "city_id": 1,
                    "category": "Kebabs",
                    "category_url": "https://www.licious.in/kebabs",
                    "category_id": 39,
                    "product_name": "Purani Dilli ki Mutton Seekh Kebab",
                    "url": "http://licious.in/kebabs/purani-dilli-ki-mutton-seekh-kebab-pr_inuk3ilznwg",
                    "deeplink": "type=product&productId=pr_inuk3ilznwg",
                    "status": 1,
                    "created_at": "2020-05-05T11:21:03.000Z",
                    "updated_at": "2020-05-05T11:21:03.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedkebabs/undefined",
                    "msite_category_url": "https://m.licious.in/kebabs",
                    "product_id": "pr_inuk3ilznwg",
                    "product_slug": "purani-dilli-ki-mutton-seekh-kebab-pr_inuk3ilznwg",
                    "cat_slug": "kebabs"
                }
            ],
            "category_url": "https://www.licious.in/kebabs",
            "msite_category_url": "https://m.licious.in/kebabs"
        },
        {
            "category_name": "Meat Masala",
            "products": [
                {
                    "id": 242,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Classic Meat Masala",
                    "url": "http://licious.in/masalas/classic-meat-masala-pr_o2hlaqh6jv9",
                    "deeplink": "type=product&productId=pr_o2hlaqh6jv9",
                    "status": 1,
                    "created_at": "2022-11-30T17:15:38.000Z",
                    "updated_at": "2022-11-30T17:15:38.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_o2hlaqh6jv9",
                    "product_slug": "classic-meat-masala-pr_o2hlaqh6jv9",
                    "cat_slug": "masalas"
                },
                {
                    "id": 244,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Dakshin Pepper Fry Masala",
                    "url": "http://licious.in/masalas/dakshin-pepper-fry-masala-pr_ncplaqh86z8",
                    "deeplink": "type=product&productId=pr_ncplaqh86z8",
                    "status": 1,
                    "created_at": "2022-12-01T06:37:20.000Z",
                    "updated_at": "2022-12-01T06:37:20.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_ncplaqh86z8",
                    "product_slug": "dakshin-pepper-fry-masala-pr_ncplaqh86z8",
                    "cat_slug": "masalas"
                },
                {
                    "id": 245,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Chatpata Fish Fry Masala",
                    "url": "http://licious.in/masalas/chatpata-fish-fry-masala-pr_kjdlaqh7g54",
                    "deeplink": "type=product&productId=pr_kjdlaqh7g54",
                    "status": 1,
                    "created_at": "2022-12-01T06:56:38.000Z",
                    "updated_at": "2022-12-01T06:56:38.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_kjdlaqh7g54",
                    "product_slug": "chatpata-fish-fry-masala-pr_kjdlaqh7g54",
                    "cat_slug": "masalas"
                },
                {
                    "id": 246,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Classic Chicken Masala",
                    "url": "http://licious.in/masalas/classic-chicken-masala-pr_ncplaqh5mkw",
                    "deeplink": "type=product&productId=pr_ncplaqh5mkw",
                    "status": 1,
                    "created_at": "2022-12-01T07:14:52.000Z",
                    "updated_at": "2022-12-01T07:14:52.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_ncplaqh5mkw",
                    "product_slug": "classic-chicken-masala-pr_ncplaqh5mkw",
                    "cat_slug": "masalas"
                },
                {
                    "id": 247,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Asli Garam Masala",
                    "url": "http://licious.in/masalas/asli-garam-masala-pr_o2hlaqh0y11",
                    "deeplink": "type=product&productId=pr_o2hlaqh0y11",
                    "status": 1,
                    "created_at": "2022-12-08T10:09:05.000Z",
                    "updated_at": "2022-12-08T10:09:05.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_o2hlaqh0y11",
                    "product_slug": "asli-garam-masala-pr_o2hlaqh0y11",
                    "cat_slug": "masalas"
                },
                {
                    "id": 248,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Original Tandoori Chicken Masala",
                    "url": "http://licious.in/masalas/original-tandoori-chicken-masa-pr_ncplaqh1yxx",
                    "deeplink": "type=product&productId=pr_ncplaqh1yxx",
                    "status": 1,
                    "created_at": "2022-12-08T10:10:21.000Z",
                    "updated_at": "2022-12-08T10:10:21.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_ncplaqh1yxx",
                    "product_slug": "original-tandoori-chicken-masa-pr_ncplaqh1yxx",
                    "cat_slug": "masalas"
                },
                {
                    "id": 249,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Shandaar Butter Chicken Masala",
                    "url": "http://licious.in/masalas/shandaar-butter-chicken-masala-pr_o2hlaqh33oq",
                    "deeplink": "type=product&productId=pr_o2hlaqh33oq",
                    "status": 1,
                    "created_at": "2022-12-08T10:11:39.000Z",
                    "updated_at": "2022-12-08T10:11:39.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_o2hlaqh33oq",
                    "product_slug": "shandaar-butter-chicken-masala-pr_o2hlaqh33oq",
                    "cat_slug": "masalas"
                },
                {
                    "id": 250,
                    "city_id": 1,
                    "category": "Meat Masala",
                    "category_url": "https://www.licious.in/masalas",
                    "category_id": 297,
                    "product_name": "Khansama Biryani Masala",
                    "url": "http://licious.in/masalas/khansama-biryani-masala-pr_ggylaqh46m8",
                    "deeplink": "type=product&productId=pr_ggylaqh46m8",
                    "status": 1,
                    "created_at": "2022-12-08T10:16:29.000Z",
                    "updated_at": "2022-12-08T10:16:29.000Z",
                    "platform": "ALL",
                    "msite_product_url": "undefinedmeat masala/undefined",
                    "msite_category_url": "https://www.m.licious.in/masalas",
                    "product_id": "pr_ggylaqh46m8",
                    "product_slug": "khansama-biryani-masala-pr_ggylaqh46m8",
                    "cat_slug": "masalas"
                }
            ],
            "category_url": "https://www.licious.in/masalas",
            "msite_category_url": "https://www.m.licious.in/masalas"
        }
    ]
    
export  const productsList = [
  {
    cat_name :"Chicken",
    "subProductList" : [
      
        {
    variantId: 'pr_5785b9065d7e1',
    merchandiseName: 'Chicken Curry Cut - Small Pieces',
    slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '500',
      grossWeight: '526',
      pieces: '12-18',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '526 g'
      }
    },
    basePrice: 195,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 179,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
      productShortname: 'Chicken Curry Cut Small Pieces'
    }
  },
  {
    variantId: 'pr_3nqjtznab5c',
    merchandiseName: 'Chicken Breast - Boneless',
    slug: 'chicken-breast-boneless-pr_3nqjtznab5c',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '450',
      grossWeight: '600',
      pieces: '2-4',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '600 g'
      }
    },
    basePrice: 315,
    baseDiscount: 5,
    discountPercentage: 5,
    discountedPrice: 299,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/469c9ea4-4c1a-fe2a-0f2b-7dba03860c67/original/1716980533039.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/469c9ea4-4c1a-fe2a-0f2b-7dba03860c67/original/1716980533039.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/d7f6c192-6591-4894-fa08-f4fcaaeaa8d1/original/1716980541332.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/769c76bf-3a51-b837-46ae-c11b68e1e0cf/original/1716980546829.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/5d75d097-78ec-ec38-5a11-410e16bc331b/original/1716980551182.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Enjoy tender pieces of juicy chicken breast',
      productShortname: 'Chicken Breast Boneless'
    }
  },
  {
    variantId: 'pr_av4kgtb3l1h',
    merchandiseName: 'Chicken Curry Cut - Small Pieces (Large Pack)',
    slug: 'chicken-curry-cut-small---value-pack-pr_av4kgtb3l1h',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '1000',
      grossWeight: '1026',
      pieces: '24-36',
      uom: 'Weight',
      serves: '6',
      unit: 'g',
      displayWeight: {
        value: '1026 g'
      }
    },
    basePrice: 369,
    baseDiscount: 3,
    discountPercentage: 3,
    discountedPrice: 359,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/145d3e25-9567-e1a7-d7f6-acb4e55e9619/original/1716982461273.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/145d3e25-9567-e1a7-d7f6-acb4e55e9619/original/1716982461273.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/399361f8-6a3b-fc60-d9cb-c119cb2d019c/original/1716982469860.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/0cf060fe-ff61-a214-0afc-d11ad6149145/original/1716982475557.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/6ff0cb5e-b904-6039-e83a-e854a92f6aa8/original/1716982485092.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'The ideal pack for a big, delicious curry feast',
      productShortname: 'Chicken Curry Cut Small - Value Pack'
    }
  },
  {
    variantId: 'pr_57234c427648b',
    merchandiseName: 'Chicken Curry Cut - Large Pieces',
    slug: 'chicken-curry-cut-large---8-to-10-pieces-pr_57234c427648b',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '500',
      grossWeight: '526',
      pieces: '8-10',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '526 g'
      }
    },
    basePrice: 195,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 179,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/e5081d0b-8cc2-16f6-fb11-45c92d6810bd/original/1716983949511.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/e5081d0b-8cc2-16f6-fb11-45c92d6810bd/original/1716983949511.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/7cb94552-ac3c-2689-d701-e918012036b2/original/1716983957848.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/0b6068a0-b4df-3720-ec19-ef17087f7c61/original/1716983962607.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/6c4c9a37-8e96-0b72-ddc4-5239e20ffa3a/original/1716983966901.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Large bone-in & boneless pieces for a delicious curry',
      productShortname: 'Chicken Curry Cut Large Pieces'
    }
  },
  {
    variantId: 'pr_fmhkgtbdprx',
    merchandiseName: 'Chicken Breast Boneless (Large Pack)',
    slug: 'chicken-breast-boneless---large-pack-pr_fmhkgtbdprx',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '900',
      grossWeight: '1200',
      pieces: '4-6',
      uom: 'Weight',
      serves: '6',
      unit: 'g',
      displayWeight: {
        value: '1200 g'
      }
    },
    basePrice: 605,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 559,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/cb796609-f225-eb22-edb9-f5fd9366e114/original/1716980799212.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/cb796609-f225-eb22-edb9-f5fd9366e114/original/1716980799212.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/438128c7-cd50-08b0-5176-8829112f6109/original/1716980808128.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/cde3c5fc-fee3-8660-636b-375ab2e18645/original/1716980812514.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/d77b1d70-83e2-5db5-0a81-d66ea032d496/original/1716980816561.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Skinless, boneless pieces of juicy chicken breasts.',
      productShortname: 'Chicken Breast Boneless - Large Pack'
    }
  },
  {
    variantId: 'pr_avakgtb7ywh',
    merchandiseName: 'Chicken Curry Cut - Large Pieces (Large Pack)',
    slug: 'chicken-curry-cut-large---large-pack-pr_avakgtb7ywh',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '1000',
      grossWeight: '1026',
      pieces: '14-22',
      uom: 'Weight',
      serves: '6',
      unit: 'g',
      displayWeight: {
        value: '1026 g'
      }
    },
    basePrice: 369,
    baseDiscount: 3,
    discountPercentage: 3,
    discountedPrice: 359,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/3475a799-9d51-41c3-dd9c-efb9f811700c/original/1716984273022.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/3475a799-9d51-41c3-dd9c-efb9f811700c/original/1716984273022.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/0599bad3-2da6-10a0-7795-ed0238667d40/original/1716984286408.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/1ea4785f-15b7-a4bd-4946-0dbe41855b97/original/1716984290221.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/2281d833-dd61-7488-d884-405a2c918d0c/original/1716984294690.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Large bone-in & boneless pieces for a delicious curry',
      productShortname: 'Chicken Curry Cut Large - Large Pack'
    }
  },
  {
    variantId: 'pr_ffojtsk929c',
    merchandiseName: 'Oriental Basil Chicken',
    slug: 'chicken-basil-manchurian-pr_ffojtsk929c',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '225',
      grossWeight: '225',
      pieces: '10-14',
      uom: 'Weight',
      serves: '',
      unit: 'g',
      displayWeight: {
        value: '225 g'
      }
    },
    basePrice: 199,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 199,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/e577998c-0047-99fe-618f-eac464f14b64/original/1694168731995.jpg',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/e577998c-0047-99fe-618f-eac464f14b64/original/1694168731995.jpg',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/f917143d-81e9-c8f5-7b1c-d24a0a716091/original/1694168741988.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/53f0be03-526b-f0e7-d916-847cd1517800/original/1694168741682.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/09701363-cd95-fe6d-8f32-93522350a7b9/original/1694168742319.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/fca59112-3b7f-6be6-5294-19da51c26b06/original/1694168790080.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Boneless cubes of chicken in a manchurian marinade.',
      productShortname: 'Oriental Basil Chicken'
    }
  },
  {
    variantId: 'pr_fhijtqu0u5q',
    merchandiseName: 'Chicken Boneless - Mini Bites',
    slug: 'chicken-mini-bites---boneless-pr_fhijtqu0u5q',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '250',
      grossWeight: '350',
      pieces: '20-25',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '350 g'
      }
    },
    basePrice: 229,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 229,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/b1b27aed-5dd7-b09b-f2da-63e64aafb003/original/1716976077502.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/b1b27aed-5dd7-b09b-f2da-63e64aafb003/original/1716976077502.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/1dc1d00f-3b64-de1e-91ee-2a80651d0a17/original/1716976087923.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/3ba3a640-a453-1546-577e-ecb4e252eca0/original/1716976092310.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/bd93082d-a2c4-2618-1fd4-73c690435316/original/1716976097071.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy, tender goodness of Chicken in a mouthful',
      productShortname: 'Chicken Mini Bites - Boneless'
    }
  },
  {
    variantId: 'pr_3nqjtzosblz',
    merchandiseName: 'Premium Chicken Thigh Boneless',
    slug: 'chicken-thigh-boneless-pr_3nqjtzosblz',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '450',
      grossWeight: '565',
      pieces: '3-5',
      uom: 'Weight',
      serves: '5',
      unit: 'g',
      displayWeight: {
        value: '565 g'
      }
    },
    basePrice: 359,
    baseDiscount: 7,
    discountPercentage: 7,
    discountedPrice: 335,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/81388200-4572-512c-0588-b43ea15b1e69/original/1716974900400.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/81388200-4572-512c-0588-b43ea15b1e69/original/1716974900400.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/501f54e7-ead9-b024-7f92-b883c348f5e7/original/1716974909369.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/0f9ff001-207c-9989-7a6f-feb273dd7247/original/1716974913816.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/94e2da12-4d41-50fe-32e5-bfe066cf8230/original/1716974919223.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Meaty, tender boneless chicken thighs',
      productShortname: 'Chicken Thigh (Boneless)'
    }
  },
  {
    variantId: 'pr_fhijtzoq66l',
    merchandiseName: 'Chicken Mince (Keema)',
    slug: 'chicken-mince-keema-pr_fhijtzoq66l',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '450',
      grossWeight: '565',
      pieces: '',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '565 g'
      }
    },
    basePrice: 295,
    baseDiscount: 19,
    discountPercentage: 19,
    discountedPrice: 239,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/5d13ab9c-10b1-d606-e125-a6d487786bd1/original/1716976590734.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/5d13ab9c-10b1-d606-e125-a6d487786bd1/original/1716976590734.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/429b8bfa-9a0d-0c15-8078-c4b0cf242fef/original/1716976598917.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/21d7856f-1350-e63a-1ef4-1814db437c54/original/1716976605581.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/738a0f1c-1f4e-0bdd-2875-0f9b21571ebe/original/1716976608919.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'For mouth-watering meatballs, keema & more',
      productShortname: 'Chicken Mince/ Keema'
    }
  },
  {
    variantId: 'pr_4lal483r2ks',
    merchandiseName: 'Chicken Drumstick - Pack Of 6',
    slug: 'chicken-drumstick---pack-of-6-pr_4lal483r2ks',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '6',
      grossWeight: '',
      pieces: '6',
      uom: 'Pieces',
      serves: '2-3',
      unit: ''
    },
    basePrice: 319,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 295,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/5f9b176a-ea78-aab3-26b9-de69235c52f0/original/1716979586900.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/5f9b176a-ea78-aab3-26b9-de69235c52f0/original/1716979586900.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/17a10f2d-686e-1d51-5ab4-ff62e3a51ca5/original/1716979602116.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/99300ff6-09ac-f9a3-1d30-061b639968aa/original/1716979606758.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/55967e99-b074-e056-7d97-bd5fb0e78de1/original/1716979610899.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in chicken drumsticks, cut from the leg',
      productShortname: 'Chicken Drumstick - Pack Of 6'
    }
  },
  {
    variantId: 'pr_fagkepqge4h',
    merchandiseName: 'Chicken Liver',
    slug: 'chicken-liver-pr_fagkepqge4h',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '350',
      grossWeight: '354',
      pieces: '7-9',
      uom: 'Weight',
      serves: '2-3',
      unit: 'g',
      displayWeight: {
        value: '354 g'
      }
    },
    basePrice: 139,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 139,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/f4661810-07ff-85d0-18c4-3180146a9829/original/1710239870472.jpg',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/f4661810-07ff-85d0-18c4-3180146a9829/original/1710239870472.jpg',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/a93cf55e-b3c4-b6ca-23ba-0f782ec6cba2/original/1710239874728.jpg',
        'https://dao54xqhg9jfa.cloudfront.net/OMS-ProductMerchantdising/6e9a0375-3037-a545-1be5-34808bf4b69f/original/PDP_15._Chicken_Liver_Cooked.jpg',
        'https://dao54xqhg9jfa.cloudfront.net/OMS-ProductMerchantdising/71e41bef-c88a-ce88-0dc1-43cfd4f8be91/original/PDP_15._Chicken_Liver_KH_(1).jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Smooth, rich & meaty Chicken Liver',
      productShortname: 'Chicken Liver'
    }
  },
  {
    variantId: 'pr_3zxlai240t2',
    merchandiseName: 'Chicken Leg With Thigh - Pack of 3',
    slug: 'chicken-leg-with-thigh-pack-of-pr_3zxlai240t2',
    primaryTag: {
      name: 'New Price'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '3',
      grossWeight: '',
      pieces: '3',
      uom: 'Pieces',
      serves: '2-3',
      unit: ''
    },
    basePrice: 289,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 289,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/7fd6c72f-7342-89d6-a880-0069e0b5b024/original/1716977103040.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/7fd6c72f-7342-89d6-a880-0069e0b5b024/original/1716977103040.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/a0cd52f4-673b-3cd0-db39-3025558eeb87/original/1716977113406.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/f26f8d3f-67fd-25bd-c4c9-2146a460e344/original/1716977117887.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/3f918d47-4bf9-84ec-3658-e4e61d964d41/original/1716977121795.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in leg pieces for delicious Curries or Biryanis',
      productShortname: 'Chicken Leg With Thigh - Pack of 3'
    }
  },
  {
    variantId: 'pr_fhijtgw0ctk',
    merchandiseName: 'Classic Chicken Soup Bones ',
    slug: 'chicken-soup-bones---classic-pr_fhijtgw0ctk',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '250',
      grossWeight: '250',
      pieces: '11-12',
      uom: 'Weight',
      serves: '',
      unit: 'g',
      displayWeight: {
        value: '250 g'
      }
    },
    basePrice: 75,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 75,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/b375e9c0-c196-3f43-f289-c6aeab6f5f9b/original/1709004209467.jpg',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/b375e9c0-c196-3f43-f289-c6aeab6f5f9b/original/1709004209467.jpg',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/12284840-bc72-b5d5-3502-c2a70deb0af6/original/1709004211209.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/e7a2a89b-d18a-5469-faef-74a6b1718a8c/original/1706685198966.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/3bc4ac5c-3cd5-37de-b036-045bb2d52d56/original/1709004213093.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/ead1f63a-b0ff-5a6f-c4ca-e7ea32cee22a/original/1706153619553.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Cleaned chicken bones for a delicious, flavourful stock',
      productShortname: 'Chicken Soup Bones - (Classic)'
    }
  },
  {
    variantId: 'pr_fsglbgf2hjy',
    merchandiseName: 'Chicken Drumsticks - Pack of 2 (Mini Pack)',
    slug: 'chicken-drumsticks-pack-of-2-m-pr_fsglbgf2hjy',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '2',
      grossWeight: '',
      pieces: '2',
      uom: 'Pieces',
      serves: '1-2',
      unit: ''
    },
    basePrice: 129,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 129,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/24bfdd2d-8704-59b8-9391-76487a693739/original/1716979317432.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/24bfdd2d-8704-59b8-9391-76487a693739/original/1716979317432.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/f30f8735-63c9-e27f-2fc3-ea3c381e51e1/original/1716979330227.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/32459280-12fa-cee3-89eb-1b20d86782ea/original/1716979335351.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/e67abb3f-d695-7f00-3c4a-ccae60c54d19/original/1716979339709.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in chicken drumsticks, cut from the leg',
      productShortname: 'Chicken Drumsticks - Pack of 2 (Mini Pack)'
    }
  },
  {
    variantId: 'pr_hn6k8alrcck',
    merchandiseName: 'Tender Spring Chicken Curry Cut',
    slug: 'tender-spring-chicken-curry-cut-pr_hn6k8alrcck',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '800',
      grossWeight: '841',
      pieces: '14-16',
      uom: 'Weight',
      serves: '5-6',
      unit: 'g',
      displayWeight: {
        value: '841 g'
      }
    },
    basePrice: 335,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 335,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/2277047e-057b-71d5-75bd-9290e6bbb1a5/original/1716965939982.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/2277047e-057b-71d5-75bd-9290e6bbb1a5/original/1716965939982.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/d6e1a0e1-fd83-3e29-8b9b-cfa1d16b69e4/original/1716966078302.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/e082d854-7045-fd74-ae62-799b4e824f0f/original/1716966082304.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/8bc68bdb-3d57-7ea6-e145-4509b50435aa/original/1716966085922.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy, tender cuts from a whole spring chicken',
      productShortname: 'Tender Spring Chicken Curry Cut'
    }
  },
  {
    variantId: 'pr_1lo6wcszh',
    merchandiseName: 'Crispy Chicken Nuggets',
    slug: 'crispy-chicken-nuggets-pr_1lo6wcszh',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '250',
      grossWeight: '250',
      pieces: '12',
      uom: 'Weight',
      serves: '3-4',
      unit: 'g',
      displayWeight: {
        value: '250 g'
      }
    },
    basePrice: 169,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 169,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/9ceaef7d-474b-28f5-491d-fb54cc03b331/original/1699617497323.jpg',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/9ceaef7d-474b-28f5-491d-fb54cc03b331/original/1699617497323.jpg',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/b48077f3-7ea6-37b0-bd2c-194a470047aa/original/1700029082953.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/5f0d9872-1113-4fbb-d7ad-d2443992a780/original/1700029085741.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/984e80c8-27cd-264f-259f-79a18265d764/original/1700029088697.jpeg',
        'https://assets.licious.in/OMS-ProductMerchantdising/59d27417-6983-c14c-cd2e-3986db48d819/original/1700029091107.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Premium cuts of chicken minced & coated in breadcrumbs',
      productShortname: 'Crispy Chicken Nuggets'
    }
  },
  {
    variantId: 'pr_2j9jxbzk1cl',
    merchandiseName: 'Premium Chicken Leg Curry Cut',
    slug: 'chicken-leg-curry-cut-large---4-pieces-pr_2j9jxbzk1cl',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '300',
      grossWeight: '400',
      pieces: '4-6',
      uom: 'Weight',
      serves: '2-3',
      unit: 'g',
      displayWeight: {
        value: '400 g'
      }
    },
    basePrice: 225,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 225,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/8f0010f9-dd3f-c396-c438-f2201c7b0ac8/original/1716978387321.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/8f0010f9-dd3f-c396-c438-f2201c7b0ac8/original/1716978387321.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/3bb60b6c-f2cf-e325-38cb-1ac44b714864/original/1716978395400.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/064a995f-c1d2-4775-e219-138406aaa38e/original/1716978400153.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/c7c143bc-cb0b-1a45-4388-033e8963d271/original/1716978404374.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in leg pieces for delicious Curries or Biryanis',
      productShortname: 'Chicken Leg Curry Cut (Large - 4 pieces)'
    }
  },
  {
    variantId: 'pr_59a6c5c60df4b',
    merchandiseName: 'Chicken Curry Cut with Skin - Small Pieces',
    slug: 'chicken-curry-cut-with-skin-small---12-to-14-pieces-pr_59a6c5c60df4b',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '500',
      grossWeight: '526',
      pieces: '12-14',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '526 g'
      }
    },
    basePrice: 175,
    baseDiscount: 0,
    discountPercentage: 0,
    discountedPrice: 175,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/b837226a-4ec4-6390-908b-996c5bbf5b38/original/1716981276644.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/b837226a-4ec4-6390-908b-996c5bbf5b38/original/1716981276644.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/74c1f98c-e6b7-eeae-34bc-a2e2be3c47f0/original/1716981292858.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/7bd9f248-4052-78be-7db4-924d0d14fd58/original/1716981298878.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/977a6ea0-146e-cf98-a25e-780ca37bb5f1/original/1716981303406.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'A pop of flavour with skin-on chicken cuts',
      productShortname: 'Chicken Curry Cut with Skin (Small - 12 to 14 Pieces)'
    }
  },
  {
    variantId: 'pr_8smkrx2ly4g',
    merchandiseName: 'Creamy Afghani Chicken (Mini)',
    slug: 'half---creamy-afghani-chicken-pr_8smkrx2ly4g',
    isCombo: 0,
    weightAndPieces: {
      netWeight: '225',
      grossWeight: '225',
      pieces: '7-9',
      uom: 'Weight',
      serves: '',
      unit: 'g',
      displayWeight: {
        value: '225 g'
      }
    },
    basePrice: 199,
    baseDiscount: 10,
    discountPercentage: 10,
    discountedPrice: 179,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/e32f4b28-be15-d724-5922-7a56b8c2f48f/original/1702714733820.jpg',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/e32f4b28-be15-d724-5922-7a56b8c2f48f/original/1702714733820.jpg',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/62e0f488-39c8-9c37-431f-0ea1f3f1c29b/original/1702714742839.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/649a7ab4-7fda-c74c-5572-dece1b64f795/original/1702714747755.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/adee7b62-58b9-f147-9caf-69f308155bd4/original/1702714748318.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/7c7d1ed4-972b-bb22-e045-62e615a700c5/original/1702894081383.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'A comforting meaty treat for your everyday meals',
      productShortname: 'Half - Creamy Afghani Chicken'
    }
  }
]
},
{
   "cat_name": "Ready to cook",
  "subProductList": [    
    {
    variantId: 'pr_5785b9065d7e11',
    merchandiseName: 'Chicken Curry Cut - Small Pieces',
    slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '500',
      grossWeight: '526',
      pieces: '12-18',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '526 g'
      }
    },
    basePrice: 195,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 179,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
      productShortname: 'Chicken Curry Cut Small Pieces'
    }
  },
  {
    variantId: 'pr_5785b9065d7e12',
    merchandiseName: 'Chicken Curry Cut - Small Pieces',
    slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '500',
      grossWeight: '526',
      pieces: '12-18',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '526 g'
      }
    },
    basePrice: 195,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 179,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
      productShortname: 'Chicken Curry Cut Small Pieces'
    }
  },
  {
    variantId: 'pr_5785b9065d7e13',
    merchandiseName: 'Chicken Curry Cut - Small Pieces',
    slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
    primaryTag: {
      name: 'NA'
    },
    isCombo: 0,
    weightAndPieces: {
      netWeight: '500',
      grossWeight: '526',
      pieces: '12-18',
      uom: 'Weight',
      serves: '4',
      unit: 'g',
      displayWeight: {
        value: '526 g'
      }
    },
    basePrice: 195,
    baseDiscount: 8,
    discountPercentage: 8,
    discountedPrice: 179,
    nextAvailableBy: 'Today in 90 mins',
    hasAddOns: true,
    deliveryType: 'EXPRESS',
    media: {
      prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
      images: [
        'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
        'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
        'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
      ]
    },
    productDescriptors: {
      uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
      productShortname: 'Chicken Curry Cut Small Pieces'
    }
  }
]

},
{
    "cat_name": "Fish & Seafood",
   "subProductList": [    
     {
     variantId: 'pr_5785b9065d7e0',
     merchandiseName: 'Chicken Curry Cut - Small Pieces',
     slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
     primaryTag: {
       name: 'NA'
     },
     isCombo: 0,
     weightAndPieces: {
       netWeight: '500',
       grossWeight: '526',
       pieces: '12-18',
       uom: 'Weight',
       serves: '4',
       unit: 'g',
       displayWeight: {
         value: '526 g'
       }
     },
     basePrice: 195,
     baseDiscount: 8,
     discountPercentage: 8,
     discountedPrice: 179,
     nextAvailableBy: 'Today in 90 mins',
     hasAddOns: true,
     deliveryType: 'EXPRESS',
     media: {
       prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       images: [
         'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
         'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
         'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
       ]
     },
     productDescriptors: {
       uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
       productShortname: 'Chicken Curry Cut Small Pieces'
     }
   },
   {
     variantId: 'pr_5785b9065d7e1',
     merchandiseName: 'Chicken Curry Cut - Small Pieces',
     slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
     primaryTag: {
       name: 'NA'
     },
     isCombo: 0,
     weightAndPieces: {
       netWeight: '500',
       grossWeight: '526',
       pieces: '12-18',
       uom: 'Weight',
       serves: '4',
       unit: 'g',
       displayWeight: {
         value: '526 g'
       }
     },
     basePrice: 195,
     baseDiscount: 8,
     discountPercentage: 8,
     discountedPrice: 179,
     nextAvailableBy: 'Today in 90 mins',
     hasAddOns: true,
     deliveryType: 'EXPRESS',
     media: {
       prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       images: [
         'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
         'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
         'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
       ]
     },
     productDescriptors: {
       uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
       productShortname: 'Chicken Curry Cut Small Pieces'
     }
   },
   {
     variantId: 'pr_5785b9065d7e2',
     merchandiseName: 'Chicken Curry Cut - Small Pieces',
     slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
     primaryTag: {
       name: 'NA'
     },
     isCombo: 0,
     weightAndPieces: {
       netWeight: '500',
       grossWeight: '526',
       pieces: '12-18',
       uom: 'Weight',
       serves: '4',
       unit: 'g',
       displayWeight: {
         value: '526 g'
       }
     },
     basePrice: 195,
     baseDiscount: 8,
     discountPercentage: 8,
     discountedPrice: 179,
     nextAvailableBy: 'Today in 90 mins',
     hasAddOns: true,
     deliveryType: 'EXPRESS',
     media: {
       prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       images: [
         'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
         'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
         'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
       ]
     },
     productDescriptors: {
       uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
       productShortname: 'Chicken Curry Cut Small Pieces'
     }
   }
 ]

 },
 {
   cat_name:"Mutton",
   "subProductList": [    
     {
     variantId: 'pr_5785b9065d7A1',
     merchandiseName: 'Chicken Curry Cut - Small Pieces',
     slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
     primaryTag: {
       name: 'NA'
     },
     isCombo: 0,
     weightAndPieces: {
       netWeight: '500',
       grossWeight: '526',
       pieces: '12-18',
       uom: 'Weight',
       serves: '4',
       unit: 'g',
       displayWeight: {
         value: '526 g'
       }
     },
     basePrice: 195,
     baseDiscount: 8,
     discountPercentage: 8,
     discountedPrice: 179,
     nextAvailableBy: 'Today in 90 mins',
     hasAddOns: true,
     deliveryType: 'EXPRESS',
     media: {
       prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       images: [
         'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
         'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
         'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
       ]
     },
     productDescriptors: {
       uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
       productShortname: 'Chicken Curry Cut Small Pieces'
     }
   },
   {
     variantId: 'pr_5785b9065d7B2',
     merchandiseName: 'Chicken Curry Cut - Small Pieces',
     slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
     primaryTag: {
       name: 'NA'
     },
     isCombo: 0,
     weightAndPieces: {
       netWeight: '500',
       grossWeight: '526',
       pieces: '12-18',
       uom: 'Weight',
       serves: '4',
       unit: 'g',
       displayWeight: {
         value: '526 g'
       }
     },
     basePrice: 195,
     baseDiscount: 8,
     discountPercentage: 8,
     discountedPrice: 179,
     nextAvailableBy: 'Today in 90 mins',
     hasAddOns: true,
     deliveryType: 'EXPRESS',
     media: {
       prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       images: [
         'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
         'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
         'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
       ]
     },
     productDescriptors: {
       uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
       productShortname: 'Chicken Curry Cut Small Pieces'
     }
   },
   {
     variantId: 'pr_5785b9065d7B3',
     merchandiseName: 'Chicken Curry Cut - Small Pieces',
     slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
     primaryTag: {
       name: 'NA'
     },
     isCombo: 0,
     weightAndPieces: {
       netWeight: '500',
       grossWeight: '526',
       pieces: '12-18',
       uom: 'Weight',
       serves: '4',
       unit: 'g',
       displayWeight: {
         value: '526 g'
       }
     },
     basePrice: 195,
     baseDiscount: 8,
     discountPercentage: 8,
     discountedPrice: 179,
     nextAvailableBy: 'Today in 90 mins',
     hasAddOns: true,
     deliveryType: 'EXPRESS',
     media: {
       prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
       images: [
         'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
         'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
         'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
       ]
     },
     productDescriptors: {
       uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
       productShortname: 'Chicken Curry Cut Small Pieces'
     }
   }
 ]

 },
 {
    "cat_name": "Liver & More",
    "subProductList": [    
      {
      variantId: 'pr_5785b9065d7A12',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7B23',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7B34',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    }
  ]

  },
  {
    "cat_name":"Prawns & Crabs",
    "subProductList": [    
      {
      variantId: 'pr_5785b9065d7AB12',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB23',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB34',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    }
  ]

  },
  {
    
    "cat_name": "Eggs",
    "subProductList": [    
      {
      variantId: 'pr_5785b9065d7AB12',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB23',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB34',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    }
  ]

  },
  {
    
    "cat_name":" Crispy Snacks",
    "subProductList": [    
      {
      variantId: 'pr_5785b9065d7AB12',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB23',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB34',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    }
  ]

  },
  {
    
    "cat_name":"Kebab & Biryani",
    "subProductList": [    
      {
      variantId: 'pr_5785b9065d7AB12',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB23',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    },
    {
      variantId: 'pr_5785b9065d7AB34',
      merchandiseName: 'Chicken Curry Cut - Small Pieces',
      slug: 'chicken-curry-cut-small---13-to-16-pieces-pr_5785b9065d7e1',
      primaryTag: {
        name: 'NA'
      },
      isCombo: 0,
      weightAndPieces: {
        netWeight: '500',
        grossWeight: '526',
        pieces: '12-18',
        uom: 'Weight',
        serves: '4',
        unit: 'g',
        displayWeight: {
          value: '526 g'
        }
      },
      basePrice: 195,
      baseDiscount: 8,
      discountPercentage: 8,
      discountedPrice: 179,
      nextAvailableBy: 'Today in 90 mins',
      hasAddOns: true,
      deliveryType: 'EXPRESS',
      media: {
        prImage: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        thumbnail: 'https://assets.licious.in/OMS-ProductMerchantdising/6fc425d4-2c62-058c-9718-64a2a92161c5/original/1716979971362.png',
        images: [
          'https://assets.licious.in/OMS-ProductMerchantdising/911b5f6f-183f-57ad-a490-09e54e0a632b/original/1716979980129.png',
          'https://assets.licious.in/OMS-ProductMerchantdising/892fc432-9459-ab90-1217-e6833d011b45/original/1716979985392.jpg',
          'https://assets.licious.in/OMS-ProductMerchantdising/ab6cf7d2-f0d1-86b1-6d4a-4abe0f492bb8/original/1716979989683.jpg'
        ]
      },
      productDescriptors: {
        uspDescription: 'Juicy bone-in & boneless chicken for delectable curries',
        productShortname: 'Chicken Curry Cut Small Pieces'
      }
    }
  ]

  }
]



        
 
